export type Maybe<T> = T | null;
export type InputMaybe<T> = undefined | T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  JSON: any;
};

export enum AccountType {
  Customer = 'CUSTOMER',
  Demo = 'DEMO',
  Prospect = 'PROSPECT'
}

export type ActivitiesResult = {
  __typename?: 'ActivitiesResult';
  items: Array<Activity>;
  metadata: PaginationMetadata;
};

export type Activity = {
  __typename?: 'Activity';
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['ID']>;
  championId?: Maybe<Scalars['ID']>;
  cohortFacilityIds?: Maybe<Array<Scalars['String']>>;
  comments?: Maybe<Array<Comment>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<ActivityDocument>>;
  executionPlan: ExecutionPlanType;
  id: Scalars['ID'];
  inputs?: Maybe<Array<Maybe<ActivityUserInput>>>;
  job?: Maybe<Job>;
  jobId?: Maybe<Scalars['ID']>;
  logs?: Maybe<Array<ActivityLog>>;
  nonChampionIds?: Maybe<Array<Scalars['String']>>;
  notes?: Maybe<Scalars['String']>;
  output?: Maybe<Scalars['JSON']>;
  payments?: Maybe<Array<Payment>>;
  reportDetailsExtended?: Maybe<Scalars['JSON']>;
  status: ActivityStatus;
  type: ActivityType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow: Workflow;
};

export type ActivityDocument = {
  __typename?: 'ActivityDocument';
  activity: Activity;
  activityId: Scalars['ID'];
  document: Document;
  documentId: Scalars['ID'];
};

export type ActivityInput = {
  assigneeId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  executionPlan?: InputMaybe<ExecutionPlanType>;
  input?: InputMaybe<Scalars['JSON']>;
  message?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ActivityStatus>;
  type?: InputMaybe<ActivityType>;
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  activityId: Scalars['ID'];
  errorType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  stackTrace?: Maybe<Scalars['String']>;
  status: ActivityStatus;
  time?: Maybe<Scalars['DateTime']>;
};

export type ActivityOutput = {
  __typename?: 'ActivityOutput';
  records?: Maybe<Array<ActivityRecord>>;
};

export type ActivityRecord = {
  __typename?: 'ActivityRecord';
  associatedDocumentId?: Maybe<Scalars['String']>;
  at: Scalars['DateTime'];
  key: Scalars['String'];
  kind: ActivityRecordKind;
  name: Scalars['String'];
};

export enum ActivityRecordKind {
  AstDocumentation = 'AST_DOCUMENTATION',
  DikeDescription = 'DIKE_DESCRIPTION',
  EmergencyResponsePlan = 'EMERGENCY_RESPONSE_PLAN',
  HazardousMaterialsInventoryStatement = 'HAZARDOUS_MATERIALS_INVENTORY_STATEMENT',
  HazardousMaterialsManagementPlan = 'HAZARDOUS_MATERIALS_MANAGEMENT_PLAN',
  Invoice = 'INVOICE',
  Other = 'OTHER',
  Receipt = 'RECEIPT',
  ReferenceImage = 'REFERENCE_IMAGE',
  Report = 'REPORT',
  SafeguardMeasures = 'SAFEGUARD_MEASURES',
  Screenshot = 'SCREENSHOT',
  Sds = 'SDS',
  SiteCoordinateAbbreviation = 'SITE_COORDINATE_ABBREVIATION',
  SitePlan = 'SITE_PLAN',
  TrainingPlan = 'TRAINING_PLAN',
  UstDocumentation = 'UST_DOCUMENTATION'
}

export type ActivitySafeToResetResponse = {
  __typename?: 'ActivitySafeToResetResponse';
  activity?: Maybe<Activity>;
  isSafeToReset: Scalars['Boolean'];
};

export enum ActivityStatus {
  Canceled = 'Canceled',
  Completed = 'Completed',
  Error = 'Error',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
  Queued = 'Queued',
  StaffCompleted = 'StaffCompleted'
}

export enum ActivityType {
  AddDocument = 'AddDocument',
  CollectEvidence = 'CollectEvidence',
  CollectEvidenceOfCompletion = 'CollectEvidenceOfCompletion',
  CreatePdf = 'CreatePdf',
  CreateZip = 'CreateZip',
  FillPdf = 'FillPdf',
  Geppetto = 'Geppetto',
  Lob = 'Lob',
  Presubmission = 'Presubmission',
  SendEmail = 'SendEmail',
  SignReportPages = 'SignReportPages',
  Staff = 'Staff',
  Tier2Submit = 'Tier2Submit',
  Tier2SubmitValidation = 'Tier2SubmitValidation',
  WaitForAllAltIdReports = 'WaitForAllAltIdReports',
  WaitForAllCnReports = 'WaitForAllCNReports',
  WaitForAllCredentialReports = 'WaitForAllCredentialReports',
  WaitForAllFd = 'WaitForAllFD',
  WaitForAllLepc = 'WaitForAllLEPC',
  WaitForAllStateReports = 'WaitForAllStateReports'
}

export type ActivityUserInput = {
  __typename?: 'ActivityUserInput';
  activityId: Scalars['ID'];
  id: Scalars['ID'];
  label: Scalars['String'];
  required: Scalars['Boolean'];
  shortName: Scalars['String'];
  type: ActivityUserInputType;
  value?: Maybe<Scalars['String']>;
};

export enum ActivityUserInputType {
  Boolean = 'Boolean'
}

export enum AgencyTypeCode {
  Contractor = 'CONTRACTOR',
  County = 'COUNTY',
  EpaContractor = 'EPA_CONTRACTOR',
  Interstate = 'INTERSTATE',
  Local = 'LOCAL',
  Municipal = 'MUNICIPAL',
  Other = 'OTHER',
  OtherEpa = 'OTHER_EPA',
  OtherFederal = 'OTHER_FEDERAL',
  OtherState = 'OTHER_STATE',
  Regional = 'REGIONAL',
  SeniorEnvironmentalEmploymentSeeInspector = 'SENIOR_ENVIRONMENTAL_EMPLOYMENT_SEE_INSPECTOR',
  State = 'STATE',
  StateContractor = 'STATE_CONTRACTOR',
  Tribal = 'TRIBAL',
  UnknownFromConversion = 'UNKNOWN_FROM_CONVERSION',
  UsEpa = 'US_EPA'
}

export type AllWasteByMonth = {
  __typename?: 'AllWasteByMonth';
  hazardous: Scalars['Float'];
  month: Scalars['Date'];
  nonHazardous: Scalars['Float'];
  universal: Scalars['Float'];
};

export type AllWasteShipmentsByFacility = {
  __typename?: 'AllWasteShipmentsByFacility';
  byMonth: Array<AllWasteByMonth>;
  totalHazardousAmount: Scalars['Float'];
  totalNonHazardousAmount: Scalars['Float'];
  totalUniversalAmount: Scalars['Float'];
};

export type AlternateId = {
  __typename?: 'AlternateId';
  expiresAt?: Maybe<Scalars['Date']>;
  hasNoId: Scalars['Boolean'];
  id: Scalars['ID'];
  type: Scalars['String'];
  value: Scalars['String'];
};

export type AlternateIdInput = {
  expiresAt?: InputMaybe<Scalars['Date']>;
  hasNoId?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  type: Scalars['String'];
  value: Scalars['String'];
};

export type AmountWithUnit = {
  __typename?: 'AmountWithUnit';
  amount?: Maybe<Scalars['Float']>;
  amountCode?: Maybe<Scalars['Int']>;
  unit?: Maybe<UnitType>;
};

export enum AssignmentType {
  Assignee = 'ASSIGNEE',
  Reviewer = 'REVIEWER'
}

export type BulkCopyInventoryResult = {
  __typename?: 'BulkCopyInventoryResult';
  failed: Array<CopyFacilityInventoryResult>;
  skipped: Array<CopyFacilityInventoryResult>;
  succeeded: Array<CopyFacilityInventoryResult>;
};

export type BulkUpdateNotReportingReasonResult = {
  __typename?: 'BulkUpdateNotReportingReasonResult';
  succeeded?: Maybe<Scalars['Boolean']>;
};

export type BulkVerifyAndSubmitReportsResult = {
  __typename?: 'BulkVerifyAndSubmitReportsResult';
  succeeded: Scalars['Boolean'];
};

export type CheckForFileResult = {
  __typename?: 'CheckForFileResult';
  exists: Scalars['Boolean'];
  signedUrl?: Maybe<Scalars['String']>;
};

export type Chemical = {
  __typename?: 'Chemical';
  alternateId?: Maybe<Scalars['String']>;
  associatedFacilities: Array<Facility>;
  casNumber?: Maybe<Scalars['String']>;
  chemicalTenants?: Maybe<Array<ChemicalTenant>>;
  components?: Maybe<Array<ChemicalComponent>>;
  createdAt: Scalars['DateTime'];
  createdAtViaMerge?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  density?: Maybe<Scalars['Float']>;
  densityUnits?: Maybe<DensityUnits>;
  documents?: Maybe<Array<ChemicalDocument>>;
  ehsForm?: Maybe<EhsForm>;
  extensions: ExtensionsByProgramArea;
  facilityChemicalMeasurementCount?: Maybe<Scalars['Int']>;
  facilityChemicalMeasurementMaxAmount?: Maybe<AmountWithUnit>;
  facilityChemicalStateFields?: Maybe<Array<FacilityChemicalStateField>>;
  facilityChemicals?: Maybe<Array<FacilityChemical>>;
  healthHazards: Array<HealthHazard>;
  id: Scalars['ID'];
  ifcHazards: Array<InternationalFireCodeHazard>;
  isEhs: Scalars['Boolean'];
  isTradeSecret: Scalars['Boolean'];
  issueCount?: Maybe<Scalars['Int']>;
  issues: Array<Issue>;
  manufacturerSupplier?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  needsReview: Scalars['Boolean'];
  noCasNumber?: Maybe<Scalars['Boolean']>;
  noHazardsNotReporting?: Maybe<Scalars['Boolean']>;
  oregonHazards: Array<OregonHazard>;
  physicalHazards: Array<PhysicalHazard>;
  pureOrMixture?: Maybe<PureOrMixture>;
  recommendedUse?: Maybe<Scalars['String']>;
  revisionDate?: Maybe<Scalars['Date']>;
  stateFields?: Maybe<Array<DynamicField>>;
  stateOfMatter: Array<StateOfMatter>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
  verifiedAt?: Maybe<Scalars['DateTime']>;
  verifiedBy?: Maybe<Scalars['String']>;
  verifier?: Maybe<User>;
  version?: Maybe<Scalars['String']>;
};


export type ChemicalFacilityChemicalMeasurementCountArgs = {
  facilityId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};


export type ChemicalFacilityChemicalMeasurementMaxAmountArgs = {
  facilityId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};


export type ChemicalFacilityChemicalsArgs = {
  facilityId?: InputMaybe<Scalars['ID']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
};

export type ChemicalAnomaliesResult = {
  __typename?: 'ChemicalAnomaliesResult';
  count: Scalars['Int'];
  items: Array<ChemicalAnomaly>;
};

export type ChemicalAnomaly = {
  __typename?: 'ChemicalAnomaly';
  chemicalId: Scalars['ID'];
  chemicalName: Scalars['String'];
  currentYearMaxAmount?: Maybe<Scalars['Float']>;
  currentYearReportId?: Maybe<Scalars['ID']>;
  currentYearUnit?: Maybe<UnitType>;
  facilityId: Scalars['ID'];
  facilityName: Scalars['String'];
  previousYearMaxAmount?: Maybe<Scalars['Float']>;
  previousYearReportId?: Maybe<Scalars['ID']>;
  previousYearUnit?: Maybe<UnitType>;
};

export type ChemicalComponent = {
  __typename?: 'ChemicalComponent';
  casNumber?: Maybe<Scalars['String']>;
  chemical: Chemical;
  chemicalId: Scalars['ID'];
  componentPercentage?: Maybe<Scalars['Float']>;
  ehsForm?: Maybe<EhsForm>;
  id: Scalars['ID'];
  isEhs: Scalars['Boolean'];
  name: Scalars['String'];
  noCasNumber?: Maybe<Scalars['Boolean']>;
  weightOrVolume?: Maybe<WeightOrVolume>;
};

export type ChemicalComponentInput = {
  casNumber?: InputMaybe<Scalars['String']>;
  componentPercentage?: InputMaybe<Scalars['Float']>;
  ehsForm?: InputMaybe<EhsForm>;
  id: Scalars['ID'];
  isEhs?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  noCasNumber?: InputMaybe<Scalars['Boolean']>;
  weightOrVolume?: InputMaybe<WeightOrVolume>;
};

export type ChemicalDocument = {
  __typename?: 'ChemicalDocument';
  chemical: Chemical;
  chemicalId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  document: Document;
  documentId: Scalars['String'];
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type ChemicalDocumentInput = {
  chemicalId?: InputMaybe<Scalars['ID']>;
  document: DocumentInput;
  documentId: Scalars['String'];
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
};

export type ChemicalInput = {
  alternateId?: InputMaybe<Scalars['String']>;
  casNumber?: InputMaybe<Scalars['String']>;
  components?: InputMaybe<Array<ChemicalComponentInput>>;
  createdAtViaMerge?: InputMaybe<Scalars['String']>;
  density?: InputMaybe<Scalars['Float']>;
  densityUnits?: InputMaybe<DensityUnits>;
  documents?: InputMaybe<Array<ChemicalDocumentInput>>;
  ehsForm?: InputMaybe<EhsForm>;
  healthHazards?: InputMaybe<Array<HealthHazard>>;
  ifcHazards?: InputMaybe<Array<InternationalFireCodeHazard>>;
  isEhs?: InputMaybe<Scalars['Boolean']>;
  isTradeSecret?: InputMaybe<Scalars['Boolean']>;
  manufacturerSupplier?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  needsReview?: InputMaybe<Scalars['Boolean']>;
  noCasNumber?: InputMaybe<Scalars['Boolean']>;
  noHazardsNotReporting?: InputMaybe<Scalars['Boolean']>;
  oregonHazards?: InputMaybe<Array<OregonHazard>>;
  physicalHazards?: InputMaybe<Array<PhysicalHazard>>;
  pureOrMixture?: InputMaybe<PureOrMixture>;
  recommendedUse?: InputMaybe<Scalars['String']>;
  revisionDate?: InputMaybe<Scalars['DateTime']>;
  stateFields?: InputMaybe<Array<DynamicFieldInput>>;
  stateOfMatter?: InputMaybe<Array<StateOfMatter>>;
  tenantIds?: InputMaybe<Array<Scalars['ID']>>;
  verifiedAt?: InputMaybe<Scalars['DateTime']>;
  verifiedBy?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['String']>;
};

export type ChemicalMeasurementSummary = {
  __typename?: 'ChemicalMeasurementSummary';
  alternateId?: Maybe<Scalars['String']>;
  casNumber?: Maybe<Scalars['String']>;
  components?: Maybe<Array<ChemicalComponent>>;
  hasCarryOver?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isEhs?: Maybe<Scalars['Boolean']>;
  issues: Array<Issue>;
  maxAmount?: Maybe<AmountWithUnit>;
  name: Scalars['String'];
  pureOrMixture?: Maybe<PureOrMixture>;
  totalMeasurements?: Maybe<Scalars['Int']>;
};

export type ChemicalOverviewFilter = {
  assignedToMe?: InputMaybe<Scalars['Boolean']>;
  reportKind?: InputMaybe<TierIiReportKind>;
  tagNames?: InputMaybe<Array<Scalars['String']>>;
};

export type ChemicalStateField = {
  __typename?: 'ChemicalStateField';
  chemical: Chemical;
  chemicalId: Scalars['ID'];
  id: Scalars['ID'];
  jurisdiction: Scalars['String'];
  key: Scalars['String'];
  type: ProgramArea;
  value: Scalars['JSON'];
};

export type ChemicalTenant = {
  __typename?: 'ChemicalTenant';
  chemical: Chemical;
  chemicalId: Scalars['ID'];
  id: Scalars['ID'];
  tenant: Tenant;
  tenantId: Scalars['String'];
};

export type ChemicalWithAssociatedData = {
  __typename?: 'ChemicalWithAssociatedData';
  chemical: Chemical;
  jurisdictions: Array<Scalars['String']>;
};

export type ChemicalsOverviewMyProgressResult = {
  __typename?: 'ChemicalsOverviewMyProgressResult';
  dueDate: Scalars['String'];
  reportsRemaining: Scalars['Int'];
  reportsTotal: Scalars['Int'];
};

export type ChemicalsResult = {
  __typename?: 'ChemicalsResult';
  count: Scalars['Int'];
  items: Array<Chemical>;
};

export enum CollectEvidenceOfCompletionActions {
  ChemicalCount = 'chemicalCount',
  Completion = 'completion'
}

export enum CollectionMode {
  Aggregate = 'AGGREGATE',
  AggregateDefaulted = 'AGGREGATE_DEFAULTED',
  Measurement = 'MEASUREMENT',
  MeasurementDefaulted = 'MEASUREMENT_DEFAULTED'
}

export type Comment = {
  __typename?: 'Comment';
  activity?: Maybe<Activity>;
  activityId?: Maybe<Scalars['ID']>;
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  report?: Maybe<TierIiReport>;
  reportId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  workflow?: Maybe<Workflow>;
  workflowId?: Maybe<Scalars['ID']>;
};

export type CommentInput = {
  activityId?: InputMaybe<Scalars['ID']>;
  comment: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  reportId?: InputMaybe<Scalars['ID']>;
  workflowId?: InputMaybe<Scalars['ID']>;
};

export enum ContactReportRole {
  EpcraBilling = 'EPCRA_BILLING',
  EpcraCaOperator = 'EPCRA_CA_OPERATOR',
  EpcraCaOwner = 'EPCRA_CA_OWNER',
  EpcraCaPropertyOwner = 'EPCRA_CA_PROPERTY_OWNER',
  EpcraCaTankOperator = 'EPCRA_CA_TANK_OPERATOR',
  EpcraCaTankOwner = 'EPCRA_CA_TANK_OWNER',
  EpcraChemicalCarrier = 'EPCRA_CHEMICAL_CARRIER',
  EpcraEmergencyContact = 'EPCRA_EMERGENCY_CONTACT',
  EpcraEmergencyCoordinator = 'EPCRA_EMERGENCY_COORDINATOR',
  EpcraOwnerOperator = 'EPCRA_OWNER_OPERATOR',
  EpcraTierIiContact = 'EPCRA_TIER_II_CONTACT',
  General = 'GENERAL'
}

export type CopyFacilityInventoryResult = {
  __typename?: 'CopyFacilityInventoryResult';
  facilityId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
};

export type CopyInventoryResult = {
  __typename?: 'CopyInventoryResult';
  fromYear?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CountStat = {
  __typename?: 'CountStat';
  count: Scalars['Int'];
  key: Scalars['String'];
  name: Scalars['String'];
};

export type CountiesResult = {
  __typename?: 'CountiesResult';
  count: Scalars['Int'];
  items: Array<Scalars['String']>;
};

export type Counts = {
  __typename?: 'Counts';
  count?: Maybe<Scalars['Int']>;
  countKey?: Maybe<Scalars['String']>;
};

export type CreateChemicalsFromSdsInput = {
  documentIds: Array<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type CreateSubtaskInput = {
  completedAt?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type CreateTaskInput = {
  assigneeId: Scalars['ID'];
  deadline: Scalars['Date'];
  description?: InputMaybe<Scalars['String']>;
  documentIds: Array<Scalars['ID']>;
  facilityIds: Array<Scalars['ID']>;
  frequency: Frequency;
  interval: Scalars['Int'];
  links: Array<Scalars['String']>;
  shouldNotify: Scalars['Boolean'];
  subtasks: Array<CreateSubtaskInput>;
  tags?: InputMaybe<Array<TagInput>>;
  tenantId: Scalars['ID'];
  title: Scalars['String'];
  watchers: Array<Scalars['ID']>;
};

export type CreateUserInput = {
  email: Scalars['String'];
  first?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type CreateWebAutomationJobInput = {
  action: WebAutomationAction;
  credentialId?: InputMaybe<Scalars['ID']>;
  credentialUsername: Scalars['String'];
  encampRequestId?: InputMaybe<Scalars['ID']>;
  evidenceOfCompletionActions: Array<CollectEvidenceOfCompletionActions>;
  facilityId?: InputMaybe<Scalars['ID']>;
  forceClassicSubmissionStrategy: Scalars['Boolean'];
  parameters: Scalars['JSON'];
  reportId?: InputMaybe<Scalars['ID']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  requestId?: InputMaybe<Scalars['ID']>;
  stateOrTerritory: Scalars['String'];
  status: JobStatus;
  stepError: Scalars['String'];
  task: JobTask;
  tenantId: Scalars['String'];
};

export type Credential = {
  __typename?: 'Credential';
  email?: Maybe<Scalars['String']>;
  facilities?: Maybe<Array<Facility>>;
  facilityCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isEncampOwned: Scalars['Boolean'];
  issues?: Maybe<Array<Issue>>;
  kind: CredentialKind;
  lastVerificationCheckAt?: Maybe<Scalars['DateTime']>;
  lastVerificationSuccessAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  states?: Maybe<Array<Scalars['String']>>;
  tenantId: Scalars['ID'];
  username: Scalars['String'];
  verificationStatus: CredentialVerificationStatus;
};

export type CredentialInput = {
  email?: InputMaybe<Scalars['String']>;
  facilityIds?: InputMaybe<Array<Scalars['ID']>>;
  id?: InputMaybe<Scalars['ID']>;
  kind: CredentialKind;
  name: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  username: Scalars['String'];
};

export type CredentialInputForValidation = {
  email?: InputMaybe<Scalars['String']>;
  facilityIds?: InputMaybe<Array<Scalars['ID']>>;
  id?: InputMaybe<Scalars['ID']>;
  kind: CredentialKind;
  name: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['ID']>;
  username: Scalars['String'];
};

export enum CredentialKind {
  Lepc = 'LEPC',
  RcraCounty = 'RCRA_COUNTY',
  RcraFederal = 'RCRA_FEDERAL',
  RcraPayment = 'RCRA_PAYMENT',
  RcraState = 'RCRA_STATE',
  Tierii = 'TIERII'
}

export type CredentialResult = {
  __typename?: 'CredentialResult';
  count?: Maybe<Scalars['Int']>;
  items: Array<Credential>;
};

export enum CredentialVerificationStatus {
  BadPassword = 'BAD_PASSWORD',
  BadSecurityQuestionAnswer = 'BAD_SECURITY_QUESTION_ANSWER',
  BadUsername = 'BAD_USERNAME',
  CurrentlyVerifying = 'CURRENTLY_VERIFYING',
  ExpiredPassword = 'EXPIRED_PASSWORD',
  FailedOneTimePassword = 'FAILED_ONE_TIME_PASSWORD',
  Good = 'GOOD',
  InvalidAccessidOrPassword = 'INVALID_ACCESSID_OR_PASSWORD',
  InUse = 'IN_USE',
  Locked = 'LOCKED',
  NotAttempted = 'NOT_ATTEMPTED',
  RequiresNewPassword = 'REQUIRES_NEW_PASSWORD',
  UnknownErrorNeedsHuman = 'UNKNOWN_ERROR_NEEDS_HUMAN',
  UnknownNonVerifiable = 'UNKNOWN_NON_VERIFIABLE',
  Verifying = 'VERIFYING'
}

export enum DbCollectionMode {
  Aggregate = 'AGGREGATE',
  Measurement = 'MEASUREMENT'
}

export type DeleteCandidatesInput = {
  candidateIds: Array<Scalars['ID']>;
};

export type DeleteChemicalDocumentInput = {
  chemicalId: Scalars['ID'];
  documentId: Scalars['ID'];
};

export type DeleteChemicalDocumentResult = {
  __typename?: 'DeleteChemicalDocumentResult';
  chemicalDocumentId?: Maybe<Scalars['ID']>;
  document: Document;
};

export type DemoAccountCandidate = {
  __typename?: 'DemoAccountCandidate';
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  emails?: Maybe<Array<Maybe<Scalars['String']>>>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  naics?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  operatorName?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  rcraIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  registryId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type DemoAccountCandidateSearchResult = {
  __typename?: 'DemoAccountCandidateSearchResult';
  count: Scalars['Int'];
  items: Array<DemoAccountCandidate>;
};

export type DemoOrganizationInput = {
  excludeDomains: Array<Scalars['String']>;
  excludeEpaIds: Array<Scalars['String']>;
  excludeNameTerms: Array<Scalars['String']>;
  excludeRegistryIds: Array<Scalars['String']>;
  includeDomains: Array<Scalars['String']>;
  includeEpaIds: Array<Scalars['String']>;
  includeNameTerms: Array<Scalars['String']>;
  includeRegistryIds: Array<Scalars['String']>;
  salesforceId?: InputMaybe<Scalars['String']>;
  tenantName: Scalars['String'];
};

export enum DensityUnits {
  KilogramsPerBarrel = 'KILOGRAMS_PER_BARREL',
  KilogramsPerCubicFoot = 'KILOGRAMS_PER_CUBIC_FOOT',
  KilogramsPerGallon = 'KILOGRAMS_PER_GALLON',
  KilogramsPerLiter = 'KILOGRAMS_PER_LITER',
  MetricTonsPerBarrel = 'METRIC_TONS_PER_BARREL',
  MetricTonsPerCubicFoot = 'METRIC_TONS_PER_CUBIC_FOOT',
  MetricTonsPerGallon = 'METRIC_TONS_PER_GALLON',
  MetricTonsPerLiter = 'METRIC_TONS_PER_LITER',
  PoundsPerBarrel = 'POUNDS_PER_BARREL',
  PoundsPerCubicFoot = 'POUNDS_PER_CUBIC_FOOT',
  PoundsPerGallon = 'POUNDS_PER_GALLON',
  PoundsPerLiter = 'POUNDS_PER_LITER',
  TonsPerBarrel = 'TONS_PER_BARREL',
  TonsPerCubicFoot = 'TONS_PER_CUBIC_FOOT',
  TonsPerGallon = 'TONS_PER_GALLON',
  TonsPerLiter = 'TONS_PER_LITER'
}

export type DevtoolsReportsForTenantInput = {
  id: Scalars['ID'];
  state?: InputMaybe<Scalars['String']>;
  year: Scalars['Int'];
};

export type DevtoolsReportsForTenantResult = {
  __typename?: 'DevtoolsReportsForTenantResult';
  updatedCount: Scalars['Int'];
};

export type Document = {
  __typename?: 'Document';
  activities?: Maybe<Array<Activity>>;
  area?: Maybe<Scalars['String']>;
  chemicalDocument?: Maybe<Array<ChemicalDocument>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentTags?: Maybe<Array<Tag>>;
  documentType: DocumentType;
  downloadLink?: Maybe<Scalars['String']>;
  facilities?: Maybe<Array<Facility>>;
  fileExtension?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isArchived?: Maybe<Scalars['Boolean']>;
  job?: Maybe<Array<Job>>;
  lobId?: Maybe<Scalars['String']>;
  report?: Maybe<TierIiReport>;
  reportId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  storageLink: Scalars['String'];
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type DocumentInput = {
  activityId?: InputMaybe<Scalars['String']>;
  area?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  documentTags?: InputMaybe<Array<TagInput>>;
  documentType?: InputMaybe<DocumentType>;
  facilities?: InputMaybe<Array<FacilityDocumentInput>>;
  fileExtension?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  jurisdictions?: InputMaybe<Array<Scalars['String']>>;
  reportId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  storageLink?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum DocumentType {
  AstDocumentation = 'ASTDocumentation',
  Certification = 'Certification',
  Check = 'Check',
  CoverLetter = 'CoverLetter',
  DikeDescription = 'DikeDescription',
  Epcra302 = 'EPCRA302',
  Epcra304 = 'EPCRA304',
  Epcra311 = 'EPCRA311',
  Epcra312 = 'EPCRA312',
  Epcra313 = 'EPCRA313',
  EmergencyResponsePlan = 'EmergencyResponsePlan',
  FeeCalculation = 'FeeCalculation',
  Fees = 'Fees',
  Form = 'Form',
  HazardousMaterialsContingencyPlanOrQuickGuide = 'HazardousMaterialsContingencyPlanOrQuickGuide',
  HazardousMaterialsInventoryStatement = 'HazardousMaterialsInventoryStatement',
  HazardousMaterialsManagementPlan = 'HazardousMaterialsManagementPlan',
  HazardousWasteAnnualReport = 'HazardousWasteAnnualReport',
  HazardousWasteBiennialReport = 'HazardousWasteBiennialReport',
  HazardousWasteContingencyPlan = 'HazardousWasteContingencyPlan',
  HazardousWasteFeesReceipts = 'HazardousWasteFeesReceipts',
  HazardousWasteNotification = 'HazardousWasteNotification',
  HazardousWasteQuarterlyReport = 'HazardousWasteQuarterlyReport',
  HazardousWasteRecertification = 'HazardousWasteRecertification',
  Invoice = 'Invoice',
  Other = 'Other',
  OtherRcra = 'OtherRCRA',
  P2Plan = 'P2Plan',
  P2Update = 'P2Update',
  Permit = 'Permit',
  Proof = 'Proof',
  RcraAnnual = 'RCRAAnnual',
  RcraFeePaymentOrInvoice = 'RCRAFeePaymentOrInvoice',
  RcraManifest = 'RCRAManifest',
  RcraUpdateNotification = 'RCRAUpdateNotification',
  Receipt = 'Receipt',
  ReferenceImage = 'ReferenceImage',
  Report = 'Report',
  RevisionOrUpdate = 'RevisionOrUpdate',
  SafeguardMeasures = 'SafeguardMeasures',
  SafetyDataSheet = 'SafetyDataSheet',
  Screenshot = 'Screenshot',
  SiteCoordinateAbbreviation = 'SiteCoordinateAbbreviation',
  SitePlan = 'SitePlan',
  Submission = 'Submission',
  TrainingPlan = 'TrainingPlan',
  UstDocumentation = 'USTDocumentation'
}

export type DocumentsResult = {
  __typename?: 'DocumentsResult';
  count?: Maybe<Scalars['Int']>;
  items: Array<Document>;
};

export type DynamicField = {
  __typename?: 'DynamicField';
  group?: Maybe<Scalars['String']>;
  helperText?: Maybe<Scalars['String']>;
  inputType: DynamicFieldType;
  jurisdiction: Scalars['String'];
  key: Scalars['String'];
  label: Scalars['String'];
  layout?: Maybe<Scalars['JSON']>;
  renderMetadata?: Maybe<Scalars['JSON']>;
  selectOptions?: Maybe<Array<DynamicFieldOption>>;
  tooltip?: Maybe<Scalars['String']>;
  type?: Maybe<ProgramArea>;
  value?: Maybe<Scalars['JSON']>;
};

export type DynamicFieldInput = {
  jurisdiction: Scalars['String'];
  key: Scalars['String'];
  type: ProgramArea;
  value?: InputMaybe<Scalars['JSON']>;
};

export type DynamicFieldOption = {
  __typename?: 'DynamicFieldOption';
  label: Scalars['String'];
  value: Scalars['JSON'];
};

export enum DynamicFieldType {
  Autocomplete = 'AUTOCOMPLETE',
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Multiselect = 'MULTISELECT',
  MultiselectWithOther = 'MULTISELECT_WITH_OTHER',
  Numeric = 'NUMERIC',
  Radiogroup = 'RADIOGROUP',
  Select = 'SELECT',
  SelectNjPoliceDepartment = 'SELECT_NJ_POLICE_DEPARTMENT',
  SelectWithOther = 'SELECT_WITH_OTHER',
  SicCodeSelect = 'SIC_CODE_SELECT',
  Text = 'TEXT',
  Textarea = 'TEXTAREA'
}

export type DynamicFieldsResult = {
  __typename?: 'DynamicFieldsResult';
  items: Array<DynamicField>;
};

export type EchoExporter = {
  __typename?: 'EchoExporter';
  airFlag?: Maybe<Scalars['Boolean']>;
  airIds: Array<Scalars['String']>;
  caa3yrComplQtrsHistory: Array<QuarterlyHistory>;
  caaComplianceStatus?: Maybe<Scalars['String']>;
  caaDateLastFormalAction?: Maybe<Scalars['DateTime']>;
  caaDaysLastEvaluation?: Maybe<Scalars['Int']>;
  caaEvaluationCount?: Maybe<Scalars['Int']>;
  caaFormalActionCount?: Maybe<Scalars['Int']>;
  caaHpvFlag?: Maybe<Scalars['Boolean']>;
  caaInformalCount?: Maybe<Scalars['Int']>;
  caaLastPenaltyAmt?: Maybe<Scalars['Float']>;
  caaLastPenaltyDate?: Maybe<Scalars['DateTime']>;
  caaNaics: Array<Scalars['String']>;
  caaPenalties?: Maybe<Scalars['Float']>;
  caaPermitTypes: Array<Scalars['String']>;
  caaQtrsWithNc?: Maybe<Scalars['Int']>;
  caaSics: Array<Scalars['String']>;
  cwa3yrQncrCodes?: Maybe<Scalars['String']>;
  cwa13qtrsComplHistory: Array<QuarterlyHistory>;
  cwa13qtrsEfflntExceedances?: Maybe<Scalars['Float']>;
  cwaComplianceStatus?: Maybe<Scalars['String']>;
  cwaComplianceTracking?: Maybe<Scalars['String']>;
  cwaDateLastFormalAction?: Maybe<Scalars['DateTime']>;
  cwaDaysLastInspection?: Maybe<Scalars['Int']>;
  cwaFormalActionCount?: Maybe<Scalars['Int']>;
  cwaInformalCount?: Maybe<Scalars['Int']>;
  cwaInspectionCount?: Maybe<Scalars['Int']>;
  cwaLastPenaltyAmt?: Maybe<Scalars['Float']>;
  cwaLastPenaltyDate?: Maybe<Scalars['DateTime']>;
  cwaNaics: Array<Scalars['String']>;
  cwaPenalties?: Maybe<Scalars['Float']>;
  cwaPermitTypes: Array<Scalars['String']>;
  cwaQtrsWithNc?: Maybe<Scalars['Int']>;
  cwaSics: Array<Scalars['String']>;
  cwaSncFlag?: Maybe<Scalars['Boolean']>;
  dfrUrl?: Maybe<Scalars['String']>;
  ejscreenFlagUs?: Maybe<Scalars['Boolean']>;
  fac3yrComplianceHistory: Array<QuarterlyHistory>;
  facAccuracyMeters?: Maybe<Scalars['Float']>;
  facActiveFlag?: Maybe<Scalars['Boolean']>;
  facChesapeakeBayFlg?: Maybe<Scalars['Boolean']>;
  facCity?: Maybe<Scalars['String']>;
  facCollectionMethod?: Maybe<Scalars['String']>;
  facComplianceStatus?: Maybe<Scalars['String']>;
  facCounty?: Maybe<Scalars['String']>;
  facDateLastFormalActEpa?: Maybe<Scalars['DateTime']>;
  facDateLastFormalActSt?: Maybe<Scalars['DateTime']>;
  facDateLastFormalAction?: Maybe<Scalars['DateTime']>;
  facDateLastInformalActEpa?: Maybe<Scalars['DateTime']>;
  facDateLastInformalActSt?: Maybe<Scalars['DateTime']>;
  facDateLastInformalAction?: Maybe<Scalars['DateTime']>;
  facDateLastInspection?: Maybe<Scalars['DateTime']>;
  facDateLastInspectionEpa?: Maybe<Scalars['DateTime']>;
  facDateLastInspectionState?: Maybe<Scalars['DateTime']>;
  facDateLastPenalty?: Maybe<Scalars['DateTime']>;
  facDaysLastInspection?: Maybe<Scalars['Int']>;
  facDerivedCb2010?: Maybe<Scalars['String']>;
  facDerivedCd113?: Maybe<Scalars['String']>;
  facDerivedHuc?: Maybe<Scalars['String']>;
  facDerivedStctyFips?: Maybe<Scalars['String']>;
  facDerivedTribes?: Maybe<Scalars['String']>;
  facDerivedWbd?: Maybe<Scalars['String']>;
  facDerivedZip?: Maybe<Scalars['String']>;
  facEpaRegion?: Maybe<Scalars['String']>;
  facFederalAgency?: Maybe<Scalars['String']>;
  facFederalFlg?: Maybe<Scalars['Boolean']>;
  facFipsCode?: Maybe<Scalars['String']>;
  facFormalActionCount?: Maybe<Scalars['Int']>;
  facImpWaterFlg?: Maybe<Scalars['Boolean']>;
  facIndianCntryFlg?: Maybe<Scalars['Boolean']>;
  facInformalCount?: Maybe<Scalars['Int']>;
  facInspectionCount?: Maybe<Scalars['Int']>;
  facLastPenaltyAmt?: Maybe<Scalars['Float']>;
  facLat?: Maybe<Scalars['Float']>;
  facLong?: Maybe<Scalars['Float']>;
  facMajorFlag?: Maybe<Scalars['Boolean']>;
  facMapIcon?: Maybe<Scalars['String']>;
  facMyrtkUniverse?: Maybe<Scalars['String']>;
  facNaaFlag?: Maybe<Scalars['Boolean']>;
  facNaicsCodes: Array<Scalars['String']>;
  facName?: Maybe<Scalars['String']>;
  facPenaltyCount?: Maybe<Scalars['Int']>;
  facPercentMinority?: Maybe<Scalars['Float']>;
  facPopDen?: Maybe<Scalars['Float']>;
  facProgramsWithSnc?: Maybe<Scalars['Int']>;
  facQtrsWithNc?: Maybe<Scalars['Int']>;
  facReferencePoint?: Maybe<Scalars['String']>;
  facSicCodes: Array<Scalars['String']>;
  facSncFlg?: Maybe<Scalars['Boolean']>;
  facState?: Maybe<Scalars['String']>;
  facStreet?: Maybe<Scalars['String']>;
  facTotalPenalties?: Maybe<Scalars['Float']>;
  facUsMexBorderFlg?: Maybe<Scalars['Boolean']>;
  facZip?: Maybe<Scalars['String']>;
  fecCaseIds: Array<Scalars['String']>;
  fecLastCaseDate?: Maybe<Scalars['DateTime']>;
  fecNumberOfCases?: Maybe<Scalars['Int']>;
  fecTotalPenalties?: Maybe<Scalars['Float']>;
  ghgCo2Releases?: Maybe<Scalars['Float']>;
  ghgFlag?: Maybe<Scalars['Boolean']>;
  ghgIds: Array<Scalars['String']>;
  npdesFlag?: Maybe<Scalars['Boolean']>;
  npdesIds: Array<Scalars['String']>;
  rcra3yrComplQtrsHistory: Array<QuarterlyHistory>;
  rcraComplianceStatus?: Maybe<Scalars['String']>;
  rcraDateLastFormalAction?: Maybe<Scalars['DateTime']>;
  rcraDaysLastEvaluation?: Maybe<Scalars['Int']>;
  rcraFlag?: Maybe<Scalars['Boolean']>;
  rcraFormalActionCount?: Maybe<Scalars['Int']>;
  rcraIds: Array<Scalars['String']>;
  rcraInformalCount?: Maybe<Scalars['Int']>;
  rcraInspectionCount?: Maybe<Scalars['Int']>;
  rcraLastPenaltyAmt?: Maybe<Scalars['Float']>;
  rcraLastPenaltyDate?: Maybe<Scalars['DateTime']>;
  rcraNaics: Array<Scalars['String']>;
  rcraPenalties?: Maybe<Scalars['Float']>;
  rcraPermitTypes: Array<Scalars['String']>;
  rcraQtrsWithNc?: Maybe<Scalars['Int']>;
  rcraSncFlag?: Maybe<Scalars['Boolean']>;
  registryId: Scalars['String'];
  sdwaComplianceStatus?: Maybe<Scalars['String']>;
  sdwaFormalActionCount?: Maybe<Scalars['Int']>;
  sdwaIds: Array<Scalars['String']>;
  sdwaInformalCount?: Maybe<Scalars['Int']>;
  sdwaSncFlag?: Maybe<Scalars['Boolean']>;
  sdwaSystemTypes: Array<Scalars['String']>;
  sdwisFlag?: Maybe<Scalars['Boolean']>;
  triFlag?: Maybe<Scalars['Boolean']>;
  triIds: Array<Scalars['String']>;
  triOffSiteTransfers?: Maybe<Scalars['Float']>;
  triOnSiteReleases?: Maybe<Scalars['Float']>;
  triReleasesTransfers?: Maybe<Scalars['Float']>;
  triReporter?: Maybe<Scalars['Boolean']>;
  triReporterInPast?: Maybe<Scalars['Boolean']>;
};

export type EchoExporterAggregated = {
  __typename?: 'EchoExporterAggregated';
  echoFacilityName?: Maybe<Scalars['String']>;
  echoFirstNaicsCode?: Maybe<Scalars['String']>;
  facilityCity?: Maybe<Scalars['String']>;
  facilityCounty?: Maybe<Scalars['String']>;
  facilityState?: Maybe<Scalars['String']>;
  facilityStreet?: Maybe<Scalars['String']>;
  facilityZip?: Maybe<Scalars['String']>;
  naics3?: Maybe<Scalars['String']>;
  naicsCode?: Maybe<Scalars['Int']>;
  nonComplianceCountLast12Qrtrs?: Maybe<Scalars['Int']>;
  penaltiesLast12Qrtrs?: Maybe<Scalars['Float']>;
  registryId: Scalars['String'];
  violationCountLast12Qrtrs?: Maybe<Scalars['Int']>;
};

export type EchoExporterResult = {
  __typename?: 'EchoExporterResult';
  count: Scalars['Int'];
  items: Array<EchoExporter>;
};

export type EchoOverview = {
  __typename?: 'EchoOverview';
  history: Array<EchoOverviewHistory>;
  stats: EchoOverviewStats;
};

export type EchoOverviewHistory = {
  __typename?: 'EchoOverviewHistory';
  noViolation: Scalars['Int'];
  program: Scalars['String'];
  quarter: Scalars['String'];
  significantNoncompliance: Scalars['Int'];
  unknown: Scalars['Int'];
  violation: Scalars['Int'];
};

export type EchoOverviewStats = {
  __typename?: 'EchoOverviewStats';
  activeFacilityCount?: Maybe<Scalars['Int']>;
  airComplianceStatusCounts?: Maybe<Array<Counts>>;
  airFacilityCount?: Maybe<Scalars['Int']>;
  airPermitTypeCounts?: Maybe<Array<Counts>>;
  airSignificantViolatorCount?: Maybe<Scalars['Int']>;
  airViolatorCount?: Maybe<Scalars['Int']>;
  totalFacilityCount?: Maybe<Scalars['Int']>;
  wasteComplianceStatusCounts?: Maybe<Array<Counts>>;
  wasteFacilityCount?: Maybe<Scalars['Int']>;
  wastePermitTypeCounts?: Maybe<Array<Counts>>;
  wasteSignificantViolatorCount?: Maybe<Scalars['Int']>;
  wasteViolatorCount?: Maybe<Scalars['Int']>;
  waterComplianceStatusCounts?: Maybe<Array<Counts>>;
  waterFacilityCount?: Maybe<Scalars['Int']>;
  waterPermitTypeCounts?: Maybe<Array<Counts>>;
  waterSignificantViolatorCount?: Maybe<Scalars['Int']>;
  waterViolatorCount?: Maybe<Scalars['Int']>;
};

export enum EchoQuarterlyHistory {
  Inactive = 'INACTIVE',
  NoViolation = 'NO_VIOLATION',
  SignificantNoncompliance = 'SIGNIFICANT_NONCOMPLIANCE',
  Unknown = 'UNKNOWN',
  Violation = 'VIOLATION'
}

export enum EhsForm {
  Molten = 'MOLTEN',
  None = 'NONE',
  SolidParticleSizeLessThan_100Micron = 'SOLID_PARTICLE_SIZE_LESS_THAN_100_MICRON',
  Solution = 'SOLUTION'
}

export type EmailReviewersResult = {
  __typename?: 'EmailReviewersResult';
  ids: Array<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type EncampFilingStatusResult = {
  __typename?: 'EncampFilingStatusResult';
  totalFiled: Scalars['Int'];
  totalWaitingToFile: Scalars['Int'];
  totalWaitingToReceive: Scalars['Int'];
};

export type EncampStats = {
  __typename?: 'EncampStats';
  hoursSaved: Scalars['Int'];
  totalPaymentsMade: Scalars['Float'];
  totalPaymentsManaged: Scalars['Int'];
  treesPlanted: Scalars['Int'];
};

export type EventMutationInput = {
  date: Scalars['Date'];
  eventMutationScope: EventMutationScope;
  taskId: Scalars['ID'];
};

export enum EventMutationScope {
  All = 'ALL',
  This = 'THIS',
  ThisAndFollowing = 'THIS_AND_FOLLOWING'
}

export enum ExecutionPlanType {
  Automation = 'Automation',
  Human = 'Human'
}

export type ExportFulfillmentGridToCsvResult = {
  __typename?: 'ExportFulfillmentGridToCsvResult';
  downloadUrl?: Maybe<Scalars['String']>;
  errorMsg?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ExtensionsByProgramArea = {
  __typename?: 'ExtensionsByProgramArea';
  EPCRA: Array<DynamicField>;
};

export type ExtensionsByProgramAreaInput = {
  EPCRA?: InputMaybe<Scalars['JSON']>;
};

export type FacilitiesResult = {
  __typename?: 'FacilitiesResult';
  count: Scalars['Int'];
  items: Array<Facility>;
};

export type Facility = {
  __typename?: 'Facility';
  businessUnit?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  collectionMode?: Maybe<CollectionMode>;
  colocationReportingFacility?: Maybe<Facility>;
  colocationReportingFacilityId?: Maybe<Scalars['ID']>;
  companyName?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<FacilityContact>>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  customerFacilityId?: Maybe<Scalars['String']>;
  dateClosed?: Maybe<Scalars['Date']>;
  dateInactive?: Maybe<Scalars['Date']>;
  dateOpened?: Maybe<Scalars['Date']>;
  dbNumber?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Document>>;
  echoFacilityMatchCandidates?: Maybe<Array<InsightsCandidate>>;
  epaGeneratorStatus?: Maybe<Scalars['String']>;
  epaGeneratorStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  epaGeneratorStatusUpdatedBy?: Maybe<Scalars['String']>;
  facilityAlternateIds?: Maybe<Array<AlternateId>>;
  facilityChemicalStateFields?: Maybe<Array<FacilityChemicalStateField>>;
  facilityCredentials?: Maybe<Array<FacilityCredential>>;
  facilityType?: Maybe<Scalars['String']>;
  fireDepartment?: Maybe<FireDepartment>;
  fireDepartmentId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAutoGeocoded?: Maybe<Scalars['Boolean']>;
  isClosed?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  isMailingAddressEncamp?: Maybe<Scalars['Boolean']>;
  isMailingAddressSameAsFacility?: Maybe<Scalars['Boolean']>;
  isNotReporting?: Maybe<Scalars['Boolean']>;
  isNotReportingThroughEncamp?: Maybe<Scalars['Boolean']>;
  isSubjectToChemicalAccidentPrevention?: Maybe<Scalars['Boolean']>;
  isSubjectToEmergencyPlanning?: Maybe<Scalars['Boolean']>;
  isSubjectToToxicsReleaseInventoryReporting?: Maybe<Scalars['Boolean']>;
  isUnmanned?: Maybe<Scalars['Boolean']>;
  issueCount?: Maybe<Scalars['Int']>;
  issues: Array<Issue>;
  jobs?: Maybe<Array<Job>>;
  latitude?: Maybe<Scalars['Float']>;
  lepc?: Maybe<Lepc>;
  lepcId?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  mailingCity?: Maybe<Scalars['String']>;
  mailingCountry?: Maybe<Scalars['String']>;
  mailingState?: Maybe<Scalars['String']>;
  mailingStreetAddress1?: Maybe<Scalars['String']>;
  mailingStreetAddress2?: Maybe<Scalars['String']>;
  mailingZip?: Maybe<Scalars['String']>;
  maxNumOccupants?: Maybe<Scalars['Int']>;
  municipality?: Maybe<Scalars['String']>;
  naicsCode?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  phone24Hour?: Maybe<Scalars['String']>;
  portalCredential?: Maybe<PortalCredential>;
  rawExtensions?: Maybe<Scalars['JSON']>;
  regulatoryStatus?: Maybe<FacilityRegulatoryStatus>;
  reportingChemicalCount: Scalars['Int'];
  reportsManually?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  stateFields: Array<DynamicField>;
  status?: Maybe<FacilityStatus>;
  statusReason?: Maybe<Scalars['String']>;
  streetAddress1?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
  tags: Array<Tag>;
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['ID']>;
  tierIIReports?: Maybe<Array<TierIiReport>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  wasteStreams?: Maybe<FacilityWasteStreamResult>;
  zip?: Maybe<Scalars['String']>;
};


export type FacilityContactsArgs = {
  programArea?: InputMaybe<ProgramArea>;
};


export type FacilityJobsArgs = {
  action?: InputMaybe<WebAutomationAction>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type FacilityWasteStreamsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};

export type FacilityChemical = {
  __typename?: 'FacilityChemical';
  averageAmount?: Maybe<Scalars['Float']>;
  averageAmountCode?: Maybe<Scalars['Int']>;
  chemical?: Maybe<Chemical>;
  chemicalId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  daysOnSite?: Maybe<Scalars['Int']>;
  facility?: Maybe<Facility>;
  facilityId: Scalars['ID'];
  hasConfidentialStorageLocations?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isAlwaysReported?: Maybe<Scalars['Boolean']>;
  issueCount?: Maybe<Scalars['Int']>;
  issues: Array<Issue>;
  jurisdictions?: Maybe<Array<Scalars['String']>>;
  maxAmount?: Maybe<Scalars['Float']>;
  maxAmountCode?: Maybe<Scalars['Int']>;
  maxAmountLargestContainer?: Maybe<Scalars['Float']>;
  reportingFacilityChemical?: Maybe<ReportingFacilityChemical>;
  reportingYear: Scalars['Int'];
  stateFields: Array<DynamicField>;
  storageLocations?: Maybe<Array<FacilityChemicalStorageLocation>>;
  unit?: Maybe<UnitType>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type FacilityChemicalInput = {
  averageAmount?: InputMaybe<Scalars['Float']>;
  averageAmountCode?: InputMaybe<Scalars['Int']>;
  chemicalId?: InputMaybe<Scalars['ID']>;
  daysOnSite?: InputMaybe<Scalars['Int']>;
  facilityId?: InputMaybe<Scalars['ID']>;
  hasConfidentialStorageLocations?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isAlwaysReported?: InputMaybe<Scalars['Boolean']>;
  maxAmount?: InputMaybe<Scalars['Float']>;
  maxAmountCode?: InputMaybe<Scalars['Int']>;
  maxAmountLargestContainer?: InputMaybe<Scalars['Float']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  stateFields?: InputMaybe<Array<DynamicFieldInput>>;
  storageLocations: Array<FacilityChemicalStorageLocationInput>;
  unit?: InputMaybe<UnitType>;
};

export type FacilityChemicalMeasurement = {
  __typename?: 'FacilityChemicalMeasurement';
  amount: Scalars['Float'];
  chemical?: Maybe<Chemical>;
  chemicalId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  facility?: Maybe<Facility>;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  issueCount?: Maybe<Scalars['Int']>;
  issues: Array<Issue>;
  measuredAtUtc: Scalars['Date'];
  otherPressureValue?: Maybe<Scalars['String']>;
  pressure?: Maybe<Pressure>;
  storageLocation?: Maybe<StorageLocation>;
  storageLocationId: Scalars['ID'];
  storageType?: Maybe<Scalars['String']>;
  storageTypeDescription?: Maybe<Scalars['String']>;
  temperature?: Maybe<Temperature>;
  unit: UnitType;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type FacilityChemicalMeasurementInput = {
  amount?: InputMaybe<Scalars['Float']>;
  chemicalId?: InputMaybe<Scalars['ID']>;
  facilityId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  measuredAtUtc?: InputMaybe<Scalars['Date']>;
  otherPressureValue?: InputMaybe<Scalars['String']>;
  pressure?: InputMaybe<Pressure>;
  storageLocation?: InputMaybe<StorageLocationInput>;
  storageLocationId: Scalars['ID'];
  storageType?: InputMaybe<Scalars['String']>;
  storageTypeDescription?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Temperature>;
  unit?: InputMaybe<UnitType>;
};

export type FacilityChemicalMeasurementsResult = {
  __typename?: 'FacilityChemicalMeasurementsResult';
  count: Scalars['Int'];
  items: Array<FacilityChemicalMeasurement>;
};

export type FacilityChemicalStateField = {
  __typename?: 'FacilityChemicalStateField';
  chemical?: Maybe<Chemical>;
  chemicalId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  facility?: Maybe<Facility>;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  jurisdiction: Scalars['String'];
  key: Scalars['String'];
  reportingYear: Scalars['Int'];
  type: ProgramArea;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
  value: Scalars['JSON'];
};

export type FacilityChemicalStateFieldInput = {
  chemicalId: Scalars['ID'];
  facilityId: Scalars['ID'];
  jurisdiction: Scalars['String'];
  key: Scalars['String'];
  reportingYear: Scalars['Int'];
  type: ProgramArea;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FacilityChemicalStorageLocation = {
  __typename?: 'FacilityChemicalStorageLocation';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  facilityChemical?: Maybe<FacilityChemical>;
  facilityChemicalId: Scalars['ID'];
  id: Scalars['ID'];
  maxAmount?: Maybe<Scalars['Float']>;
  otherPressureValue?: Maybe<Scalars['String']>;
  pressure?: Maybe<Pressure>;
  storageLocation?: Maybe<StorageLocation>;
  storageLocationId: Scalars['ID'];
  storageType?: Maybe<Scalars['String']>;
  storageTypeDescription?: Maybe<Scalars['String']>;
  temperature?: Maybe<Temperature>;
  unit?: Maybe<UnitType>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type FacilityChemicalStorageLocationInput = {
  id: Scalars['ID'];
  maxAmount?: InputMaybe<Scalars['Float']>;
  otherPressureValue?: InputMaybe<Scalars['String']>;
  pressure?: InputMaybe<Pressure>;
  storageLocation: StorageLocationInput;
  storageType?: InputMaybe<Scalars['String']>;
  storageTypeDescription?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Temperature>;
  unit?: InputMaybe<UnitType>;
};

export type FacilityChemicalThresholdData = {
  __typename?: 'FacilityChemicalThresholdData';
  isOverThreshold?: Maybe<Scalars['Boolean']>;
};

export type FacilityChemicalsResult = {
  __typename?: 'FacilityChemicalsResult';
  count: Scalars['Int'];
  items: Array<FacilityChemical>;
};

export type FacilityContact = {
  __typename?: 'FacilityContact';
  facility: Facility;
  id: Scalars['ID'];
  issues?: Maybe<Array<Issue>>;
  person: Person;
  reportingRoles: Array<ContactReportRole>;
};

export type FacilityContactInput = {
  facilityId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  person: PersonInput;
  reportingRoles: Array<ContactReportRole>;
};

export type FacilityCredential = {
  __typename?: 'FacilityCredential';
  credential: Credential;
  credentialId: Scalars['ID'];
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
};

export type FacilityDocumentInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type FacilityEchoExporter = {
  __typename?: 'FacilityEchoExporter';
  customerFacilityId?: Maybe<Scalars['String']>;
  echoFacilityName?: Maybe<Scalars['String']>;
  echoFirstNaicsCode?: Maybe<Scalars['String']>;
  facilityCity?: Maybe<Scalars['String']>;
  facilityCounty?: Maybe<Scalars['String']>;
  facilityId?: Maybe<Scalars['String']>;
  facilityState?: Maybe<Scalars['String']>;
  facilityStatus?: Maybe<FacilityStatus>;
  facilityStreet?: Maybe<Scalars['String']>;
  facilityZip?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  naics3?: Maybe<Scalars['String']>;
  naicsCode?: Maybe<Scalars['Int']>;
  nonComplianceCountLast12Qrtrs?: Maybe<Scalars['Int']>;
  penaltiesLast12Qrtrs?: Maybe<Scalars['Float']>;
  registryId?: Maybe<Scalars['String']>;
  violationCountLast12Qrtrs?: Maybe<Scalars['Int']>;
};

export type FacilityInput = {
  businessUnit?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  collectionMode?: InputMaybe<DbCollectionMode>;
  colocationReportingFacilityId?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  customerFacilityId?: InputMaybe<Scalars['String']>;
  dateClosed?: InputMaybe<Scalars['Date']>;
  dateInactive?: InputMaybe<Scalars['Date']>;
  dateOpened?: InputMaybe<Scalars['Date']>;
  dbNumber?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  epaGeneratorStatus?: InputMaybe<Scalars['String']>;
  epaGeneratorStatusUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  epaGeneratorStatusUpdatedBy?: InputMaybe<Scalars['String']>;
  facilityAlternateIds?: InputMaybe<Array<AlternateIdInput>>;
  facilityType?: InputMaybe<Scalars['String']>;
  fireDepartmentId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  isAutoGeocoded?: InputMaybe<Scalars['Boolean']>;
  isColocated?: InputMaybe<Scalars['Boolean']>;
  isMailingAddressEncamp?: InputMaybe<Scalars['Boolean']>;
  isMailingAddressSameAsFacility?: InputMaybe<Scalars['JSON']>;
  isSubjectToChemicalAccidentPrevention?: InputMaybe<Scalars['Boolean']>;
  isSubjectToEmergencyPlanning?: InputMaybe<Scalars['Boolean']>;
  isSubjectToToxicsReleaseInventoryReporting?: InputMaybe<Scalars['Boolean']>;
  isUnmanned?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['Float']>;
  lepcId?: InputMaybe<Scalars['ID']>;
  longitude?: InputMaybe<Scalars['Float']>;
  mailingCity?: InputMaybe<Scalars['String']>;
  mailingCountry?: InputMaybe<Scalars['String']>;
  mailingState?: InputMaybe<Scalars['String']>;
  mailingStreetAddress1?: InputMaybe<Scalars['String']>;
  mailingStreetAddress2?: InputMaybe<Scalars['String']>;
  mailingZip?: InputMaybe<Scalars['String']>;
  maxNumOccupants?: InputMaybe<Scalars['Int']>;
  municipality?: InputMaybe<Scalars['String']>;
  naicsCode?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phone24Hour?: InputMaybe<Scalars['String']>;
  rawExtensions?: InputMaybe<Scalars['JSON']>;
  reportingChemicalCount?: InputMaybe<Scalars['Int']>;
  reportsManually?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  stateFields?: InputMaybe<Array<DynamicFieldInput>>;
  status?: InputMaybe<FacilityStatus>;
  statusReason?: InputMaybe<Scalars['String']>;
  streetAddress1?: InputMaybe<Scalars['String']>;
  streetAddress2?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  zip?: InputMaybe<Scalars['String']>;
};

export type FacilityPayment = {
  __typename?: 'FacilityPayment';
  amount?: Maybe<Scalars['Float']>;
  facility?: Maybe<Facility>;
};

export type FacilityProduct = {
  __typename?: 'FacilityProduct';
  averageQuantity?: Maybe<Scalars['Int']>;
  chemicalAmounts?: Maybe<Array<FacilityProductChemicalAmounts>>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  daysOnSite?: Maybe<Scalars['Int']>;
  facility?: Maybe<Facility>;
  facilityId: Scalars['ID'];
  hasConfidentialStorageLocations?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  issues: Array<Issue>;
  maxQuantity?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  productId: Scalars['ID'];
  reportingYear: Scalars['Int'];
  storageLocations?: Maybe<Array<FacilityProductStorageLocation>>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type FacilityProductChemicalAmounts = {
  __typename?: 'FacilityProductChemicalAmounts';
  averageAmount?: Maybe<Scalars['Float']>;
  chemical: Chemical;
  chemicalId: Scalars['ID'];
  maxAmount?: Maybe<Scalars['Float']>;
  unit?: Maybe<UnitType>;
};

export type FacilityProductInput = {
  averageQuantity?: InputMaybe<Scalars['Int']>;
  daysOnSite?: InputMaybe<Scalars['Int']>;
  facilityId?: InputMaybe<Scalars['ID']>;
  hasConfidentialStorageLocations?: InputMaybe<Scalars['Boolean']>;
  maxQuantity?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['ID']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  storageLocations: Array<FacilityProductStorageLocationInput>;
};

export type FacilityProductMeasurement = {
  __typename?: 'FacilityProductMeasurement';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  facility?: Maybe<Facility>;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  issues: Array<Issue>;
  measuredAtUtc: Scalars['Date'];
  product?: Maybe<Product>;
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  storageLocation?: Maybe<StorageLocation>;
  storageLocationId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type FacilityProductMeasurementInput = {
  facilityId?: InputMaybe<Scalars['ID']>;
  measuredAtUtc?: InputMaybe<Scalars['Date']>;
  productId?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Float']>;
  storageLocation?: InputMaybe<StorageLocationInput>;
  storageLocationId?: InputMaybe<Scalars['ID']>;
};

export type FacilityProductMeasurementsResult = {
  __typename?: 'FacilityProductMeasurementsResult';
  count: Scalars['Int'];
  items: Array<FacilityProductMeasurement>;
};

export type FacilityProductStorageLocation = {
  __typename?: 'FacilityProductStorageLocation';
  facilityProduct?: Maybe<FacilityProduct>;
  facilityProductId: Scalars['ID'];
  id: Scalars['ID'];
  maxQuantity?: Maybe<Scalars['Int']>;
  storageLocation?: Maybe<StorageLocation>;
  storageLocationId: Scalars['ID'];
};

export type FacilityProductStorageLocationInput = {
  id: Scalars['ID'];
  maxQuantity?: InputMaybe<Scalars['Int']>;
  storageLocation: StorageLocationInput;
};

export type FacilityProductsResult = {
  __typename?: 'FacilityProductsResult';
  count: Scalars['Int'];
  items: Array<FacilityProduct>;
};

export type FacilityRegulatoryStatus = {
  __typename?: 'FacilityRegulatoryStatus';
  eManifestHighestStatusThisYear: RcraInfoFederalWasteGeneratorStatus;
  rcraInfo: RcraInfoFederalWasteGeneratorStatus;
  rcraInfoHighestStatusThisYear: RcraInfoFederalWasteGeneratorStatus;
  vendorHighestStatusThisYear: RcraInfoFederalWasteGeneratorStatus;
};

export type FacilityStateFieldsInput = {
  facilityId: Scalars['ID'];
  jurisdictions?: InputMaybe<Array<Scalars['String']>>;
};

export enum FacilityStatus {
  Closed = 'CLOSED',
  Inactive = 'INACTIVE',
  Open = 'OPEN',
  Planned = 'PLANNED'
}

export type FacilityTierIiReport = {
  __typename?: 'FacilityTierIIReport';
  activityAssignee?: Maybe<Scalars['String']>;
  assignees: Array<TierIiReportAssignee>;
  city?: Maybe<Scalars['String']>;
  colocationReportingFacilityId?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  customerFacilityId?: Maybe<Scalars['String']>;
  encampStatus?: Maybe<TierIiReportEncampStatus>;
  encampStatusAnnual?: Maybe<TierIiReportEncampStatus>;
  facilityDateClosed?: Maybe<Scalars['Date']>;
  facilityDateInactive?: Maybe<Scalars['Date']>;
  facilityId: Scalars['ID'];
  facilityName?: Maybe<Scalars['String']>;
  hasOpenInitial?: Maybe<Scalars['Boolean']>;
  hasOpenRevision?: Maybe<Scalars['Boolean']>;
  hasVerifiedInitial?: Maybe<Scalars['Boolean']>;
  hasVerifiedRevision?: Maybe<Scalars['Boolean']>;
  isClosed?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  isNotReporting?: Maybe<Scalars['Boolean']>;
  isNotReportingThroughEncamp?: Maybe<Scalars['Boolean']>;
  issueCount?: Maybe<Scalars['Int']>;
  notReportingReason?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  organizationStatus?: Maybe<TierIiReportOrgStatus>;
  organizationStatusAnnual?: Maybe<TierIiReportOrgStatus>;
  productCount?: Maybe<Scalars['Int']>;
  reportCreatedAt?: Maybe<Scalars['DateTime']>;
  reportCreatedBy?: Maybe<Scalars['String']>;
  reportCreatedByUser?: Maybe<User>;
  reportKind?: Maybe<TierIiReportKind>;
  reportUpdatedAt?: Maybe<Scalars['DateTime']>;
  reportUpdatedBy?: Maybe<Scalars['String']>;
  reportUpdatedByUser?: Maybe<User>;
  reportingYear: Scalars['Int'];
  reviewers: Array<TierIiReportAssignee>;
  state?: Maybe<Scalars['String']>;
  streetAddress1?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  tierIIReportId?: Maybe<Scalars['ID']>;
  viewId: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

export type FacilityTierIiReportsResult = {
  __typename?: 'FacilityTierIIReportsResult';
  count: Scalars['Int'];
  items: Array<FacilityTierIiReport>;
};

export enum FacilityTypeCode {
  Corporation = 'CORPORATION',
  CountyGovernment = 'COUNTY_GOVERNMENT',
  District = 'DISTRICT',
  FederalFacility = 'FEDERAL_FACILITY',
  GovernmentOwnedContractorOperated = 'GOVERNMENT_OWNED_CONTRACTOR_OPERATED',
  Individual = 'INDIVIDUAL',
  MixedOwnership = 'MIXED_OWNERSHIP',
  Municipality = 'MUNICIPALITY',
  MunicipalOrWaterDistrict = 'MUNICIPAL_OR_WATER_DISTRICT',
  NonGovernment = 'NON_GOVERNMENT',
  PrivatelyOwnedFacility = 'PRIVATELY_OWNED_FACILITY',
  SchoolDistrict = 'SCHOOL_DISTRICT',
  StateGovernment = 'STATE_GOVERNMENT',
  TribalGovernment = 'TRIBAL_GOVERNMENT',
  Unknown = 'UNKNOWN'
}

export enum FacilityTypeIndicator {
  FederalFacility = 'FEDERAL_FACILITY',
  NonPubliclyOwnedTreatmentWorks = 'NON_PUBLICLY_OWNED_TREATMENT_WORKS',
  PubliclyOwnedTreatmentWorks = 'PUBLICLY_OWNED_TREATMENT_WORKS'
}

export type FacilityUsage = {
  __typename?: 'FacilityUsage';
  facilityCount: Scalars['Int'];
  items: Array<Facility>;
  tenantCount: Scalars['Int'];
};

export type FacilityWasteStream = {
  __typename?: 'FacilityWasteStream';
  classification?: Maybe<WasteClassification>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  dotDescription?: Maybe<Scalars['String']>;
  facilityId: Scalars['ID'];
  facilityWasteStreamYearToDates?: Maybe<Array<FacilityWasteStreamYearToDate>>;
  federalWasteCodes?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  stateWasteCodes?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  wasteStreamHashKey?: Maybe<Scalars['String']>;
};

export type FacilityWasteStreamResult = {
  __typename?: 'FacilityWasteStreamResult';
  count: Scalars['Int'];
  items: Array<FacilityWasteStream>;
};

export type FacilityWasteStreamYearToDate = {
  __typename?: 'FacilityWasteStreamYearToDate';
  finalDestinations?: Maybe<Array<Scalars['String']>>;
  managementMethodCodes?: Maybe<Array<Scalars['String']>>;
  shipments?: Maybe<Scalars['Float']>;
};

export type FireDepartment = {
  __typename?: 'FireDepartment';
  additionalComments?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fireDeptId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isEmailed?: Maybe<Scalars['Boolean']>;
  isMailed?: Maybe<Scalars['Boolean']>;
  isSubmittedViaPortal?: Maybe<Scalars['Boolean']>;
  issues?: Maybe<Array<Issue>>;
  lastName?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  mailingAddress?: Maybe<Scalars['String']>;
  mailingAddressLine2?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  needsT2sFile?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  phoneExt?: Maybe<Scalars['String']>;
  portalId?: Maybe<Scalars['String']>;
  portalName?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateSubmitsToFireDept?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type FireDepartmentInput = {
  additionalComments?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEmailed?: InputMaybe<Scalars['Boolean']>;
  isMailed?: InputMaybe<Scalars['Boolean']>;
  isSubmittedViaPortal?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  mailingAddress?: InputMaybe<Scalars['String']>;
  mailingAddressLine2?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  needsT2sFile?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneExt?: InputMaybe<Scalars['String']>;
  portalId?: InputMaybe<Scalars['String']>;
  portalName?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  stateSubmitsToFireDept?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type FireDepartmentResult = {
  __typename?: 'FireDepartmentResult';
  count: Scalars['Int'];
  items: Array<FireDepartment>;
};

export enum Frequency {
  Monthly = 'MONTHLY',
  Once = 'ONCE',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type GenerateInsightsCandidatesInput = {
  queryConfiguration?: InputMaybe<QueryConfiguration>;
  tenantId: Scalars['String'];
};

export type GeneratePresignedUrlResult = {
  __typename?: 'GeneratePresignedUrlResult';
  key: Scalars['String'];
  presignedUrl: Scalars['String'];
};

export type GenerateSubmissionZipArgs = {
  documentTypes?: InputMaybe<Array<DocumentType>>;
  facilityId?: InputMaybe<Scalars['ID']>;
  reportingYear: Scalars['Int'];
  tenantId: Scalars['ID'];
};

export type GenerateSubmissionZipPath = {
  __typename?: 'GenerateSubmissionZipPath';
  destination: Scalars['String'];
  source: Scalars['String'];
};

export type GenerateSubmissionZipResult = {
  __typename?: 'GenerateSubmissionZipResult';
  archiveKey: Scalars['String'];
  files: Array<GenerateSubmissionZipPath>;
};

export type GenerateTierIiPdfPreviewResult = {
  __typename?: 'GenerateTierIIPdfPreviewResult';
  jobId: Scalars['String'];
  s3Key: Scalars['String'];
};

export type HasIssuesReason = {
  __typename?: 'HasIssuesReason';
  eManifestValue?: Maybe<Scalars['String']>;
  field: Scalars['String'];
  vendorManifestValue?: Maybe<Scalars['String']>;
};

export type HazardousWasteByMonth = {
  __typename?: 'HazardousWasteByMonth';
  acutelyHazardous: Scalars['Float'];
  hazardous: Scalars['Float'];
  month: Scalars['Date'];
};

export type HazardousWasteShipmentsByFacility = {
  __typename?: 'HazardousWasteShipmentsByFacility';
  byMonth: Array<HazardousWasteByMonth>;
  highestAcutelyHazardousMonths: Array<Scalars['String']>;
  highestHazardousMonths: Array<Scalars['String']>;
  highestWasteMonths: Array<Scalars['String']>;
  totalAcutelyHazardousAmount: Scalars['Float'];
  totalAmount: Scalars['Float'];
  totalHazardousAmount: Scalars['Float'];
};

export type HdHandler = {
  __typename?: 'HdHandler';
  accessibility?: Maybe<RcraInfoAccessibility>;
  acknowledgeDate?: Maybe<Scalars['DateTime']>;
  acknowledgeFlag?: Maybe<Scalars['Boolean']>;
  activityLocation: Scalars['String'];
  brExempt?: Maybe<Scalars['String']>;
  cdxTransactionId?: Maybe<Scalars['String']>;
  contactCity?: Maybe<Scalars['String']>;
  contactCountry?: Maybe<Scalars['String']>;
  contactEmailAddress?: Maybe<Scalars['String']>;
  contactFax?: Maybe<Scalars['String']>;
  contactFirstName?: Maybe<Scalars['String']>;
  contactLanguage?: Maybe<Scalars['String']>;
  contactLastName?: Maybe<Scalars['String']>;
  contactMiddleInitial?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  contactPhoneExt?: Maybe<Scalars['String']>;
  contactState?: Maybe<Scalars['String']>;
  contactStreet1?: Maybe<Scalars['String']>;
  contactStreet2?: Maybe<Scalars['String']>;
  contactStreetNo?: Maybe<Scalars['String']>;
  contactTitle?: Maybe<Scalars['String']>;
  contactZip?: Maybe<Scalars['String']>;
  countyCode?: Maybe<Scalars['String']>;
  createdByUserId?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  currentRecord?: Maybe<Scalars['Boolean']>;
  dataOrigin?: Maybe<RcraInfoDataOrigin>;
  fedWasteGenerator?: Maybe<RcraInfoFederalWasteGeneratorStatus>;
  fedWasteGeneratorOwner?: Maybe<Scalars['String']>;
  furnaceExemption?: Maybe<Scalars['Boolean']>;
  handlerId: Scalars['String'];
  handlerName?: Maybe<Scalars['String']>;
  hdOwnerOperators: Array<HdOwnerOperator>;
  importerActivity?: Maybe<Scalars['Boolean']>;
  includeInNationalReport?: Maybe<Scalars['Boolean']>;
  landType?: Maybe<RcraInfoLandType>;
  lastChange?: Maybe<Scalars['String']>;
  locationCity?: Maybe<Scalars['String']>;
  locationCountry?: Maybe<Scalars['String']>;
  locationGisOrigin?: Maybe<Scalars['String']>;
  locationGisPrimary?: Maybe<Scalars['Boolean']>;
  locationLatitude?: Maybe<Scalars['Float']>;
  locationLongitude?: Maybe<Scalars['Float']>;
  locationState?: Maybe<Scalars['String']>;
  locationStreet1?: Maybe<Scalars['String']>;
  locationStreet2?: Maybe<Scalars['String']>;
  locationStreetNo?: Maybe<Scalars['String']>;
  locationZip?: Maybe<Scalars['String']>;
  lqhuw?: Maybe<Scalars['Boolean']>;
  mailCity?: Maybe<Scalars['String']>;
  mailCountry?: Maybe<Scalars['String']>;
  mailState?: Maybe<Scalars['String']>;
  mailStreet1?: Maybe<Scalars['String']>;
  mailStreet2?: Maybe<Scalars['String']>;
  mailStreetNo?: Maybe<Scalars['String']>;
  mailZip?: Maybe<Scalars['String']>;
  manifestBroker?: Maybe<Scalars['Boolean']>;
  mixedWasteGenerator?: Maybe<Scalars['Boolean']>;
  nonNotifier?: Maybe<RcraInfoNonNotifier>;
  notes?: Maybe<Scalars['String']>;
  offSiteReceipt?: Maybe<Scalars['Boolean']>;
  onsiteBurnerExemption?: Maybe<Scalars['Boolean']>;
  operatorName?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  receiveDate?: Maybe<Scalars['DateTime']>;
  recognizedTraderExporter?: Maybe<Scalars['Boolean']>;
  recognizedTraderImporter?: Maybe<Scalars['Boolean']>;
  recyclerActivity?: Maybe<Scalars['Boolean']>;
  recyclerActivityNonstorage?: Maybe<Scalars['Boolean']>;
  reportCycle?: Maybe<Scalars['String']>;
  seqNumber: Scalars['Int'];
  shortTermGenerator?: Maybe<Scalars['Boolean']>;
  shortTermGeneratorNotes?: Maybe<Scalars['String']>;
  slabExporter?: Maybe<Scalars['Boolean']>;
  slabImporter?: Maybe<Scalars['Boolean']>;
  sourceType: RcraInfoSourceType;
  stateDistrict?: Maybe<Scalars['String']>;
  stateDistrictOwner?: Maybe<Scalars['String']>;
  stateWasteGenerator?: Maybe<Scalars['String']>;
  stateWasteGeneratorOwner?: Maybe<Scalars['String']>;
  subpartKCollege?: Maybe<Scalars['Boolean']>;
  subpartKHospital?: Maybe<Scalars['Boolean']>;
  subpartKNonprofit?: Maybe<Scalars['Boolean']>;
  subpartKWithdrawal?: Maybe<Scalars['Boolean']>;
  subpartPHealthcare?: Maybe<Scalars['Boolean']>;
  subpartPReverseDistributor?: Maybe<Scalars['Boolean']>;
  subpartPWithdrawal?: Maybe<Scalars['Boolean']>;
  transferFacility?: Maybe<Scalars['Boolean']>;
  transporter?: Maybe<Scalars['Boolean']>;
  tsdActivity?: Maybe<Scalars['Boolean']>;
  undergroundInjectionActivity?: Maybe<Scalars['Boolean']>;
  universalWasteDestFacility?: Maybe<Scalars['Boolean']>;
  usedOilBurner?: Maybe<Scalars['Boolean']>;
  usedOilMarketBurner?: Maybe<Scalars['Boolean']>;
  usedOilProcessor?: Maybe<Scalars['Boolean']>;
  usedOilRefiner?: Maybe<Scalars['Boolean']>;
  usedOilSpecMarketer?: Maybe<Scalars['Boolean']>;
  usedOilTransferFacility?: Maybe<Scalars['Boolean']>;
  usedOilTransporter?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type HdHandlerResult = {
  __typename?: 'HdHandlerResult';
  count: Scalars['Int'];
  items: Array<HdHandler>;
};

export type HdOwnerOperator = {
  __typename?: 'HdOwnerOperator';
  activityLocation: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  dateBecameCurrent?: Maybe<Scalars['DateTime']>;
  dateEndedCurrent?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  handlerId: Scalars['String'];
  ownerOperatorIndicator?: Maybe<RcraInfoOwnerOperatorIndicator>;
  ownerOperatorName?: Maybe<Scalars['String']>;
  ownerOperatorSeq: Scalars['Int'];
  ownerOperatorType?: Maybe<RcraInfoLandType>;
  phone?: Maybe<Scalars['String']>;
  phoneExt?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  seqNumber: Scalars['Int'];
  sourceType: RcraInfoSourceType;
  state?: Maybe<Scalars['String']>;
  street1?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  streetNo?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export enum HealthHazard {
  AcuteToxicity = 'ACUTE_TOXICITY',
  AspirationHazard = 'ASPIRATION_HAZARD',
  Carcinogenic = 'CARCINOGENIC',
  CausesRespiratoryOrSkinSensitization = 'CAUSES_RESPIRATORY_OR_SKIN_SENSITIZATION',
  EyeIrritant = 'EYE_IRRITANT',
  GermCellMutagenic = 'GERM_CELL_MUTAGENIC',
  HazardNotOtherwiseClassifiedHealth = 'HAZARD_NOT_OTHERWISE_CLASSIFIED_HEALTH',
  ReproductiveToxicity = 'REPRODUCTIVE_TOXICITY',
  SimpleAsphyxiant = 'SIMPLE_ASPHYXIANT',
  SkinIrritant = 'SKIN_IRRITANT',
  SpecificTargetOrganToxicity = 'SPECIFIC_TARGET_ORGAN_TOXICITY'
}

export enum InsideOutside {
  Inside = 'INSIDE',
  Outside = 'OUTSIDE'
}

export type InsightsCandidate = {
  __typename?: 'InsightsCandidate';
  echoExporter: SelectedEchoExporterFields;
  facility: Facility;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  job: Job;
  jobId: Scalars['String'];
  matchScore?: Maybe<Scalars['Float']>;
  registryId: Scalars['String'];
  tenant: Tenant;
  tenantId: Scalars['String'];
};

export type InsightsCandidatesResult = {
  __typename?: 'InsightsCandidatesResult';
  count: Scalars['Int'];
  items: Array<InsightsCandidate>;
};

export type InsightsCohort = {
  __typename?: 'InsightsCohort';
  domainSearches: Array<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nameSearches: Array<Scalars['String']>;
  tenantId: Scalars['String'];
};

export type InsightsEchoAllFacilitiesResult = {
  __typename?: 'InsightsEchoAllFacilitiesResult';
  count: Scalars['Int'];
  items: Array<EchoExporterAggregated>;
};

export type InsightsEchoFacilitiesResult = {
  __typename?: 'InsightsEchoFacilitiesResult';
  count: Scalars['Int'];
  items: Array<FacilityEchoExporter>;
};

export type InsightsFacilityMix = {
  __typename?: 'InsightsFacilityMix';
  connectedFacilitiesCount: Scalars['Int'];
  facilitiesCount: Scalars['Int'];
  facilitiesWithMultiplePrograms: Scalars['Int'];
  facilityNaicsTypes: Array<InsightsFacilityNaicsType>;
  filteredFacilitiesCount: Scalars['Int'];
  hasNoGovtIdCount: Scalars['Int'];
  programAreas: Array<InsightsFacilityProgramArea>;
};

export type InsightsFacilityNaicsType = {
  __typename?: 'InsightsFacilityNaicsType';
  count: Scalars['Int'];
  naicsCode: Scalars['String'];
  name: Scalars['String'];
};

export type InsightsFacilityProgramArea = {
  __typename?: 'InsightsFacilityProgramArea';
  count: Scalars['Int'];
  key: Scalars['String'];
};

export type InsightsFilter = {
  naicsCode?: InputMaybe<Scalars['String']>;
  programArea?: InputMaybe<Scalars['String']>;
};

export type InsightsNonCompliance = {
  __typename?: 'InsightsNonCompliance';
  byProgramArea: Array<CountStat>;
  quarterlyByProgramArea: Array<QuarterlyStat>;
  quarterlyBySignificance: Array<QuarterlyStat>;
  violationsByFacility: Array<CountStat>;
};

export type InsightsPenalties = {
  __typename?: 'InsightsPenalties';
  averageCostPerViolation: Scalars['Float'];
  averagePenalties: Scalars['Float'];
  byFacility: Array<InsightsPenalty>;
  byProgramArea: Array<InsightsPenalty>;
  byQuarter: Array<InsightsPenalty>;
  byQuarterByProgramArea: Array<InsightsPenaltyQuarter>;
  totalPenalties: Scalars['Float'];
};

export type InsightsPenalty = {
  __typename?: 'InsightsPenalty';
  cost: Scalars['Float'];
  frsId?: Maybe<Scalars['String']>;
  label: Scalars['String'];
};

export type InsightsPenaltyQuarter = {
  __typename?: 'InsightsPenaltyQuarter';
  programAreas: Array<InsightsPenalty>;
  quarter: Scalars['String'];
};

export type InsightsViolations = {
  __typename?: 'InsightsViolations';
  percentageFacilitiesWithViolation: Scalars['Float'];
  programAreas: Array<Scalars['String']>;
  totalViolations: Scalars['Int'];
  violationsByFacility: Array<InsightsViolationsFacility>;
  violationsByProgramArea: Array<InsightsViolationsProgramArea>;
  violationsByQuarter: Array<InsightsViolationsQuarter>;
};

export type InsightsViolationsFacility = {
  __typename?: 'InsightsViolationsFacility';
  frsId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  totalViolations: Scalars['Int'];
};

export type InsightsViolationsProgramArea = {
  __typename?: 'InsightsViolationsProgramArea';
  name: Scalars['String'];
  totalViolations: Scalars['Int'];
};

export type InsightsViolationsQuarter = {
  __typename?: 'InsightsViolationsQuarter';
  quarter: Scalars['String'];
  violationsByProgramArea: Array<InsightsViolationsProgramArea>;
};

export enum InternationalFireCodeHazard {
  Combustible = 'COMBUSTIBLE',
  Corrosive = 'CORROSIVE',
  Explosive = 'EXPLOSIVE',
  Flammable = 'FLAMMABLE',
  HighlyToxic = 'HIGHLY_TOXIC',
  Inert = 'INERT',
  OrganicPeroxides = 'ORGANIC_PEROXIDES',
  Oxidizing = 'OXIDIZING',
  Pyrophoric = 'PYROPHORIC',
  Radioactive = 'RADIOACTIVE',
  Toxic = 'TOXIC',
  Unstable = 'UNSTABLE',
  WaterReactive = 'WATER_REACTIVE'
}

export enum Inventory {
  Chemical = 'CHEMICAL',
  Product = 'PRODUCT'
}

export type InventoryStatusResult = {
  __typename?: 'InventoryStatusResult';
  exists: Scalars['Boolean'];
  mostRecentYear?: Maybe<Scalars['Int']>;
};

export type Issue = {
  __typename?: 'Issue';
  facilityId?: Maybe<Scalars['String']>;
  jurisdictions?: Maybe<Array<Scalars['String']>>;
  key?: Maybe<Scalars['String']>;
  level: IssueLevel;
  message: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  modelId?: Maybe<Scalars['String']>;
  modelName: Scalars['String'];
  schemaPath?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};

export enum IssueLevel {
  Critical = 'CRITICAL',
  Error = 'ERROR'
}

export type Job = {
  __typename?: 'Job';
  action?: Maybe<WebAutomationAction>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  document?: Maybe<Document>;
  extraction?: Maybe<Scalars['JSON']>;
  extractionKey?: Maybe<Scalars['String']>;
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  insightsCandidates: Array<InsightsCandidate>;
  logs: Array<JobLog>;
  parameters?: Maybe<Scalars['JSON']>;
  payments: Array<Payment>;
  promotedAt?: Maybe<Scalars['DateTime']>;
  reportId?: Maybe<Scalars['ID']>;
  reportingYear?: Maybe<Scalars['Int']>;
  requestId?: Maybe<Scalars['ID']>;
  staffReportDownloadLink?: Maybe<Scalars['String']>;
  staffReportKey?: Maybe<Scalars['String']>;
  stateOrTerritory?: Maybe<Scalars['String']>;
  status: JobStatus;
  stepsDone: Array<JobStepsDone>;
  task?: Maybe<JobTask>;
  taskArn?: Maybe<Scalars['String']>;
  taskUrl?: Maybe<Scalars['String']>;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['String'];
  totalIssues?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type JobLog = {
  __typename?: 'JobLog';
  cloudWatchLogStream?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  errorMessage?: Maybe<Scalars['String']>;
  htmlKey?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobId?: Maybe<Scalars['String']>;
  screenshotKey?: Maybe<Scalars['String']>;
  screenshotUrl?: Maybe<Scalars['String']>;
  status: JobStatus;
  taskArn?: Maybe<Scalars['String']>;
  taskDefinitionArn?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type JobLogsResult = {
  __typename?: 'JobLogsResult';
  count: Scalars['Int'];
  items: Array<JobLog>;
};

export enum JobStatus {
  AwaitingManualIntervention = 'AWAITING_MANUAL_INTERVENTION',
  Cancelled = 'CANCELLED',
  Cancelling = 'CANCELLING',
  Failed = 'FAILED',
  FailedMayAutoRetry = 'FAILED_MAY_AUTO_RETRY',
  FailedNeedsHuman = 'FAILED_NEEDS_HUMAN',
  FailedProvisioningEcsTask = 'FAILED_PROVISIONING_ECS_TASK',
  FailedQualityControlCheck = 'FAILED_QUALITY_CONTROL_CHECK',
  Promoted = 'PROMOTED',
  /** @deprecated use PROVISIONING_ECS_TASK instead */
  Provisioning = 'PROVISIONING',
  ProvisioningEcsTask = 'PROVISIONING_ECS_TASK',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  /** @deprecated use JobStepDone (SendCheckStepDoneName.SEND_CHECK) instead */
  Sent = 'SENT',
  ShouldCancel = 'SHOULD_CANCEL',
  Succeeded = 'SUCCEEDED'
}

export type JobStepsDone = {
  __typename?: 'JobStepsDone';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  jobId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type JobStepsDoneResult = {
  __typename?: 'JobStepsDoneResult';
  count: Scalars['Int'];
  items: Array<JobStepsDone>;
};

export enum JobTask {
  BulkVerifyAndSubmitReports = 'BULK_VERIFY_AND_SUBMIT_REPORTS',
  ChemicalAggregation = 'CHEMICAL_AGGREGATION',
  DataPipeline = 'DATA_PIPELINE',
  EmailDigests = 'EMAIL_DIGESTS',
  ExportData = 'EXPORT_DATA',
  FileExtraction = 'FILE_EXTRACTION',
  GeneratePdf = 'GENERATE_PDF',
  InsightsConnector = 'INSIGHTS_CONNECTOR',
  OneSchemaFileUpload = 'ONE_SCHEMA_FILE_UPLOAD',
  ProcessManifests = 'PROCESS_MANIFESTS',
  PromoteDraftReport = 'PROMOTE_DRAFT_REPORT',
  SendCheck = 'SEND_CHECK',
  StaffReport = 'STAFF_REPORT',
  ValidateTenant = 'VALIDATE_TENANT',
  WebAutomation = 'WEB_AUTOMATION'
}

export type JobsResult = {
  __typename?: 'JobsResult';
  count: Scalars['Int'];
  items: Array<Job>;
};

export type LeadAgency = {
  __typename?: 'LeadAgency';
  address: Scalars['String'];
  attn: Scalars['String'];
  city: Scalars['String'];
  consolidated: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  issueCount?: Maybe<Scalars['Int']>;
  issues: Array<Issue>;
  name: Scalars['String'];
  phone: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type LeadAgencyInput = {
  address: Scalars['String'];
  attn: Scalars['String'];
  city: Scalars['String'];
  consolidated: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type Lepc = {
  __typename?: 'Lepc';
  additionaRequirements?: Maybe<Scalars['String']>;
  additionalComments?: Maybe<Scalars['String']>;
  additionalFees?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  deactivated?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  feeStructure?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCurrent1AsOf2021?: Maybe<Scalars['Boolean']>;
  isEmailed: Scalars['Boolean'];
  isMailed?: Maybe<Scalars['Boolean']>;
  isStateSubmits?: Maybe<Scalars['Boolean']>;
  isSubmittedViaPortal?: Maybe<Scalars['Boolean']>;
  issueCount?: Maybe<Scalars['Int']>;
  issues?: Maybe<Array<Issue>>;
  latitude?: Maybe<Scalars['Float']>;
  leadAgency?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  mailingAddress?: Maybe<Scalars['String']>;
  mailingAddressLine2?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  needsT2sFile?: Maybe<Scalars['Boolean']>;
  needsXmlZipFile?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  portalId?: Maybe<Scalars['String']>;
  portalName?: Maybe<Scalars['String']>;
  requirementDetails?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  submissionNotes?: Maybe<Scalars['String']>;
  t2sValue?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type LepcInput = {
  additionaRequirements?: InputMaybe<Scalars['String']>;
  additionalComments?: InputMaybe<Scalars['String']>;
  additionalFees?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  deactivated?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  feeStructure?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isCurrent1AsOf2021?: InputMaybe<Scalars['Boolean']>;
  isEmailed?: InputMaybe<Scalars['Boolean']>;
  isMailed?: InputMaybe<Scalars['Boolean']>;
  isStateSubmits?: InputMaybe<Scalars['Boolean']>;
  isSubmittedViaPortal?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['Float']>;
  leadAgency?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['Float']>;
  mailingAddress?: InputMaybe<Scalars['String']>;
  mailingAddressLine2?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  needsT2sFile?: InputMaybe<Scalars['Boolean']>;
  needsXmlZipFile?: InputMaybe<Scalars['Boolean']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  portalId?: InputMaybe<Scalars['String']>;
  portalName?: InputMaybe<Scalars['String']>;
  requirementDetails?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  submissionNotes?: InputMaybe<Scalars['String']>;
  t2sValue?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type LepcResult = {
  __typename?: 'LepcResult';
  count?: Maybe<Scalars['Int']>;
  items: Array<Lepc>;
};

export type LinkFacilitiesInput = {
  candidateIds: Array<Scalars['ID']>;
};

export type LobMail = {
  __typename?: 'LobMail';
  id: Scalars['ID'];
  lobId: Scalars['String'];
  lobUrl?: Maybe<Scalars['String']>;
  status?: Maybe<LobMailStatus>;
  type: LobMailType;
};

export enum LobMailStatus {
  Delivered = 'DELIVERED',
  InternationalExit = 'INTERNATIONAL_EXIT',
  InLocalArea = 'IN_LOCAL_AREA',
  InTransit = 'IN_TRANSIT',
  Issue = 'ISSUE',
  Mailed = 'MAILED',
  PickupAvailable = 'PICKUP_AVAILABLE',
  ProcessedForDelivery = 'PROCESSED_FOR_DELIVERY',
  ReturnedToSender = 'RETURNED_TO_SENDER',
  ReRouted = 'RE_ROUTED'
}

export enum LobMailType {
  Check = 'CHECK',
  Letter = 'LETTER'
}

export enum MajorMinorStatusFlag {
  Major = 'MAJOR',
  NonMajor = 'NON_MAJOR'
}

export enum ManageTagsAction {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export type ModelIssue = {
  __typename?: 'ModelIssue';
  dataName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isRevalidating: Scalars['Boolean'];
  message: Scalars['String'];
  modelId: Scalars['String'];
  modelName: Scalars['String'];
  propertyKey: Scalars['String'];
  tenantId: Scalars['ID'];
  validatedAt: Scalars['DateTime'];
};

export type Municipality = {
  __typename?: 'Municipality';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type MunicipalityResult = {
  __typename?: 'MunicipalityResult';
  count: Scalars['Int'];
  items: Array<Municipality>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addFacilityAlternateIds: Scalars['Boolean'];
  bulkUpdateNotReportingReason?: Maybe<BulkUpdateNotReportingReasonResult>;
  bulkVerifyAndSubmitReports: BulkVerifyAndSubmitReportsResult;
  cancelPayment: Payment;
  closeTierIIReport?: Maybe<Scalars['Boolean']>;
  completeTierIIReportReviewStep: TierIiReport;
  conductReport: Scalars['Boolean'];
  copyFacilityChemicals: CopyInventoryResult;
  copyFacilityInventoryForFacilities: BulkCopyInventoryResult;
  copyFacilityProducts: CopyInventoryResult;
  createDemoOrganization: Scalars['Boolean'];
  createInsightsCohort: InsightsCohort;
  createTask?: Maybe<Scalars['Boolean']>;
  createTierIIReport: TierIiReport;
  createTierIIReports: Array<TierIiReport>;
  createUser: User;
  createWebAutomationJobs?: Maybe<WebAutomationJobResult>;
  deleteCandidates: Scalars['Boolean'];
  deleteChemical: Chemical;
  deleteChemicalDocument: DeleteChemicalDocumentResult;
  deleteCredential: Credential;
  deleteDocument: Document;
  deleteFacility: Facility;
  deleteFacilityChemical: FacilityChemical;
  deleteFacilityChemicalMeasurement: FacilityChemicalMeasurement;
  deleteFacilityChemicalMeasurementsByChemicalAndYear?: Maybe<DeleteFacilityChemicalMeasurementsByChemicalAndYearResult>;
  deleteFacilityContact: Scalars['Boolean'];
  deleteFacilityProduct?: Maybe<FacilityProduct>;
  deleteFacilityProductMeasurement: FacilityProductMeasurement;
  deleteFacilityProductMeasurementsByProductAndYear?: Maybe<DeleteFacilityProductMeasurementsByProductAndYearResult>;
  deleteFireDepartment: FireDepartment;
  deleteInsightsCohort: InsightsCohort;
  deleteLeadAgency: LeadAgency;
  deleteLepc: Lepc;
  deletePerson?: Maybe<Person>;
  deletePoliceDepartment: PoliceDepartment;
  deleteProduct: Product;
  deleteTask?: Maybe<Scalars['Boolean']>;
  devtoolsResetReport?: Maybe<Scalars['Boolean']>;
  devtoolsResetReportsForTenant: DevtoolsReportsForTenantResult;
  emailReviewers: EmailReviewersResult;
  exportFulfillmentGridToCsv: ExportFulfillmentGridToCsvResult;
  generateInsightsCandidates: Scalars['Boolean'];
  generateInsightsCandidatesFromAlternateIds: InsightsCandidatesResult;
  generatePresignedUrl: GeneratePresignedUrlResult;
  generateStaffReport: Job;
  generateSubmissionZip: GenerateSubmissionZipResult;
  generateT2S: Scalars['String'];
  generateTierIIPdfPreview: GenerateTierIiPdfPreviewResult;
  importT2sFile: Array<Job>;
  linkFacilities: Scalars['Boolean'];
  manageTierIIReportsTags: Array<TierIiReport>;
  markAsReporting?: Maybe<Scalars['Boolean']>;
  mergeChemicals?: Maybe<Chemical>;
  mergePeople?: Maybe<Person>;
  processOneschemaFileUpload: ProcessOneschemaFileUploadResult;
  promoteDraftReport?: Maybe<Scalars['Boolean']>;
  queueSdsParsingJobs: Array<Job>;
  recordLobFee: Payment;
  removeDocumentFromActivity: ActivityDocument;
  removeTierIIReportAssignees: Array<TierIiReport>;
  removeTierIIReportReviewers: Array<TierIiReport>;
  replacePersonFacilityAssociations?: Maybe<Scalars['Boolean']>;
  requeueActivities: RequeueActivitiesResult;
  resendInvitationToUser: Scalars['Boolean'];
  resetEmulatedRole: Scalars['Boolean'];
  resetReport: Scalars['ID'];
  sendLobCheck: Payment;
  setCollectionMode?: Maybe<SetCollectionModeResult>;
  setEmulatedRole: Scalars['Boolean'];
  setInReviewStatus: TierIiReport;
  setIsAlwaysReportedOnReportingFacilityChemical: ReportingFacilityChemical;
  setReviewComplete: TierIiReport;
  setTierIIReportAssignees: Array<TierIiReport>;
  setTierIIReportReviewers: Array<TierIiReport>;
  setUserTenant: Scalars['Boolean'];
  setValueOnActivityUserInput: ActivityUserInput;
  splitChemical: Array<Chemical>;
  splitPerson: Array<Person>;
  touchTierIIReportStep: Scalars['Boolean'];
  unverifyChemical?: Maybe<Scalars['Boolean']>;
  unverifyChemicals?: Maybe<Scalars['Boolean']>;
  updateActivities: Array<Activity>;
  updateActivity: Activity;
  updateDocument: Document;
  updateFacilities: Array<Facility>;
  updateFacility?: Maybe<Facility>;
  updateInsightsCohort: InsightsCohort;
  updateNotesToRegulators: TierIiReport;
  updateTaskRecurring?: Maybe<VirtualEvent>;
  updateTaskSingle?: Maybe<VirtualEvent>;
  updateTierIIReport: TierIiReport;
  updateTierIIReportVerifier: TierIiReport;
  updateUser: User;
  updateWebAutomationJobs?: Maybe<WebAutomationJobResult>;
  upsertChemical: Chemical;
  upsertComment: Comment;
  upsertCredential: Credential;
  upsertFacilityChemical: FacilityChemical;
  upsertFacilityChemicalMeasurement?: Maybe<FacilityChemicalMeasurement>;
  upsertFacilityChemicalStateField?: Maybe<FacilityChemicalStateField>;
  upsertFacilityChemicalStateFields?: Maybe<Array<Maybe<FacilityChemicalStateField>>>;
  upsertFacilityContact?: Maybe<FacilityContact>;
  upsertFacilityProduct: FacilityProduct;
  upsertFacilityProductMeasurement?: Maybe<FacilityProductMeasurement>;
  upsertFireDepartment: FireDepartment;
  upsertLeadAgency: LeadAgency;
  upsertLepc: Lepc;
  upsertPayment: Payment;
  upsertPerson: Person;
  upsertPoliceDepartment: PoliceDepartment;
  upsertProduct: Product;
  upsertTenant: Tenant;
  upsertUserFacilitiesForTenant: UpsertUserFacilitiesForTenantResult;
  verifyChemical?: Maybe<Chemical>;
  verifyChemicals?: Maybe<Scalars['Boolean']>;
  verifyCredential: VerifyCredentialResult;
  verifyCredentials: VerifyCredentialsResult;
  workflowManagerScheduleEvent: Scalars['Boolean'];
};


export type MutationAddFacilityAlternateIdsArgs = {
  alternateIds: Array<AlternateIdInput>;
  facilityId: Scalars['ID'];
};


export type MutationBulkUpdateNotReportingReasonArgs = {
  input: NotReportingReasonInput;
};


export type MutationBulkVerifyAndSubmitReportsArgs = {
  reportIds: Array<Scalars['ID']>;
  verifier: TierIiReportVerifierInput;
};


export type MutationCancelPaymentArgs = {
  id: Scalars['ID'];
};


export type MutationCloseTierIiReportArgs = {
  tierIIReportId: Scalars['ID'];
};


export type MutationCompleteTierIiReportReviewStepArgs = {
  reportId: Scalars['ID'];
};


export type MutationConductReportArgs = {
  reportId: Scalars['ID'];
};


export type MutationCopyFacilityChemicalsArgs = {
  facilityId: Scalars['ID'];
  fromYear?: InputMaybe<Scalars['Int']>;
  toYear: Scalars['Int'];
};


export type MutationCopyFacilityInventoryForFacilitiesArgs = {
  facilityIds: Array<Scalars['ID']>;
  toYear: Scalars['Int'];
};


export type MutationCopyFacilityProductsArgs = {
  facilityId: Scalars['ID'];
  fromYear?: InputMaybe<Scalars['Int']>;
  toYear: Scalars['Int'];
};


export type MutationCreateDemoOrganizationArgs = {
  input: DemoOrganizationInput;
};


export type MutationCreateInsightsCohortArgs = {
  domainSearches?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  nameSearches?: InputMaybe<Array<Scalars['String']>>;
  tenantId: Scalars['String'];
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


export type MutationCreateTierIiReportArgs = {
  facilityId: Scalars['ID'];
  reportKind: TierIiReportKind;
  reportingYear: Scalars['Int'];
};


export type MutationCreateTierIiReportsArgs = {
  facilityIds: Array<Scalars['ID']>;
  reportKind: TierIiReportKind;
  reportingYear: Scalars['Int'];
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateWebAutomationJobsArgs = {
  input: Array<CreateWebAutomationJobInput>;
};


export type MutationDeleteCandidatesArgs = {
  input: DeleteCandidatesInput;
};


export type MutationDeleteChemicalArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteChemicalDocumentArgs = {
  input: DeleteChemicalDocumentInput;
};


export type MutationDeleteCredentialArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['ID'];
  retainAsset?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDeleteFacilityArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFacilityChemicalArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFacilityChemicalMeasurementArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFacilityChemicalMeasurementsByChemicalAndYearArgs = {
  addZeroMeasurement?: InputMaybe<Scalars['Boolean']>;
  chemicalId: Scalars['ID'];
  facilityId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};


export type MutationDeleteFacilityContactArgs = {
  facilityContactId: Scalars['ID'];
};


export type MutationDeleteFacilityProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFacilityProductMeasurementArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFacilityProductMeasurementsByProductAndYearArgs = {
  facilityId: Scalars['ID'];
  productId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};


export type MutationDeleteFireDepartmentArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteInsightsCohortArgs = {
  id: Scalars['String'];
};


export type MutationDeleteLeadAgencyArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationDeleteLepcArgs = {
  id: Scalars['String'];
};


export type MutationDeletePersonArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePoliceDepartmentArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationDeleteProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTaskArgs = {
  input: EventMutationInput;
};


export type MutationDevtoolsResetReportArgs = {
  id: Scalars['ID'];
};


export type MutationDevtoolsResetReportsForTenantArgs = {
  input: DevtoolsReportsForTenantInput;
};


export type MutationEmailReviewersArgs = {
  reportId: Scalars['ID'];
};


export type MutationExportFulfillmentGridToCsvArgs = {
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type MutationGenerateInsightsCandidatesArgs = {
  input: GenerateInsightsCandidatesInput;
};


export type MutationGenerateInsightsCandidatesFromAlternateIdsArgs = {
  tenantId: Scalars['ID'];
};


export type MutationGeneratePresignedUrlArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  directory?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['ID']>;
  fileName: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationGenerateStaffReportArgs = {
  reportType: StaffReportType;
  reportingYear: Scalars['Int'];
  tenantId?: InputMaybe<Scalars['String']>;
};


export type MutationGenerateSubmissionZipArgs = {
  zipArgs: GenerateSubmissionZipArgs;
};


export type MutationGenerateT2SArgs = {
  reportId: Scalars['ID'];
};


export type MutationGenerateTierIiPdfPreviewArgs = {
  attachSitePlan?: InputMaybe<Scalars['Boolean']>;
  tierIIReportId: Scalars['ID'];
};


export type MutationImportT2sFileArgs = {
  input: T2sImportInput;
};


export type MutationLinkFacilitiesArgs = {
  input: LinkFacilitiesInput;
};


export type MutationManageTierIiReportsTagsArgs = {
  action: ManageTagsAction;
  tags: Array<Scalars['String']>;
  tierIIReportIds: Array<Scalars['ID']>;
};


export type MutationMarkAsReportingArgs = {
  facilityIds: Array<Scalars['ID']>;
};


export type MutationMergeChemicalsArgs = {
  ids: Array<Scalars['ID']>;
  input: ChemicalInput;
};


export type MutationMergePeopleArgs = {
  input: PersonInput;
  mergedPeopleIds: Array<Scalars['ID']>;
};


export type MutationProcessOneschemaFileUploadArgs = {
  input: ProcessOneschemaFileUploadInput;
};


export type MutationPromoteDraftReportArgs = {
  webAutomationJobId: Scalars['ID'];
};


export type MutationQueueSdsParsingJobsArgs = {
  input: CreateChemicalsFromSdsInput;
};


export type MutationRecordLobFeeArgs = {
  input: RecordLobFeeInput;
};


export type MutationRemoveDocumentFromActivityArgs = {
  activityId: Scalars['ID'];
  documentId: Scalars['ID'];
};


export type MutationRemoveTierIiReportAssigneesArgs = {
  assigneeIds: Array<Scalars['ID']>;
  tierIIReportIds: Array<Scalars['ID']>;
};


export type MutationRemoveTierIiReportReviewersArgs = {
  reviewerIds: Array<Scalars['ID']>;
  tierIIReportIds: Array<Scalars['ID']>;
};


export type MutationReplacePersonFacilityAssociationsArgs = {
  newPersonId: Scalars['ID'];
  oldPersonId: Scalars['ID'];
  reportingRoles?: InputMaybe<Array<ContactReportRole>>;
};


export type MutationRequeueActivitiesArgs = {
  activityIds: Array<Scalars['ID']>;
};


export type MutationResendInvitationToUserArgs = {
  email: Scalars['String'];
};


export type MutationResetReportArgs = {
  inputs: ResetReportInput;
};


export type MutationSendLobCheckArgs = {
  input: SendLobCheckInput;
};


export type MutationSetCollectionModeArgs = {
  collectionMode?: InputMaybe<CollectionMode>;
  facilityIds: Array<Scalars['ID']>;
};


export type MutationSetEmulatedRoleArgs = {
  permissions: Array<Permission>;
  tenantId: Scalars['String'];
};


export type MutationSetInReviewStatusArgs = {
  id: Scalars['ID'];
  inReview: Scalars['Boolean'];
};


export type MutationSetIsAlwaysReportedOnReportingFacilityChemicalArgs = {
  id: Scalars['ID'];
  isAlwaysReported?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSetReviewCompleteArgs = {
  id: Scalars['ID'];
  reviewComplete: Scalars['Boolean'];
};


export type MutationSetTierIiReportAssigneesArgs = {
  assigneeIds: Array<Scalars['ID']>;
  tierIIReportIds: Array<Scalars['ID']>;
};


export type MutationSetTierIiReportReviewersArgs = {
  reviewerIds: Array<Scalars['ID']>;
  tierIIReportIds: Array<Scalars['ID']>;
};


export type MutationSetUserTenantArgs = {
  tenantId: Scalars['ID'];
};


export type MutationSetValueOnActivityUserInputArgs = {
  id: Scalars['ID'];
  value: Scalars['String'];
};


export type MutationSplitChemicalArgs = {
  id: Scalars['ID'];
};


export type MutationSplitPersonArgs = {
  id: Scalars['ID'];
};


export type MutationTouchTierIiReportStepArgs = {
  reportId: Scalars['ID'];
  step: TierIiReportStep;
};


export type MutationUnverifyChemicalArgs = {
  chemicalId: Scalars['ID'];
};


export type MutationUnverifyChemicalsArgs = {
  chemicalIds: Array<Scalars['ID']>;
};


export type MutationUpdateActivitiesArgs = {
  ids: Array<Scalars['ID']>;
  input: ActivityInput;
};


export type MutationUpdateActivityArgs = {
  id: Scalars['ID'];
  input: ActivityInput;
};


export type MutationUpdateDocumentArgs = {
  id: Scalars['ID'];
  input: DocumentInput;
};


export type MutationUpdateFacilitiesArgs = {
  facility: FacilityInput;
  ids: Array<Scalars['ID']>;
};


export type MutationUpdateFacilityArgs = {
  facility: FacilityInput;
  id: Scalars['ID'];
  reportId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateInsightsCohortArgs = {
  domainSearches?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  nameSearches?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationUpdateNotesToRegulatorsArgs = {
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateTaskRecurringArgs = {
  input: UpdateTaskRecurringInput;
};


export type MutationUpdateTaskSingleArgs = {
  input: UpdateTaskSingleInput;
};


export type MutationUpdateTierIiReportArgs = {
  input: TierIiReportUpdateInput;
  tierIIReportId: Scalars['ID'];
};


export type MutationUpdateTierIiReportVerifierArgs = {
  reportId: Scalars['ID'];
  verifier: TierIiReportVerifier;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateWebAutomationJobsArgs = {
  ids: Array<Scalars['ID']>;
  input: UpdateWebAutomationJobInput;
};


export type MutationUpsertChemicalArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: ChemicalInput;
};


export type MutationUpsertCommentArgs = {
  input: CommentInput;
};


export type MutationUpsertCredentialArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: CredentialInput;
};


export type MutationUpsertFacilityChemicalArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: FacilityChemicalInput;
  reportId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpsertFacilityChemicalMeasurementArgs = {
  id: Scalars['ID'];
  input: FacilityChemicalMeasurementInput;
};


export type MutationUpsertFacilityChemicalStateFieldArgs = {
  input: FacilityChemicalStateFieldInput;
};


export type MutationUpsertFacilityChemicalStateFieldsArgs = {
  chemicalId: Scalars['ID'];
  facilityId: Scalars['ID'];
  input: Array<FacilityChemicalStateFieldInput>;
  reportingYear: Scalars['Int'];
  type: ProgramArea;
};


export type MutationUpsertFacilityContactArgs = {
  data: FacilityContactInput;
  programArea?: InputMaybe<ProgramArea>;
};


export type MutationUpsertFacilityProductArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: FacilityProductInput;
};


export type MutationUpsertFacilityProductMeasurementArgs = {
  id: Scalars['ID'];
  input: FacilityProductMeasurementInput;
};


export type MutationUpsertFireDepartmentArgs = {
  id?: InputMaybe<Scalars['String']>;
  input: FireDepartmentInput;
};


export type MutationUpsertLeadAgencyArgs = {
  id?: InputMaybe<Scalars['Int']>;
  input: LeadAgencyInput;
};


export type MutationUpsertLepcArgs = {
  id?: InputMaybe<Scalars['String']>;
  input: LepcInput;
};


export type MutationUpsertPaymentArgs = {
  input: PaymentInput;
};


export type MutationUpsertPersonArgs = {
  input: PersonFacilityContactsInput;
};


export type MutationUpsertPoliceDepartmentArgs = {
  id?: InputMaybe<Scalars['Int']>;
  input: PoliceDepartmentInput;
};


export type MutationUpsertProductArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: ProductInput;
};


export type MutationUpsertTenantArgs = {
  input: TenantInput;
};


export type MutationUpsertUserFacilitiesForTenantArgs = {
  facilityIds: Array<Scalars['ID']>;
  tenantId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationVerifyChemicalArgs = {
  chemicalId: Scalars['ID'];
};


export type MutationVerifyChemicalsArgs = {
  chemicalIds: Array<Scalars['ID']>;
};


export type MutationVerifyCredentialArgs = {
  input: VerifyCredentialInput;
};


export type MutationVerifyCredentialsArgs = {
  input: Array<VerifyCredentialInput>;
};

export type MyReportStatus = {
  __typename?: 'MyReportStatus';
  inProgress: MyReportStatusItem;
  inReview: MyReportStatusItem;
  notReporting: MyReportStatusItem;
  notStarted: MyReportStatusItem;
  submittedToEncamp: MyReportStatusItem;
};

export type MyReportStatusItem = {
  __typename?: 'MyReportStatusItem';
  count: Scalars['Int'];
  percent: Scalars['Float'];
};

export type MyTierIiFacilityResult = {
  __typename?: 'MyTierIIFacilityResult';
  myAssignedFacilityCount: Scalars['Int'];
  myAuthorizedFacilityCount: Scalars['Int'];
  myNonReportingFacilityCount: Scalars['Int'];
  myReportingFacilityCount: Scalars['Int'];
  totalFacilityCount: Scalars['Int'];
};

export enum NotReportingReason {
  Closed = 'CLOSED',
  CoLocated = 'CO_LOCATED',
  Inactive = 'INACTIVE',
  NotWithEncamp = 'NOT_WITH_ENCAMP',
  UnderThreshold = 'UNDER_THRESHOLD'
}

export type NotReportingReasonInput = {
  coLocatedId?: InputMaybe<Scalars['ID']>;
  dateClosed?: InputMaybe<Scalars['Date']>;
  dateInactive?: InputMaybe<Scalars['Date']>;
  facilityIds: Array<Scalars['ID']>;
  reason: NotReportingReason;
};

export type NpdesDetailResult = {
  __typename?: 'NpdesDetailResult';
  facility?: Maybe<NpdesFacility>;
  permits: Array<NpdesPermit>;
};

export type NpdesFacility = {
  __typename?: 'NpdesFacility';
  city?: Maybe<Scalars['String']>;
  countyCode?: Maybe<Scalars['String']>;
  facilityName?: Maybe<Scalars['String']>;
  facilityTypeCode?: Maybe<FacilityTypeCode>;
  facilityUin?: Maybe<Scalars['String']>;
  geocodeLatitude?: Maybe<Scalars['Float']>;
  geocodeLongitude?: Maybe<Scalars['Float']>;
  icisFacilityInterestId: Scalars['String'];
  impairedWaters?: Maybe<Scalars['String']>;
  locationAddress?: Maybe<Scalars['String']>;
  npdesId?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  supplementalAddressText?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type NpdesFacilityResult = {
  __typename?: 'NpdesFacilityResult';
  count: Scalars['Int'];
  items: Array<NpdesFacility>;
};

export type NpdesPermit = {
  __typename?: 'NpdesPermit';
  activityId?: Maybe<Scalars['String']>;
  actualAverageFlowNmbr?: Maybe<Scalars['Float']>;
  agencyTypeCode?: Maybe<AgencyTypeCode>;
  dmrNonReceiptFlag?: Maybe<Scalars['Boolean']>;
  edmrAuthorizationFlag?: Maybe<Scalars['Boolean']>;
  effectiveDate?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  externalPermitNmbr?: Maybe<Scalars['String']>;
  facilityTypeIndicator?: Maybe<FacilityTypeIndicator>;
  issueDate?: Maybe<Scalars['DateTime']>;
  issuingAgency?: Maybe<Scalars['String']>;
  majorMinorStatusFlag?: Maybe<MajorMinorStatusFlag>;
  masterExternalPermitNmbr?: Maybe<Scalars['String']>;
  originalIssueDate?: Maybe<Scalars['DateTime']>;
  permitCompStatusFlag?: Maybe<Scalars['Boolean']>;
  permitName?: Maybe<Scalars['String']>;
  permitStatusCode?: Maybe<PermitStatusCode>;
  permitTypeCode?: Maybe<PermitTypeCode>;
  pretreatmentIndicatorCode?: Maybe<PretreatmentIndicatorCode>;
  radWbdHuc12s?: Maybe<Scalars['String']>;
  retirementDate?: Maybe<Scalars['DateTime']>;
  rncTrackingFlag?: Maybe<Scalars['Boolean']>;
  stateWaterBody?: Maybe<Scalars['String']>;
  stateWaterBodyName?: Maybe<Scalars['String']>;
  terminationDate?: Maybe<Scalars['DateTime']>;
  tmdlInterfaceFlag?: Maybe<Scalars['Boolean']>;
  totalDesignFlowNmbr?: Maybe<Scalars['Float']>;
  versionNmbr?: Maybe<Scalars['Int']>;
};

export enum OregonHazard {
  InfectiousOrEtiologic = 'INFECTIOUS_OR_ETIOLOGIC',
  PoisonousGas = 'POISONOUS_GAS',
  PoisonousMaterial = 'POISONOUS_MATERIAL',
  Radioactive = 'RADIOACTIVE'
}

export type OutstandingReviewer = {
  __typename?: 'OutstandingReviewer';
  email: Scalars['String'];
  first: Scalars['String'];
  last: Scalars['String'];
  reportCount: Scalars['Int'];
  userId: Scalars['ID'];
};

export type OutstandingReviewsResult = {
  __typename?: 'OutstandingReviewsResult';
  reportsWithoutReviewerCount: Scalars['Int'];
  reviewers: Array<OutstandingReviewer>;
};

export type PaginationMetadata = {
  __typename?: 'PaginationMetadata';
  endCursor?: Maybe<Scalars['String']>;
  startCursor?: Maybe<Scalars['String']>;
  totalItemCount: Scalars['Int'];
};

export enum Payee {
  Fd = 'FD',
  Lepc = 'LEPC',
  Rcra = 'RCRA',
  Serc = 'SERC'
}

export type Payment = {
  __typename?: 'Payment';
  activityId?: Maybe<Scalars['ID']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  document?: Maybe<Document>;
  facilities?: Maybe<Array<FacilityPayment>>;
  id: Scalars['ID'];
  job?: Maybe<Job>;
  lobMail?: Maybe<LobMail>;
  memo?: Maybe<Scalars['String']>;
  paidAt: Scalars['DateTime'];
  payee?: Maybe<Scalars['String']>;
  payeeType?: Maybe<Payee>;
  paymentInvoices?: Maybe<Array<PaymentInvoice>>;
  paymentMethod?: Maybe<PaymentMethod>;
  recordedByEmail?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status: PaymentStatus;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['ID'];
  tierIIReports?: Maybe<Array<TierIiReportPayment>>;
  zip?: Maybe<Scalars['String']>;
};

export type PaymentAssociation = {
  amount: Scalars['Float'];
  facilityId?: InputMaybe<Scalars['ID']>;
  reportId?: InputMaybe<Scalars['ID']>;
};

export type PaymentInput = {
  activityId?: InputMaybe<Scalars['ID']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  amount: Scalars['Float'];
  associations: Array<PaymentAssociation>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  documentId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  invoiceDocumentId: Scalars['ID'];
  invoiceNumber?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  paidAt: Scalars['String'];
  payee: Scalars['String'];
  payeeType: Payee;
  paymentMethod: PaymentMethod;
  state?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  zip?: InputMaybe<Scalars['String']>;
};

export type PaymentInvoice = {
  __typename?: 'PaymentInvoice';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceDocument?: Maybe<Document>;
  invoiceNumber?: Maybe<Scalars['String']>;
  payee?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
};

export enum PaymentMethod {
  Ach = 'ACH',
  Check = 'CHECK',
  CreditCard = 'CREDIT_CARD',
  NoPayment = 'NO_PAYMENT'
}

export enum PaymentStatus {
  AwaitingInvoice = 'AWAITING_INVOICE',
  Cancelled = 'CANCELLED',
  Failure = 'FAILURE',
  NoPayment = 'NO_PAYMENT',
  Paid = 'PAID',
  Pending = 'PENDING',
  QueuedForAutomation = 'QUEUED_FOR_AUTOMATION',
  Void = 'VOID'
}

export type PaymentsResult = {
  __typename?: 'PaymentsResult';
  count: Scalars['Int'];
  items: Array<Payment>;
};

export type PeopleResult = {
  __typename?: 'PeopleResult';
  count: Scalars['Int'];
  items: Array<Person>;
};

export enum Permission {
  CreateDataCollectionTask = 'CreateDataCollectionTask',
  CreateFacility = 'CreateFacility',
  CreateUserTenant = 'CreateUserTenant',
  EditOwnFacilityPermissions = 'EditOwnFacilityPermissions',
  EditOwnFacilityPermissionsUnlimited = 'EditOwnFacilityPermissionsUnlimited',
  FulfillDataCollectionTask = 'FulfillDataCollectionTask',
  ReadAllFacility = 'ReadAllFacility',
  ReadAllFacilityMinimal = 'ReadAllFacilityMinimal',
  ReadAllUserTenant = 'ReadAllUserTenant',
  ReadFacilityContact = 'ReadFacilityContact',
  ReadOrgEventSequences = 'ReadOrgEventSequences',
  ReadPerson = 'ReadPerson',
  ReadRole = 'ReadRole',
  ReadSystemAuditLog = 'ReadSystemAuditLog',
  ReadUserActivityLog = 'ReadUserActivityLog',
  ReadUserTenantRole = 'ReadUserTenantRole',
  RouteCalendar = 'RouteCalendar',
  RouteContacts = 'RouteContacts',
  RouteDocuments = 'RouteDocuments',
  RouteEpcra = 'RouteEPCRA',
  RouteEpcraCredentials = 'RouteEPCRACredentials',
  RouteEpcraOverview = 'RouteEPCRAOverview',
  RouteEpcraProducts = 'RouteEPCRAProducts',
  RouteEpcraReports = 'RouteEPCRAReports',
  RouteEpcraTierIi = 'RouteEPCRATierII',
  RouteFacilities = 'RouteFacilities',
  RouteInsights = 'RouteInsights',
  RouteRcra = 'RouteRCRA',
  VerifyTierIiReport = 'VerifyTierIIReport',
  WriteAllCalendarEvent = 'WriteAllCalendarEvent',
  WriteAllFacility = 'WriteAllFacility',
  WriteAllUserTenant = 'WriteAllUserTenant',
  WriteDataCollectionTask = 'WriteDataCollectionTask',
  WriteDataCollectionTaskTemplate = 'WriteDataCollectionTaskTemplate',
  WriteFacilityContact = 'WriteFacilityContact',
  WriteOrgEventSequences = 'WriteOrgEventSequences',
  WritePerson = 'WritePerson',
  WriteRole = 'WriteRole',
  WriteUserTenantRole = 'WriteUserTenantRole'
}

export enum PermitStatusCode {
  AdministrativelyContinued = 'ADMINISTRATIVELY_CONTINUED',
  Effective = 'EFFECTIVE',
  Expired = 'EXPIRED',
  NotNeeded = 'NOT_NEEDED',
  Pending = 'PENDING',
  Retired = 'RETIRED',
  Terminated = 'TERMINATED'
}

export enum PermitTypeCode {
  AssociatedPermitRecord = 'ASSOCIATED_PERMIT_RECORD',
  GeneralPermitCoveredFacility = 'GENERAL_PERMIT_COVERED_FACILITY',
  IndividualIuPermitNonNpdes = 'INDIVIDUAL_IU_PERMIT_NON_NPDES',
  IndividualStateIssuedPermitNonNpdes = 'INDIVIDUAL_STATE_ISSUED_PERMIT_NON_NPDES',
  NpdesIndividualPermit = 'NPDES_INDIVIDUAL_PERMIT',
  NpdesMasterGeneralPermit = 'NPDES_MASTER_GENERAL_PERMIT',
  StateIssuedMasterGeneralPermitNonNpdes = 'STATE_ISSUED_MASTER_GENERAL_PERMIT_NON_NPDES',
  UnpermittedFacility = 'UNPERMITTED_FACILITY'
}

export type Person = {
  __typename?: 'Person';
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facilityContacts?: Maybe<Array<FacilityContact>>;
  first?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  issues?: Maybe<Array<Issue>>;
  last?: Maybe<Scalars['String']>;
  phones?: Maybe<Array<Phone>>;
  state?: Maybe<Scalars['String']>;
  streetAddress1?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
  tankOwnerType?: Maybe<TankOwnerType>;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  zip?: Maybe<Scalars['String']>;
};

export type PersonFacilitiesResult = {
  __typename?: 'PersonFacilitiesResult';
  count: Scalars['Int'];
  items: Array<Facility>;
};

export type PersonFacilityContactRolesInput = {
  facilityId: Scalars['ID'];
  reportingRoles: Array<ContactReportRole>;
};

export type PersonFacilityContactsInput = {
  facilityContactInput: Array<PersonFacilityContactRolesInput>;
  person: PersonInput;
};

export type PersonInput = {
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Array<PhoneInput>>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress1?: InputMaybe<Scalars['String']>;
  streetAddress2?: InputMaybe<Scalars['String']>;
  tankOwnerType?: InputMaybe<TankOwnerType>;
  tenantId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type Phone = {
  __typename?: 'Phone';
  number?: Maybe<Scalars['String']>;
  type: PhoneType;
};

export type PhoneInput = {
  number?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PhoneType>;
};

export enum PhoneType {
  Cell = 'CELL',
  Emergency = 'EMERGENCY',
  Fax = 'FAX',
  Home = 'HOME',
  Hrs_24 = 'HRS_24',
  Work = 'WORK'
}

export enum PhysicalHazard {
  CombustibleDust = 'COMBUSTIBLE_DUST',
  CompressedGas = 'COMPRESSED_GAS',
  CorrosiveToMetal = 'CORROSIVE_TO_METAL',
  Explosive = 'EXPLOSIVE',
  Flammable = 'FLAMMABLE',
  FlammableWithWater = 'FLAMMABLE_WITH_WATER',
  OrganicPeroxide = 'ORGANIC_PEROXIDE',
  Oxidizer = 'OXIDIZER',
  PyrophoricGas = 'PYROPHORIC_GAS',
  PyrophoricSolidOrLiquid = 'PYROPHORIC_SOLID_OR_LIQUID',
  SelfHeating = 'SELF_HEATING',
  SelfReactive = 'SELF_REACTIVE',
  UnclassifiedPhysicalHazard = 'UNCLASSIFIED_PHYSICAL_HAZARD'
}

export type PoliceDepartment = {
  __typename?: 'PoliceDepartment';
  additionalComments?: Maybe<Scalars['String']>;
  address: Scalars['String'];
  attn?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  contactName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  issueCount?: Maybe<Scalars['Int']>;
  issues: Array<Issue>;
  name: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type PoliceDepartmentForValidation = {
  additionalComments?: InputMaybe<Scalars['String']>;
  address: Scalars['String'];
  attn?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  contactName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type PoliceDepartmentInput = {
  additionalComments?: InputMaybe<Scalars['String']>;
  address: Scalars['String'];
  attn?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  contactName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type PoliceDepartmentResult = {
  __typename?: 'PoliceDepartmentResult';
  count: Scalars['Int'];
  items: Array<PoliceDepartment>;
};

export type PortalCredential = {
  __typename?: 'PortalCredential';
  credential?: Maybe<Credential>;
  type?: Maybe<PortalType>;
  url?: Maybe<Scalars['String']>;
};

export enum PortalType {
  EPlan = 'EPlan',
  Tier2Manager = 'Tier2Manager'
}

export enum Pressure {
  AmbientPressure = 'AMBIENT_PRESSURE',
  GreaterThanAmbientPressure = 'GREATER_THAN_AMBIENT_PRESSURE',
  LessThanAmbientPressure = 'LESS_THAN_AMBIENT_PRESSURE',
  Other = 'OTHER'
}

export enum PretreatmentIndicatorCode {
  Approved = 'APPROVED',
  Covered = 'COVERED',
  Epa = 'EPA',
  RequiredAndDeveloping = 'REQUIRED_AND_DEVELOPING',
  State = 'STATE'
}

export type ProcessOneschemaFileUploadInput = {
  processingFunction: ProcessingFunction;
  tenantId: Scalars['ID'];
  url: Scalars['String'];
};

export type ProcessOneschemaFileUploadResult = {
  __typename?: 'ProcessOneschemaFileUploadResult';
  result: Scalars['String'];
};

export type ProcessedManifestSummary = {
  __typename?: 'ProcessedManifestSummary';
  displayedManifestId?: Maybe<Scalars['String']>;
  epaId?: Maybe<Scalars['String']>;
  facilityName?: Maybe<Scalars['String']>;
  hasEManifest?: Maybe<Scalars['Boolean']>;
  hasIssues?: Maybe<Scalars['Boolean']>;
  hasIssuesReason?: Maybe<Array<HasIssuesReason>>;
  hasVendorManifest?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  manifestTrackingNumber?: Maybe<Scalars['String']>;
  shippedDate?: Maybe<Scalars['DateTime']>;
  vendor?: Maybe<WasteManifestSource>;
  wasteLines: WasteManifestLineItemsResult;
};

export enum ProcessingFunction {
  CleanEarth = 'cleanEarth',
  CleanHarbors = 'cleanHarbors',
  Republic = 'republic',
  UsEcology = 'usEcology',
  WasteManifest = 'wasteManifest'
}

export type Product = {
  __typename?: 'Product';
  alternateId?: Maybe<Scalars['String']>;
  facilityProductMeasurementCount?: Maybe<Scalars['Int']>;
  facilityProductMeasurements?: Maybe<Array<FacilityProductMeasurement>>;
  facilityProducts?: Maybe<Array<FacilityProduct>>;
  id: Scalars['ID'];
  issues: Array<Issue>;
  name: Scalars['String'];
  productChemicals?: Maybe<Array<ProductChemical>>;
  productTenants?: Maybe<Array<ProductTenant>>;
  reference?: Maybe<Scalars['String']>;
};


export type ProductFacilityProductMeasurementCountArgs = {
  facilityId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};


export type ProductFacilityProductsArgs = {
  facilityId?: InputMaybe<Scalars['ID']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
};

export type ProductChemical = {
  __typename?: 'ProductChemical';
  amount: Scalars['Float'];
  chemical: Chemical;
  chemicalId: Scalars['ID'];
  id: Scalars['ID'];
  otherPressureValue?: Maybe<Scalars['String']>;
  overrides: Array<ProductChemicalOverride>;
  pressure?: Maybe<Pressure>;
  product: Product;
  productId: Scalars['ID'];
  storageType?: Maybe<Scalars['String']>;
  storageTypeDescription?: Maybe<Scalars['String']>;
  temperature?: Maybe<Temperature>;
  unit: UnitType;
};

export type ProductChemicalBreakdown = {
  __typename?: 'ProductChemicalBreakdown';
  chemicalMaxAmount?: Maybe<AmountWithUnit>;
  productMaxAmount?: Maybe<AmountWithUnit>;
};

export type ProductChemicalInput = {
  amount?: InputMaybe<Scalars['Float']>;
  chemicalId?: InputMaybe<Scalars['ID']>;
  otherPressureValue?: InputMaybe<Scalars['String']>;
  overrides: Array<ProductChemicalOverrideInput>;
  pressure?: InputMaybe<Pressure>;
  productId?: InputMaybe<Scalars['ID']>;
  storageType?: InputMaybe<Scalars['String']>;
  storageTypeDescription?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Temperature>;
  unit?: InputMaybe<UnitType>;
};

export type ProductChemicalMeasurementSummary = {
  __typename?: 'ProductChemicalMeasurementSummary';
  chemical: Chemical;
  maxAmount?: Maybe<AmountWithUnit>;
};

export type ProductChemicalOverride = {
  __typename?: 'ProductChemicalOverride';
  id: Scalars['ID'];
  jurisdiction: Scalars['String'];
  otherPressureValue?: Maybe<Scalars['String']>;
  pressure?: Maybe<Pressure>;
  productChemicalId: Scalars['ID'];
  storageType?: Maybe<Scalars['String']>;
  storageTypeDescription?: Maybe<Scalars['String']>;
  temperature?: Maybe<Temperature>;
};

export type ProductChemicalOverrideInput = {
  id: Scalars['ID'];
  jurisdiction: Scalars['String'];
  otherPressureValue?: InputMaybe<Scalars['String']>;
  pressure?: InputMaybe<Pressure>;
  storageType?: InputMaybe<Scalars['String']>;
  storageTypeDescription?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Temperature>;
};

export type ProductInput = {
  alternateId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productChemicals?: InputMaybe<Array<ProductChemicalInput>>;
  reference?: InputMaybe<Scalars['String']>;
  tenantIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type ProductMeasurementSummary = {
  __typename?: 'ProductMeasurementSummary';
  id: Scalars['ID'];
  issues: Array<Issue>;
  name: Scalars['String'];
  productChemicals: Array<ProductChemicalMeasurementSummary>;
  totalMeasurements: Scalars['Int'];
};

export type ProductMeasurementsForReportResult = {
  __typename?: 'ProductMeasurementsForReportResult';
  count: Scalars['Int'];
  items: Array<ProductMeasurementSummary>;
};

export type ProductTenant = {
  __typename?: 'ProductTenant';
  id: Scalars['ID'];
  product: Product;
  productId: Scalars['ID'];
  tenant: Tenant;
  tenantId: Scalars['String'];
};

export type ProductWithFacilityCount = {
  __typename?: 'ProductWithFacilityCount';
  facilityCount: Scalars['Int'];
  product: Product;
};

export type ProductsResult = {
  __typename?: 'ProductsResult';
  count: Scalars['Int'];
  items: Array<Product>;
};

export enum ProgramArea {
  Epcra = 'EPCRA',
  Rcra = 'RCRA'
}

export type ProlificIssue = {
  __typename?: 'ProlificIssue';
  issue: ModelIssue;
  reportsAffected: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
};

export type ProlificIssuesResult = {
  __typename?: 'ProlificIssuesResult';
  count: Scalars['Int'];
  items: Array<ProlificIssue>;
};

export enum PureOrMixture {
  Mixture = 'MIXTURE',
  Pure = 'PURE'
}

export type QuarterlyHistory = {
  __typename?: 'QuarterlyHistory';
  quarter: Scalars['String'];
  status: EchoQuarterlyHistory;
};

export type QuarterlyStat = {
  __typename?: 'QuarterlyStat';
  count: Scalars['Int'];
  group?: Maybe<Scalars['String']>;
  quarter: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  activities: ActivitiesResult;
  checkForFile: CheckForFileResult;
  chemicalAnomalies: ChemicalAnomaliesResult;
  chemicalInputValidator: Array<Issue>;
  chemicalWithAssociatedData: ChemicalWithAssociatedData;
  chemicalWithAssociatedDataForFacility: ChemicalWithAssociatedData;
  chemicals: ChemicalsResult;
  chemicalsByIds: Array<Chemical>;
  chemicalsOverviewMyProgress: ChemicalsOverviewMyProgressResult;
  counties: CountiesResult;
  credential: Credential;
  credentialInputValidator: Array<Issue>;
  credentials: CredentialResult;
  demoAccountCandidates: DemoAccountCandidateSearchResult;
  document: Document;
  documentInputValidator: Array<Issue>;
  documents: DocumentsResult;
  echoExporter: EchoExporter;
  echoExporters: EchoExporterResult;
  echoOverview?: Maybe<EchoOverview>;
  encampFilingStatus: EncampFilingStatusResult;
  encampStats: EncampStats;
  facilities: FacilitiesResult;
  facilitiesForCredential: Array<Facility>;
  facilitiesWithInsightsCandidates: FacilitiesResult;
  facility?: Maybe<Facility>;
  facilityChemical?: Maybe<FacilityChemical>;
  facilityChemicalByYear?: Maybe<FacilityChemical>;
  facilityChemicalInputValidator: Array<Issue>;
  facilityChemicalMeasurement?: Maybe<FacilityChemicalMeasurement>;
  facilityChemicalMeasurementInputValidator: Array<Issue>;
  facilityChemicalMeasurements: FacilityChemicalMeasurementsResult;
  facilityChemicalMeasurementsForReport: FacilityChemicalMeasurementsForReportResult;
  facilityChemicalStateField?: Maybe<Array<FacilityChemicalStateField>>;
  facilityChemicalStateFieldsForFacility?: Maybe<DynamicFieldsResult>;
  facilityChemicalStorageLocationInputValidator: Array<Issue>;
  facilityChemicals: FacilityChemicalsResult;
  facilityContactInputValidator: Array<Issue>;
  facilityInputValidator: Array<Issue>;
  facilityInventoryStatus: InventoryStatusResult;
  facilityProduct: FacilityProduct;
  facilityProductByYear?: Maybe<FacilityProduct>;
  facilityProductInputValidator: Array<Issue>;
  facilityProductMeasurement?: Maybe<FacilityProductMeasurement>;
  facilityProductMeasurementInputValidator: Array<Issue>;
  facilityProductMeasurements: FacilityProductMeasurementsResult;
  facilityProductStorageLocationInputValidator: Array<Issue>;
  facilityProducts: FacilityProductsResult;
  facilityStateFields: Array<DynamicField>;
  facilityTierIIReports: FacilityTierIiReportsResult;
  facilityUsage: FacilityUsage;
  fireDepartment: FireDepartment;
  fireDepartmentInputValidator: Array<Issue>;
  fireDepartmentSearch: FireDepartmentResult;
  fireDepartments?: Maybe<FireDepartmentResult>;
  fireDepartmentsPicker?: Maybe<FireDepartmentResult>;
  getAllTierIIReportTags: Array<Scalars['String']>;
  getCurrentUser: User;
  getDocumentDownloadLink?: Maybe<Scalars['String']>;
  getFacilityChemicalThresholdData: FacilityChemicalThresholdData;
  getOneSchemaJwt?: Maybe<Scalars['String']>;
  /**
   * Provide list of required inputs for a given activity
   * by description (which files or fees need to be provided)
   */
  getRequiredStaffInputs?: Maybe<RequiredStaffInputResult>;
  getUserById: User;
  insightsCandidates: InsightsCandidatesResult;
  insightsCohorts: Array<InsightsCohort>;
  insightsEchoAllFacilities: InsightsEchoAllFacilitiesResult;
  insightsEchoMyFacilities: InsightsEchoFacilitiesResult;
  insightsFacilityMix: InsightsFacilityMix;
  insightsNonCompliance: InsightsNonCompliance;
  insightsPenalties: InsightsPenalties;
  insightsViolations: InsightsViolations;
  job: Job;
  jobLogs: JobLogsResult;
  jobStepsDone: JobStepsDoneResult;
  jobs: JobsResult;
  leadAgencies: LeadAgencyResult;
  leadAgency: LeadAgency;
  leadAgencyInputValidator: Array<Issue>;
  lepc: Lepc;
  lepcInputValidator: Array<Issue>;
  lepcSearch: LepcResult;
  lepcs?: Maybe<LepcResult>;
  municipalities?: Maybe<MunicipalityResult>;
  myReportStatus: MyReportStatus;
  myTierIIFacilities: MyTierIiFacilityResult;
  npdesDetail: NpdesDetailResult;
  npdesFacilities: NpdesFacilityResult;
  outstandingReviews: OutstandingReviewsResult;
  payment: Payment;
  payments: PaymentsResult;
  people: PeopleResult;
  peopleByIds: Array<Person>;
  person?: Maybe<Person>;
  personFacilities: PersonFacilitiesResult;
  personFacilityContactsInputValidator: Array<Issue>;
  policeDepartment: PoliceDepartment;
  policeDepartmentInputValidator: Array<Issue>;
  policeDepartments: PoliceDepartmentResult;
  problematicReports: FacilityTierIiReportsResult;
  product: Product;
  productChemicalInputValidator: Array<Issue>;
  productForFacility: Product;
  productInputValidator: Array<Issue>;
  productMeasurementsForReport: ProductMeasurementsForReportResult;
  productWithFacilityCount: ProductWithFacilityCount;
  products: ProductsResult;
  profile: Person;
  prolificIssues: ProlificIssuesResult;
  rcraInfoHdHandler: Array<HdHandler>;
  rcraInfoHdHandlers: HdHandlerResult;
  readT2sFile: ReadT2sFileResponse;
  regulatoryInputValidator: Array<Issue>;
  reportSafeToReset: ReportSafeToResetResponse;
  reportingFacilityChemical: ReportingFacilityChemical;
  reportingFacilityChemicalInputValidator: Array<Issue>;
  reportingFacilityChemicals: ReportingFacilityChemicalsResult;
  reportingSeasonSummary: ReportingSeasonSummary;
  roles: Array<Role>;
  staffUsers: UsersResult;
  storageLocations: StorageLocationsResult;
  submissionErrorStats: SubmissionErrorStatsResult;
  tags: TagsResult;
  tenant: Tenant;
  tenantInputValidator: Array<Issue>;
  tenants: TenantsResult;
  tierIIReport: TierIiReport;
  tierIIReportActivities: TierIiReportActivitiesResult;
  tierIIReportActivitiesInError: TierIiReportActivitiesResult;
  tierIIReportVerifyStepValidator: Array<Issue>;
  tierIIReports: TierIiReportsResult;
  user?: Maybe<User>;
  userInputValidator: Array<Issue>;
  users: UsersResult;
  virtualEvent?: Maybe<VirtualEvent>;
  virtualEvents: VirtualEventResult;
  wasteManifestLineItems: WasteManifestLineItemsResult;
  wasteManifests: WasteManifestsResult;
  wasteShipmentsByFacility: WasteShipmentsByFacility;
  webAutomationJob: WebAutomationJobWithPromotionJob;
  webAutomationJobs: WebAutomationJobsResult;
  workflowManagerConfigs: WorkflowManagerConfigResult;
};


export type QueryActivitiesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryCheckForFileArgs = {
  key: Scalars['String'];
};


export type QueryChemicalAnomaliesArgs = {
  filter?: InputMaybe<ChemicalOverviewFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['ID'];
};


export type QueryChemicalInputValidatorArgs = {
  data: ChemicalInput;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryChemicalWithAssociatedDataArgs = {
  chemicalId: Scalars['ID'];
};


export type QueryChemicalWithAssociatedDataForFacilityArgs = {
  chemicalId: Scalars['ID'];
  facilityId: Scalars['ID'];
};


export type QueryChemicalsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryChemicalsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryChemicalsOverviewMyProgressArgs = {
  filter?: InputMaybe<ChemicalOverviewFilter>;
  tenantId: Scalars['ID'];
};


export type QueryCountiesArgs = {
  state: Scalars['String'];
};


export type QueryCredentialArgs = {
  facilitiesPage?: InputMaybe<Scalars['Int']>;
  facilitiesPageSize?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
};


export type QueryCredentialInputValidatorArgs = {
  data: CredentialInputForValidation;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCredentialsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryDemoAccountCandidatesArgs = {
  input: DemoOrganizationInput;
};


export type QueryDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryDocumentInputValidatorArgs = {
  fileSize?: InputMaybe<Scalars['Int']>;
  input: DocumentInput;
};


export type QueryDocumentsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryEchoExporterArgs = {
  registryId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryEchoExportersArgs = {
  filterTenantId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['String'];
};


export type QueryEchoOverviewArgs = {
  cohortIds?: InputMaybe<Array<Scalars['String']>>;
  filterTenantId?: InputMaybe<Scalars['String']>;
  naicsCode?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
};


export type QueryEncampFilingStatusArgs = {
  filter?: InputMaybe<ChemicalOverviewFilter>;
  reportKind: TierIiReportKind;
  tenantId: Scalars['ID'];
};


export type QueryEncampStatsArgs = {
  tenantId: Scalars['ID'];
};


export type QueryFacilitiesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryFacilitiesForCredentialArgs = {
  credentialId: Scalars['ID'];
};


export type QueryFacilitiesWithInsightsCandidatesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryFacilityArgs = {
  id: Scalars['ID'];
};


export type QueryFacilityChemicalArgs = {
  id: Scalars['ID'];
};


export type QueryFacilityChemicalByYearArgs = {
  chemicalId: Scalars['ID'];
  facilityId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};


export type QueryFacilityChemicalInputValidatorArgs = {
  input: FacilityChemicalInput;
};


export type QueryFacilityChemicalMeasurementArgs = {
  id: Scalars['ID'];
};


export type QueryFacilityChemicalMeasurementInputValidatorArgs = {
  input: FacilityChemicalMeasurementInput;
};


export type QueryFacilityChemicalMeasurementsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryFacilityChemicalMeasurementsForReportArgs = {
  facilityId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  reportingYear: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryFacilityChemicalStateFieldArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryFacilityChemicalStateFieldsForFacilityArgs = {
  facilityId: Scalars['ID'];
};


export type QueryFacilityChemicalStorageLocationInputValidatorArgs = {
  facilityChemical?: InputMaybe<FacilityChemicalInput>;
  facilityChemicalId?: InputMaybe<Scalars['String']>;
  facilityId: Scalars['String'];
  input: FacilityChemicalStorageLocationInput;
};


export type QueryFacilityChemicalsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryFacilityContactInputValidatorArgs = {
  data: FacilityContactInput;
};


export type QueryFacilityInputValidatorArgs = {
  data: FacilityInput;
  id: Scalars['ID'];
  omit?: InputMaybe<Array<Scalars['String']>>;
  pick?: InputMaybe<Array<Scalars['String']>>;
  reportId?: InputMaybe<Scalars['ID']>;
};


export type QueryFacilityInventoryStatusArgs = {
  facilityId: Scalars['ID'];
  inventory: Inventory;
  toYear: Scalars['Int'];
};


export type QueryFacilityProductArgs = {
  id: Scalars['ID'];
};


export type QueryFacilityProductByYearArgs = {
  facilityId: Scalars['ID'];
  productId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};


export type QueryFacilityProductInputValidatorArgs = {
  input: FacilityProductInput;
};


export type QueryFacilityProductMeasurementArgs = {
  id: Scalars['ID'];
};


export type QueryFacilityProductMeasurementInputValidatorArgs = {
  input: FacilityProductMeasurementInput;
};


export type QueryFacilityProductMeasurementsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryFacilityProductStorageLocationInputValidatorArgs = {
  facilityId: Scalars['String'];
  input: FacilityProductStorageLocationInput;
};


export type QueryFacilityProductsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryFacilityStateFieldsArgs = {
  input: FacilityStateFieldsInput;
};


export type QueryFacilityTierIiReportsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['String'];
};


export type QueryFacilityUsageArgs = {
  chemicalId: Scalars['ID'];
  includeItems?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryFireDepartmentArgs = {
  id: Scalars['String'];
};


export type QueryFireDepartmentInputValidatorArgs = {
  data: FireDepartmentInput;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryFireDepartmentSearchArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryFireDepartmentsArgs = {
  county?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


export type QueryFireDepartmentsPickerArgs = {
  county?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


export type QueryGetDocumentDownloadLinkArgs = {
  id: Scalars['ID'];
};


export type QueryGetFacilityChemicalThresholdDataArgs = {
  input: FacilityChemicalInput;
};


export type QueryGetOneSchemaJwtArgs = {
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryGetRequiredStaffInputsArgs = {
  activityDescription: Scalars['String'];
};


export type QueryGetUserByIdArgs = {
  id: Scalars['ID'];
};


export type QueryInsightsCandidatesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryInsightsCohortsArgs = {
  tenantId: Scalars['String'];
};


export type QueryInsightsEchoAllFacilitiesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['String'];
};


export type QueryInsightsEchoMyFacilitiesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['String'];
};


export type QueryInsightsFacilityMixArgs = {
  naicsCode?: InputMaybe<Scalars['String']>;
  programArea?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
};


export type QueryInsightsNonComplianceArgs = {
  filter?: InputMaybe<InsightsFilter>;
  tenantId: Scalars['String'];
};


export type QueryInsightsPenaltiesArgs = {
  filter?: InputMaybe<InsightsFilter>;
  tenantId: Scalars['String'];
};


export type QueryInsightsViolationsArgs = {
  filter?: InputMaybe<InsightsFilter>;
  tenantId: Scalars['ID'];
};


export type QueryJobArgs = {
  id: Scalars['ID'];
};


export type QueryJobLogsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryJobStepsDoneArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryJobsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryLeadAgenciesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryLeadAgencyArgs = {
  id: Scalars['Int'];
};


export type QueryLeadAgencyInputValidatorArgs = {
  data: LeadAgencyInput;
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryLepcArgs = {
  id: Scalars['String'];
};


export type QueryLepcInputValidatorArgs = {
  data: LepcInput;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryLepcSearchArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryLepcsArgs = {
  county?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


export type QueryMunicipalitiesArgs = {
  county?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


export type QueryMyReportStatusArgs = {
  filter?: InputMaybe<ChemicalOverviewFilter>;
  reportKind: TierIiReportKind;
  tenantId: Scalars['ID'];
};


export type QueryMyTierIiFacilitiesArgs = {
  filter?: InputMaybe<ChemicalOverviewFilter>;
  tenantId: Scalars['ID'];
};


export type QueryNpdesDetailArgs = {
  npdesId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryNpdesFacilitiesArgs = {
  filterTenantId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['String'];
};


export type QueryOutstandingReviewsArgs = {
  filter?: InputMaybe<ChemicalOverviewFilter>;
  tenantId: Scalars['ID'];
};


export type QueryPaymentArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryPeopleArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryPeopleByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryPersonArgs = {
  id: Scalars['ID'];
};


export type QueryPersonFacilitiesArgs = {
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryPersonFacilityContactsInputValidatorArgs = {
  data: PersonFacilityContactsInput;
};


export type QueryPoliceDepartmentArgs = {
  id: Scalars['Int'];
};


export type QueryPoliceDepartmentInputValidatorArgs = {
  data: PoliceDepartmentForValidation;
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryPoliceDepartmentsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryProblematicReportsArgs = {
  filter?: InputMaybe<ChemicalOverviewFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['ID'];
};


export type QueryProductArgs = {
  productId: Scalars['ID'];
};


export type QueryProductChemicalInputValidatorArgs = {
  input: ProductChemicalInput;
};


export type QueryProductForFacilityArgs = {
  facilityId: Scalars['ID'];
  productId: Scalars['ID'];
};


export type QueryProductInputValidatorArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: ProductInput;
};


export type QueryProductMeasurementsForReportArgs = {
  facilityId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  reportingYear: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryProductWithFacilityCountArgs = {
  productId: Scalars['ID'];
};


export type QueryProductsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryProlificIssuesArgs = {
  filter?: InputMaybe<ChemicalOverviewFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['ID'];
};


export type QueryRcraInfoHdHandlerArgs = {
  handlerId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryRcraInfoHdHandlersArgs = {
  filterTenantId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['String'];
};


export type QueryReadT2sFileArgs = {
  documentId: Scalars['ID'];
};


export type QueryRegulatoryInputValidatorArgs = {
  data: FacilityInput;
  id: Scalars['ID'];
  omit?: InputMaybe<Array<Scalars['String']>>;
  pick?: InputMaybe<Array<Scalars['String']>>;
  reportId?: InputMaybe<Scalars['ID']>;
};


export type QueryReportSafeToResetArgs = {
  reportId: Scalars['ID'];
};


export type QueryReportingFacilityChemicalArgs = {
  id: Scalars['ID'];
};


export type QueryReportingFacilityChemicalInputValidatorArgs = {
  id: Scalars['ID'];
  input: Array<FacilityChemicalStateFieldInput>;
};


export type QueryReportingFacilityChemicalsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryReportingSeasonSummaryArgs = {
  year: Scalars['Int'];
};


export type QueryRolesArgs = {
  tenantId: Scalars['ID'];
};


export type QueryStaffUsersArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryStorageLocationsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QuerySubmissionErrorStatsArgs = {
  year: Scalars['Int'];
};


export type QueryTagsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryTenantArgs = {
  id: Scalars['ID'];
};


export type QueryTenantInputValidatorArgs = {
  input: TenantInput;
};


export type QueryTenantsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryTierIiReportArgs = {
  reportId: Scalars['ID'];
  version?: InputMaybe<Scalars['String']>;
};


export type QueryTierIiReportActivitiesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryTierIiReportActivitiesInErrorArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryTierIiReportVerifyStepValidatorArgs = {
  data: TierIiReportVerifier;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryTierIiReportsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUserInputValidatorArgs = {
  input: UserInput;
};


export type QueryUsersArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryVirtualEventArgs = {
  deadline: Scalars['DateTime'];
  taskId: Scalars['ID'];
};


export type QueryVirtualEventsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryWasteManifestLineItemsArgs = {
  wasteManifestId: Scalars['String'];
};


export type QueryWasteManifestsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryWasteShipmentsByFacilityArgs = {
  facilityId: Scalars['ID'];
  year: Scalars['Int'];
};


export type QueryWebAutomationJobArgs = {
  id: Scalars['ID'];
};


export type QueryWebAutomationJobsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};

export type QueryConfiguration = {
  cityWeight?: InputMaybe<Scalars['Int']>;
  distanceWeight?: InputMaybe<Scalars['Int']>;
  facilityNameWeight?: InputMaybe<Scalars['Int']>;
  matchLimit?: InputMaybe<Scalars['Int']>;
  minMatchScore?: InputMaybe<Scalars['Float']>;
  naicsCodeWeight?: InputMaybe<Scalars['Int']>;
  streetAddressWeight?: InputMaybe<Scalars['Int']>;
  tenantNameWeight?: InputMaybe<Scalars['Int']>;
  zipPrefixWeight?: InputMaybe<Scalars['Float']>;
  zipWeight?: InputMaybe<Scalars['Int']>;
};

export enum RcraInfoAccessibility {
  ResponsibilitiesTransferredToCercla = 'RESPONSIBILITIES_TRANSFERRED_TO_CERCLA',
  ResponsiblePartiesHaveFledTheCountry = 'RESPONSIBLE_PARTIES_HAVE_FLED_THE_COUNTRY',
  SiteInBankruptcy = 'SITE_IN_BANKRUPTCY',
  SiteInLitigation = 'SITE_IN_LITIGATION'
}

export enum RcraInfoDataOrigin {
  DataEntry = 'DATA_ENTRY',
  Emanifest = 'EMANIFEST',
  Emergency = 'EMERGENCY',
  ManualLoad = 'MANUAL_LOAD',
  Myrcraid = 'MYRCRAID',
  RcrainfoBrLoadUtility = 'RCRAINFO_BR_LOAD_UTILITY',
  RcrainfoIndustryApplication = 'RCRAINFO_INDUSTRY_APPLICATION',
  Translation = 'TRANSLATION',
  Utility = 'UTILITY'
}

export enum RcraInfoFederalWasteGeneratorStatus {
  LargeQuantityGenerator = 'LARGE_QUANTITY_GENERATOR',
  NotAGenerator = 'NOT_A_GENERATOR',
  Pending = 'PENDING',
  SmallQuantityGenerator = 'SMALL_QUANTITY_GENERATOR',
  Undetermined = 'UNDETERMINED',
  VerySmallQuantityGenerator = 'VERY_SMALL_QUANTITY_GENERATOR'
}

export enum RcraInfoLandType {
  County = 'COUNTY',
  District = 'DISTRICT',
  Federal = 'FEDERAL',
  Municipal = 'MUNICIPAL',
  Other = 'OTHER',
  Private = 'PRIVATE',
  State = 'STATE',
  Tribal = 'TRIBAL'
}

export enum RcraInfoNonNotifier {
  FormerNonNotifier = 'FORMER_NON_NOTIFIER',
  NonNotifier = 'NON_NOTIFIER',
  NonNotifierDeterminedToBeExempt = 'NON_NOTIFIER_DETERMINED_TO_BE_EXEMPT'
}

export enum RcraInfoOwnerOperatorIndicator {
  CurrentOperator = 'CURRENT_OPERATOR',
  CurrentOwner = 'CURRENT_OWNER',
  PreviousOperator = 'PREVIOUS_OPERATOR',
  PreviousOwner = 'PREVIOUS_OWNER'
}

export enum RcraInfoSourceType {
  Deactivation = 'DEACTIVATION',
  ElectronicManifestBroker = 'ELECTRONIC_MANIFEST_BROKER',
  Emergency = 'EMERGENCY',
  Implementer = 'IMPLEMENTER',
  Notification = 'NOTIFICATION',
  PartA = 'PART_A',
  Report = 'REPORT',
  ReportUpdateWithNotification = 'REPORT_UPDATE_WITH_NOTIFICATION',
  Temporary = 'TEMPORARY'
}

export type ReadT2sFileResponse = {
  __typename?: 'ReadT2sFileResponse';
  facilities: Array<T2sReadFacility>;
  reportingYear: Scalars['Int'];
};

export type RecordLobFeeInput = {
  activityId: Scalars['ID'];
  amount: Scalars['Float'];
  paymentId?: InputMaybe<Scalars['ID']>;
  reportId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type ReportSafeToResetResponse = {
  __typename?: 'ReportSafeToResetResponse';
  activities?: Maybe<Array<Maybe<ActivitySafeToResetResponse>>>;
  isSafeToReset: Scalars['Boolean'];
  unsafeResetReasons: Array<Scalars['String']>;
};

export type ReportingFacilityChemical = {
  __typename?: 'ReportingFacilityChemical';
  aggregationError?: Maybe<Scalars['JSON']>;
  aggregationErrorMessage?: Maybe<Scalars['String']>;
  averageAmount?: Maybe<Scalars['Float']>;
  averageAmountCode?: Maybe<Scalars['Int']>;
  chemical?: Maybe<Chemical>;
  chemicalId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  daysOnSite?: Maybe<Scalars['Int']>;
  facility?: Maybe<Facility>;
  facilityId: Scalars['ID'];
  hasConfidentialStorageLocations?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isAlwaysReported?: Maybe<Scalars['Boolean']>;
  isOverThreshold?: Maybe<Scalars['Boolean']>;
  issueCount?: Maybe<Scalars['Int']>;
  issues: Array<Issue>;
  jurisdictions: Array<Scalars['String']>;
  manuallyEdited?: Maybe<Scalars['Boolean']>;
  maxAmount?: Maybe<Scalars['Float']>;
  maxAmountCode?: Maybe<Scalars['Int']>;
  maxAmountLargestContainer?: Maybe<Scalars['Float']>;
  maxAmountProductChemicalBreakdown?: Maybe<ProductChemicalBreakdown>;
  origin?: Maybe<ReportingFacilityChemicalOrigin>;
  previousYearMaxAmount?: Maybe<AmountWithUnit>;
  reportingYear: Scalars['Int'];
  stateFields: Array<DynamicField>;
  storageLocations?: Maybe<Array<ReportingFacilityChemicalStorageLocation>>;
  unit?: Maybe<UnitType>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type ReportingFacilityChemicalInput = {
  averageAmount?: InputMaybe<Scalars['Float']>;
  averageAmountCode?: InputMaybe<Scalars['Int']>;
  chemicalId?: InputMaybe<Scalars['ID']>;
  daysOnSite?: InputMaybe<Scalars['Int']>;
  facilityId: Scalars['ID'];
  hasConfidentialStorageLocations?: InputMaybe<Scalars['Boolean']>;
  isAlwaysReported?: InputMaybe<Scalars['Boolean']>;
  isOverThreshold?: InputMaybe<Scalars['Boolean']>;
  manuallyEdited?: InputMaybe<Scalars['Boolean']>;
  maxAmount?: InputMaybe<Scalars['Float']>;
  maxAmountCode?: InputMaybe<Scalars['Int']>;
  maxAmountLargestContainer?: InputMaybe<Scalars['Float']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  stateFields?: InputMaybe<Array<DynamicFieldInput>>;
  storageLocations?: InputMaybe<Array<FacilityChemicalStorageLocationInput>>;
  unit?: InputMaybe<UnitType>;
};

export type ReportingFacilityChemicalOrigin = {
  __typename?: 'ReportingFacilityChemicalOrigin';
  facilityChemical?: Maybe<FacilityChemical>;
  facilityChemicalId?: Maybe<Scalars['ID']>;
  facilityChemicalMeasurements?: Maybe<Array<FacilityChemicalMeasurement>>;
  facilityProductMeasurements?: Maybe<Array<FacilityProductMeasurement>>;
  facilityProducts?: Maybe<Array<FacilityProduct>>;
  id: Scalars['ID'];
};

export type ReportingFacilityChemicalStorageLocation = {
  __typename?: 'ReportingFacilityChemicalStorageLocation';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  id: Scalars['ID'];
  maxAmount?: Maybe<Scalars['Float']>;
  otherPressureValue?: Maybe<Scalars['String']>;
  pressure?: Maybe<Pressure>;
  reportingFacilityChemical?: Maybe<ReportingFacilityChemical>;
  reportingFacilityChemicalId: Scalars['ID'];
  storageLocation?: Maybe<StorageLocation>;
  storageLocationId: Scalars['ID'];
  storageType?: Maybe<Scalars['String']>;
  storageTypeDescription?: Maybe<Scalars['String']>;
  temperature?: Maybe<Temperature>;
  unit?: Maybe<UnitType>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type ReportingFacilityChemicalsResult = {
  __typename?: 'ReportingFacilityChemicalsResult';
  count: Scalars['Int'];
  items: Array<ReportingFacilityChemical>;
};

export type ReportingSeasonSummary = {
  __typename?: 'ReportingSeasonSummary';
  facilitiesTotal: Scalars['Int'];
  noReportsTotal: Scalars['Int'];
  organizationSummaries: Array<UnverifiedSummary>;
  reportsInAwaitingVerification: Scalars['Int'];
  reportsInFilingComplete: Scalars['Int'];
  reportsInNotReporting: Scalars['Int'];
  reportsInProcessing: Scalars['Int'];
  reportsTotal: Scalars['Int'];
  reportsUnverified: Scalars['Int'];
  staffSummaries: Array<StaffSummary>;
  stateSummaries: Array<UnverifiedSummary>;
  workflowsCountAutomation: Scalars['Int'];
  workflowsCountError: Scalars['Int'];
  workflowsCountHuman: Scalars['Int'];
  workflowsCountWaitForAll: Scalars['Int'];
  year: Scalars['Int'];
};

export type RequeueActivitiesResult = {
  __typename?: 'RequeueActivitiesResult';
  activitiesUpdated: Array<Scalars['ID']>;
  updatedCount: Scalars['Int'];
};

export type RequiredStaffInputItem = {
  __typename?: 'RequiredStaffInputItem';
  inputType?: Maybe<StaffInputType>;
  name: StaffInput;
};

export type RequiredStaffInputResult = {
  __typename?: 'RequiredStaffInputResult';
  activityType?: Maybe<Scalars['String']>;
  consolidated?: Maybe<Scalars['String']>;
  jurisdictionType?: Maybe<Scalars['String']>;
  links?: Maybe<Array<StaffInputLink>>;
  requiredStaffInputs: Array<RequiredStaffInputItem>;
};

export type ResetReportInput = {
  encampStatus: TierIiReportEncampStatus;
  organizationStatus: TierIiReportOrgStatus;
  reportId: Scalars['ID'];
  safetyOverride?: InputMaybe<Scalars['Boolean']>;
  untouchedSteps?: InputMaybe<Array<Scalars['String']>>;
};

export type Role = {
  __typename?: 'Role';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  permissions?: Maybe<Array<Permission>>;
};

export type SelectedEchoExporterFields = {
  __typename?: 'SelectedEchoExporterFields';
  dfrUrl?: Maybe<Scalars['String']>;
  facActiveFlag?: Maybe<Scalars['Boolean']>;
  facCity?: Maybe<Scalars['String']>;
  facLat?: Maybe<Scalars['Float']>;
  facLong?: Maybe<Scalars['Float']>;
  facNaicsCodes: Array<Scalars['String']>;
  facName?: Maybe<Scalars['String']>;
  facState?: Maybe<Scalars['String']>;
  facStreet?: Maybe<Scalars['String']>;
  facZip?: Maybe<Scalars['String']>;
  npdesIds: Array<Scalars['String']>;
  rcraIds: Array<Scalars['String']>;
  registryId: Scalars['String'];
};

export type SendLobCheckInput = {
  activityId?: InputMaybe<Scalars['ID']>;
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  amount: Scalars['Float'];
  associations: Array<PaymentAssociation>;
  city: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  invoiceDocumentId: Scalars['ID'];
  invoiceNumber?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  payeeType: Payee;
  recipient: Scalars['String'];
  state: Scalars['String'];
  tenantId: Scalars['ID'];
  zip: Scalars['String'];
};

export type SetCollectionModeResult = {
  __typename?: 'SetCollectionModeResult';
  facilities: Array<Facility>;
  succeeded?: Maybe<Scalars['Boolean']>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortModel = {
  field: Scalars['String'];
  sort?: InputMaybe<Scalars['String']>;
};

export enum StaffInput {
  Certification = 'Certification',
  Check = 'Check',
  CoverLetter = 'CoverLetter',
  FeeCalculation = 'FeeCalculation',
  Fees = 'Fees',
  Form = 'Form',
  Invoice = 'Invoice',
  Other = 'Other',
  Proof = 'Proof',
  Receipt = 'Receipt',
  Report = 'Report',
  Submission = 'Submission'
}

export type StaffInputLink = {
  __typename?: 'StaffInputLink';
  link: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export enum StaffInputType {
  File = 'File',
  Numeric = 'Numeric'
}

export enum StaffReportType {
  TierIiValidation = 'TierIIValidation'
}

export type StaffSummary = {
  __typename?: 'StaffSummary';
  completedCount: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  reportCount: Scalars['Int'];
};

export enum StateOfMatter {
  Gas = 'GAS',
  Liquid = 'LIQUID',
  Solid = 'SOLID'
}

export type StorageLocation = {
  __typename?: 'StorageLocation';
  CA_gridNumber?: Maybe<Scalars['String']>;
  CA_mapNumber?: Maybe<Scalars['String']>;
  OR_insideOutside?: Maybe<InsideOutside>;
  OR_storageArea?: Maybe<Scalars['String']>;
  OR_storageBuilding?: Maybe<Scalars['String']>;
  OR_storageFloor?: Maybe<Scalars['String']>;
  OR_storageQuadrant?: Maybe<StorageQuadrant>;
  OR_storageRoom?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  facility: Facility;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  sourceUpdatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type StorageLocationInput = {
  CA_gridNumber?: InputMaybe<Scalars['String']>;
  CA_mapNumber?: InputMaybe<Scalars['String']>;
  OR_insideOutside?: InputMaybe<InsideOutside>;
  OR_storageArea?: InputMaybe<Scalars['String']>;
  OR_storageBuilding?: InputMaybe<Scalars['String']>;
  OR_storageFloor?: InputMaybe<Scalars['String']>;
  OR_storageQuadrant?: InputMaybe<StorageQuadrant>;
  OR_storageRoom?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
};

export type StorageLocationsResult = {
  __typename?: 'StorageLocationsResult';
  count: Scalars['Int'];
  items: Array<StorageLocation>;
};

export enum StorageQuadrant {
  C = 'C',
  E = 'E',
  N = 'N',
  Ne = 'NE',
  Nw = 'NW',
  S = 'S',
  Se = 'SE',
  Sw = 'SW',
  V = 'V',
  W = 'W'
}

export type SubmissionErrorStatsResult = {
  __typename?: 'SubmissionErrorStatsResult';
  errorsByAssignee: Array<SubmissionErrorStatsResultItem>;
  errorsByCustomer: Array<SubmissionErrorStatsResultItem>;
  errorsByState: Array<SubmissionErrorStatsResultItem>;
  reportsCurrentlyBlockedByErrors: Scalars['Int'];
};

export type SubmissionErrorStatsResultItem = {
  __typename?: 'SubmissionErrorStatsResultItem';
  name?: Maybe<Scalars['String']>;
  val: Scalars['Int'];
};

export type T2sImportInput = {
  documentId: Scalars['ID'];
  facilityIds: Array<InputMaybe<Scalars['ID']>>;
  reportingYear: Scalars['Int'];
};

export type T2sReadFacility = {
  __typename?: 'T2sReadFacility';
  chemicals: Scalars['Int'];
  city?: Maybe<Scalars['String']>;
  contacts: Scalars['Int'];
  name: Scalars['String'];
  state?: Maybe<Scalars['String']>;
};

export type Tag = {
  __typename?: 'Tag';
  description?: Maybe<Scalars['String']>;
  facilities?: Maybe<Array<Facility>>;
  icon?: Maybe<TagIcon>;
  id: Scalars['String'];
  isDisabled: Scalars['Boolean'];
  name: Scalars['String'];
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['String'];
  type: TagType;
};

export enum TagIcon {
  BadgeCheck = 'BADGE_CHECK',
  FolderOpen = 'FOLDER_OPEN',
  RadiationAlt = 'RADIATION_ALT',
  Recycle = 'RECYCLE',
  Trash = 'TRASH',
  UserHardHat = 'USER_HARD_HAT',
  Water = 'WATER',
  Wind = 'WIND'
}

export type TagInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum TagType {
  Document = 'Document',
  Facility = 'Facility',
  Task = 'Task'
}

export type TagsResult = {
  __typename?: 'TagsResult';
  count: Scalars['Int'];
  items: Array<Tag>;
};

export enum TankOwnerType {
  CountyAgency = 'COUNTY_AGENCY',
  FederalAgency = 'FEDERAL_AGENCY',
  LocalAgency = 'LOCAL_AGENCY',
  NonGovernment = 'NON_GOVERNMENT',
  StateAgency = 'STATE_AGENCY'
}

export enum Temperature {
  AmbientTemperature = 'AMBIENT_TEMPERATURE',
  CryogenicConditions = 'CRYOGENIC_CONDITIONS',
  GreaterThanAmbientTemperature = 'GREATER_THAN_AMBIENT_TEMPERATURE',
  LessThanAmbientTemperatureButNotCryogenic = 'LESS_THAN_AMBIENT_TEMPERATURE_BUT_NOT_CRYOGENIC'
}

export type Tenant = {
  __typename?: 'Tenant';
  accountType: AccountType;
  contactCount?: Maybe<Scalars['Int']>;
  facilityCount?: Maybe<Scalars['Int']>;
  featureFlags: Scalars['JSON'];
  id: Scalars['ID'];
  isDemo: Scalars['Boolean'];
  isDisabled: Scalars['Boolean'];
  isPartner: Scalars['Boolean'];
  name: Scalars['String'];
  partnerTenant?: Maybe<Tenant>;
  partnerTenantId?: Maybe<Scalars['ID']>;
  partnersTenants: Array<Tenant>;
};

export type TenantInput = {
  accountType: AccountType;
  id?: InputMaybe<Scalars['ID']>;
  isDemo: Scalars['Boolean'];
  isDisabled: Scalars['Boolean'];
  isPartner: Scalars['Boolean'];
  name: Scalars['String'];
  partnerTenantId?: InputMaybe<Scalars['ID']>;
};

export type TenantsResult = {
  __typename?: 'TenantsResult';
  count: Scalars['Int'];
  items: Array<Tenant>;
};

export type TierIiReport = {
  __typename?: 'TierIIReport';
  assignees: Array<TierIiReportAssignee>;
  comments?: Maybe<Array<Comment>>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  currentWorkflow?: Maybe<Workflow>;
  department?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Document>>;
  encampStatus: TierIiReportEncampStatus;
  facility: Facility;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  isVerified?: Maybe<Scalars['Boolean']>;
  issues: Array<Issue>;
  notesToRegulators?: Maybe<Scalars['String']>;
  organizationStatus: TierIiReportOrgStatus;
  payments?: Maybe<Array<Payment>>;
  productCount: Scalars['Int'];
  reportKind: TierIiReportKind;
  reportingYear: Scalars['Int'];
  reviewCompletedByUserId?: Maybe<Scalars['String']>;
  reviewers: Array<TierIiReportAssignee>;
  staffAssignee: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
  touchedSteps?: Maybe<Array<TierIiReportStep>>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  verifiedAt?: Maybe<Scalars['DateTime']>;
  verifiedByEncamp?: Maybe<Scalars['Boolean']>;
  verifier?: Maybe<Person>;
  verifierFullName?: Maybe<Scalars['String']>;
  verifierTitle?: Maybe<Scalars['String']>;
};

export type TierIiReportActivitiesResult = {
  __typename?: 'TierIIReportActivitiesResult';
  count: Scalars['Int'];
  items: Array<TierIiReportActivity>;
};

export type TierIiReportActivity = {
  __typename?: 'TierIIReportActivity';
  activityAssigneeEmail?: Maybe<Scalars['String']>;
  activityAssigneeFirst?: Maybe<Scalars['String']>;
  activityAssigneeLast?: Maybe<Scalars['String']>;
  activityDescription?: Maybe<Scalars['String']>;
  activityErrorMessage?: Maybe<Scalars['String']>;
  activityExecutionPlan?: Maybe<Scalars['String']>;
  activityId?: Maybe<Scalars['String']>;
  activityStatus?: Maybe<Scalars['String']>;
  activityType?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  customerFacilityId?: Maybe<Scalars['String']>;
  encampStatus?: Maybe<Scalars['String']>;
  facilityId: Scalars['String'];
  facilityName: Scalars['String'];
  hasIncompleteReviews?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isChampionReport?: Maybe<Scalars['Boolean']>;
  isValid?: Maybe<Scalars['Boolean']>;
  jobStatus?: Maybe<JobStatus>;
  lastValidatedTime?: Maybe<Scalars['DateTime']>;
  organizationName: Scalars['String'];
  organizationStatus?: Maybe<Scalars['String']>;
  partnerTenant?: Maybe<Scalars['String']>;
  productCount?: Maybe<Scalars['Int']>;
  reportKind?: Maybe<Scalars['String']>;
  reportingYear?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  streetAddress1?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  tenantId: Scalars['ID'];
  tierIIReportId?: Maybe<Scalars['ID']>;
  workflowId?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type TierIiReportAssignee = {
  __typename?: 'TierIIReportAssignee';
  assignmentType: AssignmentType;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  id: Scalars['ID'];
  isComplete?: Maybe<Scalars['Boolean']>;
  person: Person;
  personId: Scalars['ID'];
  tierIIReport: TierIiReport;
  tierIIReportId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type TierIiReportAssigneeInput = {
  assignmentType: AssignmentType;
  id?: InputMaybe<Scalars['ID']>;
  isComplete?: InputMaybe<Scalars['Boolean']>;
  personId: Scalars['ID'];
  tierIIReportId: Scalars['ID'];
};

export enum TierIiReportEncampStatus {
  AwaitingVerification = 'AWAITING_VERIFICATION',
  FilingComplete = 'FILING_COMPLETE',
  NotReporting = 'NOT_REPORTING',
  Processing = 'PROCESSING'
}

export enum TierIiReportKind {
  Annual = 'ANNUAL',
  Initial = 'INITIAL',
  Revision = 'REVISION',
  Update = 'UPDATE'
}

export enum TierIiReportOrgStatus {
  Assigned = 'ASSIGNED',
  InProgress = 'IN_PROGRESS',
  InReview = 'IN_REVIEW',
  NotReporting = 'NOT_REPORTING',
  NotStarted = 'NOT_STARTED',
  Verified = 'VERIFIED'
}

export type TierIiReportPayment = {
  __typename?: 'TierIIReportPayment';
  amount?: Maybe<Scalars['Float']>;
  tierIIReport?: Maybe<TierIiReport>;
};

export enum TierIiReportStep {
  Chemicals = 'CHEMICALS',
  ChemicalSummary = 'CHEMICAL_SUMMARY',
  Contacts = 'CONTACTS',
  Documents = 'DOCUMENTS',
  Facility = 'FACILITY',
  OtherChemicals = 'OTHER_CHEMICALS',
  Products = 'PRODUCTS',
  Regulatory = 'REGULATORY',
  ReportOverview = 'REPORT_OVERVIEW',
  Review = 'REVIEW',
  StateInformation = 'STATE_INFORMATION',
  VerifyAndSubmit = 'VERIFY_AND_SUBMIT'
}

export type TierIiReportUpdateInput = {
  assignees?: InputMaybe<Array<TierIiReportAssigneeInput>>;
  encampStatus?: InputMaybe<TierIiReportEncampStatus>;
  organizationStatus?: InputMaybe<TierIiReportOrgStatus>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type TierIiReportVerifier = {
  isVerified?: InputMaybe<Scalars['Boolean']>;
  personId?: InputMaybe<Scalars['ID']>;
  verifiedAt?: InputMaybe<Scalars['DateTime']>;
  verifierFullName?: InputMaybe<Scalars['String']>;
  verifierTitle?: InputMaybe<Scalars['String']>;
};

export type TierIiReportVerifierInput = {
  personId?: InputMaybe<Scalars['ID']>;
  verifiedAt: Scalars['DateTime'];
  verifierFullName: Scalars['String'];
  verifierTitle: Scalars['String'];
};

export type TierIiReportsResult = {
  __typename?: 'TierIIReportsResult';
  count: Scalars['Int'];
  items: Array<TierIiReport>;
  metadata: PaginationMetadata;
};

export enum UnitType {
  Barrels = 'BARRELS',
  CubicFeet = 'CUBIC_FEET',
  Gallons = 'GALLONS',
  Kilograms = 'KILOGRAMS',
  Liters = 'LITERS',
  MetricTons = 'METRIC_TONS',
  Pounds = 'POUNDS',
  Tons = 'TONS'
}

export type UnverifiedSummary = {
  __typename?: 'UnverifiedSummary';
  id: Scalars['ID'];
  name: Scalars['String'];
  reportCount: Scalars['Int'];
  unverifiedCount: Scalars['Int'];
};

export type UpdateSubtaskInput = {
  completedAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateTaskRecurringInput = {
  eventInput: UpdateVirtualEventInput;
  from?: InputMaybe<Scalars['Date']>;
  seriesId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type UpdateTaskSingleInput = {
  eventInput: UpdateVirtualEventInput;
  tenantId: Scalars['ID'];
};

export type UpdateUserInput = {
  first?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  last?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<UserStatus>;
  tenantId: Scalars['ID'];
};

export type UpdateVirtualEventInput = {
  assigneeId?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  deadline?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  documentIds?: InputMaybe<Array<Scalars['String']>>;
  facilityIds?: InputMaybe<Array<Scalars['String']>>;
  frequency?: InputMaybe<Frequency>;
  id: Scalars['ID'];
  interval?: InputMaybe<Scalars['Int']>;
  links?: InputMaybe<Array<Scalars['String']>>;
  shouldNotify?: InputMaybe<Scalars['Boolean']>;
  subtasks?: InputMaybe<Array<UpdateSubtaskInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  title?: InputMaybe<Scalars['String']>;
  watcherIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateWebAutomationJobInput = {
  action?: InputMaybe<WebAutomationAction>;
  createdBy?: InputMaybe<Scalars['String']>;
  credentialId?: InputMaybe<Scalars['ID']>;
  credentialUsername?: InputMaybe<Scalars['String']>;
  encampRequestId?: InputMaybe<Scalars['ID']>;
  evidenceOfCompletionActions?: InputMaybe<Array<CollectEvidenceOfCompletionActions>>;
  facilityId?: InputMaybe<Scalars['ID']>;
  forceClassicSubmissionStrategy?: InputMaybe<Scalars['Boolean']>;
  reportId?: InputMaybe<Scalars['ID']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  requestId?: InputMaybe<Scalars['ID']>;
  stateOrTerritory?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<JobStatus>;
  stepError?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export enum UploadStatus {
  UploadComplete = 'UPLOAD_COMPLETE',
  UploadFailed = 'UPLOAD_FAILED',
  UploadStarted = 'UPLOAD_STARTED'
}

export type UpsertUserFacilitiesForTenantResult = {
  __typename?: 'UpsertUserFacilitiesForTenantResult';
  count: Scalars['Int'];
  userFacilities: Array<UserFacility>;
};

export type User = {
  __typename?: 'User';
  UserTenant: Array<UserTenant>;
  comments?: Maybe<Array<Comment>>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  facilities: Array<Facility>;
  id: Scalars['ID'];
  invitationExpiresAt?: Maybe<Scalars['DateTime']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  isEmulating?: Maybe<Scalars['Boolean']>;
  isPartner: Scalars['Boolean'];
  issues: Array<Issue>;
  originalUserType?: Maybe<UserType>;
  person?: Maybe<Person>;
  personId?: Maybe<Scalars['String']>;
  status: UserStatus;
  type: UserType;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type UserFacility = {
  __typename?: 'UserFacility';
  facility?: Maybe<Facility>;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  user?: Maybe<User>;
  userId: Scalars['ID'];
};

export type UserInput = {
  email?: InputMaybe<Scalars['String']>;
  facilities?: InputMaybe<Array<FacilityInput>>;
  first?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<UserStatus>;
  tenantId: Scalars['ID'];
};

export enum UserStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Inactive = 'INACTIVE',
  NotInvited = 'NOT_INVITED',
  Pending = 'PENDING'
}

export type UserTenant = {
  __typename?: 'UserTenant';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  role?: Maybe<Role>;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export enum UserType {
  Customer = 'CUSTOMER',
  StaffAdmin = 'STAFF_ADMIN',
  StaffEmployee = 'STAFF_EMPLOYEE',
  StaffTemp = 'STAFF_TEMP'
}

export type UsersResult = {
  __typename?: 'UsersResult';
  count: Scalars['Int'];
  items: Array<User>;
};

export type VerifyCredentialInput = {
  credentialId?: InputMaybe<Scalars['ID']>;
  facilityId: Scalars['ID'];
};

export type VerifyCredentialResult = {
  __typename?: 'VerifyCredentialResult';
  facilityId: Scalars['ID'];
  queued: Scalars['Boolean'];
};

export type VerifyCredentialsResult = {
  __typename?: 'VerifyCredentialsResult';
  count: Scalars['Int'];
  results: Array<VerifyCredentialResult>;
};

export type VirtualEvent = {
  __typename?: 'VirtualEvent';
  assignee?: Maybe<User>;
  completedAt?: Maybe<Scalars['DateTime']>;
  deadline: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Document>>;
  facilities?: Maybe<Array<Facility>>;
  frequency: Frequency;
  id: Scalars['ID'];
  interval?: Maybe<Scalars['Int']>;
  links?: Maybe<Array<Scalars['String']>>;
  seriesId: Scalars['ID'];
  shouldNotify: Scalars['Boolean'];
  status: VirtualEventStatus;
  subtasks?: Maybe<Array<VirtualEventSubtask>>;
  tags?: Maybe<Array<Tag>>;
  taskId: Scalars['ID'];
  title: Scalars['String'];
  watchers?: Maybe<Array<User>>;
};

export type VirtualEventResult = {
  __typename?: 'VirtualEventResult';
  count: Scalars['Int'];
  items: Array<VirtualEvent>;
};

export enum VirtualEventStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Overdue = 'OVERDUE'
}

export type VirtualEventSubtask = {
  __typename?: 'VirtualEventSubtask';
  completedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export enum WasteClassification {
  Nonhazardous = 'NONHAZARDOUS',
  Pharmaceutical = 'PHARMACEUTICAL',
  RcraAcutelyHazardous = 'RCRA_ACUTELY_HAZARDOUS',
  RcraHazardous = 'RCRA_HAZARDOUS',
  StateRegulated = 'STATE_REGULATED',
  Universal = 'UNIVERSAL'
}

export type WasteLine = {
  __typename?: 'WasteLine';
  brDensity?: Maybe<Scalars['String']>;
  brDensityUomCode?: Maybe<Scalars['String']>;
  brDensityUomDescription?: Maybe<Scalars['String']>;
  brFormCode?: Maybe<Scalars['String']>;
  brFormCodeDescription?: Maybe<Scalars['String']>;
  brSourceCode?: Maybe<Scalars['String']>;
  brSourceCodeDescription?: Maybe<Scalars['String']>;
  brWasteMinCode?: Maybe<Scalars['String']>;
  brWasteMinDescription?: Maybe<Scalars['String']>;
  consentNumber?: Maybe<Scalars['String']>;
  containerNumber?: Maybe<Scalars['Int']>;
  containerTypeCode?: Maybe<Scalars['String']>;
  containerTypeDescription?: Maybe<Scalars['String']>;
  disposalManagementCode?: Maybe<Scalars['String']>;
  dotHazardous?: Maybe<Scalars['Boolean']>;
  dotIdNumberDescription?: Maybe<Scalars['String']>;
  dotPrintedInformation?: Maybe<Scalars['String']>;
  epaWaste?: Maybe<Scalars['Boolean']>;
  federalWasteCodes?: Maybe<Array<Scalars['String']>>;
  managementMethodCode?: Maybe<Scalars['String']>;
  managementMethodDescription?: Maybe<Scalars['String']>;
  manifestId: Scalars['String'];
  manifestTrackingNumber: Scalars['String'];
  nonHazWasteDescription?: Maybe<Scalars['String']>;
  qtyUnitOfMeasureCode?: Maybe<Scalars['String']>;
  qtyUnitOfMeasureDesc?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  quantityAcuteKg?: Maybe<Scalars['Float']>;
  quantityAcuteTons?: Maybe<Scalars['Float']>;
  quantityDiscrepancy?: Maybe<Scalars['Boolean']>;
  quantityHazKg?: Maybe<Scalars['Float']>;
  quantityHazTons?: Maybe<Scalars['Float']>;
  quantityKg?: Maybe<Scalars['Float']>;
  quantityNonAcuteKg?: Maybe<Scalars['Float']>;
  quantityNonAcuteTons?: Maybe<Scalars['Float']>;
  quantityNonHazKg?: Maybe<Scalars['Float']>;
  quantityNonHazTons?: Maybe<Scalars['Float']>;
  quantityTons?: Maybe<Scalars['Float']>;
  stateWasteCodes?: Maybe<Array<Scalars['String']>>;
  vendorComments?: Maybe<Scalars['String']>;
  vendorDisposalMethod?: Maybe<Scalars['String']>;
  vendorProfileDescription?: Maybe<Scalars['String']>;
  vendorProfileNumber?: Maybe<Scalars['String']>;
  vendorTSDFApprovalCode?: Maybe<Scalars['String']>;
  vendorWasteTypeCategory?: Maybe<Scalars['String']>;
  vendorWasteTypeDescription?: Maybe<Scalars['String']>;
  wasteLineNumber: Scalars['String'];
  wasteManifest?: Maybe<WasteManifest>;
  wasteResidue?: Maybe<Scalars['Boolean']>;
  wasteTypeDiscrepancy?: Maybe<Scalars['Boolean']>;
};

export type WasteManifest = {
  __typename?: 'WasteManifest';
  brokerId?: Maybe<Scalars['String']>;
  desFacContactCompanyName?: Maybe<Scalars['String']>;
  desFacLocationCity?: Maybe<Scalars['String']>;
  desFacLocationState?: Maybe<Scalars['String']>;
  desFacLocationStreet1?: Maybe<Scalars['String']>;
  desFacLocationStreet2?: Maybe<Scalars['String']>;
  desFacLocationStreetNo?: Maybe<Scalars['String']>;
  desFacLocationZip?: Maybe<Scalars['String']>;
  desFacMailCity?: Maybe<Scalars['String']>;
  desFacMailState?: Maybe<Scalars['String']>;
  desFacMailStreet1?: Maybe<Scalars['String']>;
  desFacMailStreet2?: Maybe<Scalars['String']>;
  desFacMailStreetNo?: Maybe<Scalars['String']>;
  desFacMailZip?: Maybe<Scalars['String']>;
  desFacilityId?: Maybe<Scalars['String']>;
  desFacilityName?: Maybe<Scalars['String']>;
  facility?: Maybe<Facility>;
  generatorContactCompanyName?: Maybe<Scalars['String']>;
  generatorId?: Maybe<Scalars['String']>;
  generatorLocationCity?: Maybe<Scalars['String']>;
  generatorLocationState?: Maybe<Scalars['String']>;
  generatorLocationStreet1?: Maybe<Scalars['String']>;
  generatorLocationStreet2?: Maybe<Scalars['String']>;
  generatorLocationStreetNo?: Maybe<Scalars['String']>;
  generatorLocationZip?: Maybe<Scalars['String']>;
  generatorMailCity?: Maybe<Scalars['String']>;
  generatorMailState?: Maybe<Scalars['String']>;
  generatorMailStreet1?: Maybe<Scalars['String']>;
  generatorMailStreet2?: Maybe<Scalars['String']>;
  generatorMailStreetNo?: Maybe<Scalars['String']>;
  generatorMailZip?: Maybe<Scalars['String']>;
  generatorName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  manifestResidue?: Maybe<Scalars['Boolean']>;
  manifestSource: WasteManifestSource;
  manifestTrackingNumber: Scalars['String'];
  originType?: Maybe<Scalars['String']>;
  receivedDate?: Maybe<Scalars['DateTime']>;
  rejection?: Maybe<Scalars['Boolean']>;
  shippedDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  submissionType?: Maybe<Scalars['String']>;
  totalQuantityAcuteKg?: Maybe<Scalars['Float']>;
  totalQuantityAcuteTons?: Maybe<Scalars['Float']>;
  totalQuantityHazKg?: Maybe<Scalars['Float']>;
  totalQuantityHazTons?: Maybe<Scalars['Float']>;
  totalQuantityKg?: Maybe<Scalars['Float']>;
  totalQuantityNonAcuteKg?: Maybe<Scalars['Float']>;
  totalQuantityNonAcuteTons?: Maybe<Scalars['Float']>;
  totalQuantityNonHazKg?: Maybe<Scalars['Float']>;
  totalQuantityNonHazTons?: Maybe<Scalars['Float']>;
  totalQuantityTons?: Maybe<Scalars['Float']>;
  updatedDate?: Maybe<Scalars['DateTime']>;
  vendorBillQuantity?: Maybe<Scalars['Float']>;
  vendorBillTotal?: Maybe<Scalars['Float']>;
  vendorBillUnit?: Maybe<Scalars['String']>;
  vendorCompanyID?: Maybe<Scalars['String']>;
  vendorCustomerID?: Maybe<Scalars['String']>;
  vendorCustomerName?: Maybe<Scalars['String']>;
  vendorGeneratorID?: Maybe<Scalars['String']>;
  vendorGeneratorSiteCode?: Maybe<Scalars['String']>;
  vendorGeneratorSiteType?: Maybe<Scalars['String']>;
  vendorGeneratorSublocationCode?: Maybe<Scalars['String']>;
  vendorInvoiceCode?: Maybe<Scalars['String']>;
  vendorInvoiceDate?: Maybe<Scalars['DateTime']>;
  vendorProfitCtrID?: Maybe<Scalars['String']>;
  vendorPurchaseOrder?: Maybe<Scalars['String']>;
  vendorResourceType?: Maybe<Scalars['String']>;
  vendorSequenceID?: Maybe<Scalars['String']>;
  vendorSiteId?: Maybe<Scalars['String']>;
  vendorTSDFCode?: Maybe<Scalars['String']>;
  vendorUnitPrice?: Maybe<Scalars['Float']>;
  vendorWorkOrderId?: Maybe<Scalars['String']>;
  wasteLines?: Maybe<Array<WasteLine>>;
  wasteTransporters?: Maybe<Array<WasteTransporter>>;
};

export type WasteManifestLineItemsResult = {
  __typename?: 'WasteManifestLineItemsResult';
  count: Scalars['Int'];
  items: Array<WasteLine>;
};

export enum WasteManifestSource {
  CleanEarth = 'CleanEarth',
  CleanHarbors = 'CleanHarbors',
  Other = 'Other',
  Republic = 'Republic',
  UsEcology = 'UsEcology',
  Wm = 'WM',
  EManifest = 'eManifest'
}

export type WasteManifestsByTrackingNumber = {
  __typename?: 'WasteManifestsByTrackingNumber';
  manifestTrackingNumber: Scalars['String'];
  wasteManifests: Array<WasteManifest>;
};

export type WasteManifestsResult = {
  __typename?: 'WasteManifestsResult';
  count: Scalars['Int'];
  items: Array<ProcessedManifestSummary>;
};

export type WasteShipmentsByFacility = {
  __typename?: 'WasteShipmentsByFacility';
  hazardousWasteShipments?: Maybe<HazardousWasteShipmentsByFacility>;
  highestWasteStreamShipments?: Maybe<Array<WasteStreamShipment>>;
  wasteShipmentsByMonth?: Maybe<AllWasteShipmentsByFacility>;
};

export type WasteStreamShipment = {
  __typename?: 'WasteStreamShipment';
  amount: Scalars['Float'];
  wasteStream: FacilityWasteStream;
};

export type WasteTransporter = {
  __typename?: 'WasteTransporter';
  manifestTrackingNumber: Scalars['String'];
  transporterId?: Maybe<Scalars['String']>;
  transporterLineNumber: Scalars['String'];
  transporterName?: Maybe<Scalars['String']>;
  vendorAddressLine1?: Maybe<Scalars['String']>;
  vendorAddressLine2?: Maybe<Scalars['String']>;
  vendorCity?: Maybe<Scalars['String']>;
  vendorState?: Maybe<Scalars['String']>;
  vendorZip?: Maybe<Scalars['String']>;
  wasteManifest?: Maybe<WasteManifest>;
};

export enum WebAutomationAction {
  AcquireLock = 'acquireLock',
  CloseDraftReport = 'closeDraftReport',
  CollectEvidenceOfCompletion = 'collectEvidenceOfCompletion',
  DeleteLock = 'deleteLock',
  DownloadReport = 'downloadReport',
  ExtractChemicalDatabase = 'extractChemicalDatabase',
  ExtractData = 'extractData',
  ExtractHazardousMaterialsPermit = 'extractHazardousMaterialsPermit',
  ExtractStateIDs = 'extractStateIDs',
  GetFacilitiesList = 'getFacilitiesList',
  InputData = 'inputData',
  InputDataLepc = 'inputDataLepc',
  InputDataRevision = 'inputDataRevision',
  Rcra870012 = 'rcra870012',
  Rcra870013 = 'rcra870013',
  RcraEvq = 'rcraEvq',
  ScrapeDistrictInfo = 'scrapeDistrictInfo',
  Verify870012Submission = 'verify870012Submission',
  VerifyCredentials = 'verifyCredentials'
}

export type WebAutomationJobResult = {
  __typename?: 'WebAutomationJobResult';
  count: Scalars['Int'];
};

export type WebAutomationJobWithPromotionJob = {
  __typename?: 'WebAutomationJobWithPromotionJob';
  action?: Maybe<WebAutomationAction>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  extraction?: Maybe<Scalars['JSON']>;
  extractionKey?: Maybe<Scalars['String']>;
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  insightsCandidates: Array<InsightsCandidate>;
  logs: Array<JobLog>;
  parameters?: Maybe<Scalars['JSON']>;
  payments: Array<Payment>;
  /** @deprecated use `promotionJobUpdatedAt` instead */
  promotedAt?: Maybe<Scalars['DateTime']>;
  promotionJobId?: Maybe<Scalars['ID']>;
  promotionJobStatus?: Maybe<JobStatus>;
  promotionJobUpdatedAt?: Maybe<Scalars['DateTime']>;
  reportId?: Maybe<Scalars['ID']>;
  reportingYear?: Maybe<Scalars['Int']>;
  requestId?: Maybe<Scalars['ID']>;
  staffReportDownloadLink?: Maybe<Scalars['String']>;
  staffReportKey?: Maybe<Scalars['String']>;
  stateOrTerritory?: Maybe<Scalars['String']>;
  status?: Maybe<JobStatus>;
  stepsDone: Array<JobStepsDone>;
  task?: Maybe<JobTask>;
  taskArn?: Maybe<Scalars['String']>;
  taskUrl?: Maybe<Scalars['String']>;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['String'];
  totalIssues?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type WebAutomationJobsResult = {
  __typename?: 'WebAutomationJobsResult';
  count: Scalars['Int'];
  items: Array<WebAutomationJobWithPromotionJob>;
};

export enum WeightOrVolume {
  Volume = 'VOLUME',
  Weight = 'WEIGHT'
}

export type Workflow = {
  __typename?: 'Workflow';
  activities: Array<Activity>;
  comments?: Maybe<Array<Comment>>;
  currentActivity?: Maybe<Activity>;
  currentActivityId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  tierIIReportId?: Maybe<Scalars['ID']>;
};

export type WorkflowManagerConfig = {
  __typename?: 'WorkflowManagerConfig';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  id: Scalars['ID'];
  type: WorkflowManagerConfigType;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
  value: Scalars['String'];
};

export type WorkflowManagerConfigResult = {
  __typename?: 'WorkflowManagerConfigResult';
  count: Scalars['Int'];
  items: Array<WorkflowManagerConfig>;
};

export enum WorkflowManagerConfigType {
  AllowEnvironment = 'ALLOW_ENVIRONMENT',
  AllowFacility = 'ALLOW_FACILITY',
  AllowState = 'ALLOW_STATE',
  DenyFacility = 'DENY_FACILITY',
  DenyTenant = 'DENY_TENANT',
  FacilityBypassValidation = 'FACILITY_BYPASS_VALIDATION',
  MaxConcurrency = 'MAX_CONCURRENCY',
  MinConductExecutionTime = 'MIN_CONDUCT_EXECUTION_TIME',
  StateBypassValidation = 'STATE_BYPASS_VALIDATION'
}

export type DeleteFacilityChemicalMeasurementsByChemicalAndYearResult = {
  __typename?: 'deleteFacilityChemicalMeasurementsByChemicalAndYearResult';
  chemicalId: Scalars['ID'];
  facilityId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};

export type DeleteFacilityProductMeasurementsByProductAndYearResult = {
  __typename?: 'deleteFacilityProductMeasurementsByProductAndYearResult';
  facilityId: Scalars['ID'];
  productId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};

export type FacilityChemicalMeasurementsForReportResult = {
  __typename?: 'facilityChemicalMeasurementsForReportResult';
  count: Scalars['Int'];
  items: Array<ChemicalMeasurementSummary>;
};

export type LeadAgencyResult = {
  __typename?: 'leadAgencyResult';
  count: Scalars['Int'];
  items: Array<LeadAgency>;
};

export type ChemicalListItemFragment = { __typename?: 'Chemical', id: string, name: string };

export type ChemicalPickerFragment = { __typename?: 'Chemical', id: string, name: string, pureOrMixture?: PureOrMixture | null, casNumber?: string | null, isEhs: boolean, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null };

export type ChemicalsQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
  facilityId?: InputMaybe<Scalars['ID']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
}>;


export type ChemicalsQueryQuery = { __typename?: 'Query', chemicals: { __typename?: 'ChemicalsResult', count: number, items: Array<{ __typename?: 'Chemical', id: string, name: string, pureOrMixture?: PureOrMixture | null, casNumber?: string | null, isEhs: boolean, facilityChemicals?: Array<{ __typename?: 'FacilityChemical', id: string }> | null, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null }> } };

export type CommentListFragment = { __typename?: 'Comment', id: string, reportId?: string | null, userId?: string | null, workflowId?: string | null, activityId?: string | null, comment: string, updatedAt: any, user?: { __typename?: 'User', id: string, email: string } | null };

export type ContactFacilitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type ContactFacilitiesQuery = { __typename?: 'Query', facilities: { __typename?: 'FacilitiesResult', count: number, items: Array<{ __typename?: 'Facility', id: string, name: string, customerFacilityId?: string | null, streetAddress1?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }> } };

export type ContactsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type ContactsQuery = { __typename?: 'Query', people: { __typename?: 'PeopleResult', count: number, items: Array<{ __typename?: 'Person', id: string, first?: string | null, last?: string | null, email?: string | null, user?: { __typename?: 'User', id: string } | null, phones?: Array<{ __typename?: 'Phone', type: PhoneType, number?: string | null }> | null, facilityContacts?: Array<{ __typename?: 'FacilityContact', id: string, reportingRoles: Array<ContactReportRole>, facility: { __typename?: 'Facility', id: string, name: string, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } }> | null, issues?: Array<{ __typename?: 'Issue', message: string }> | null }> } };

export type GetPersonForDeletionQueryVariables = Exact<{
  personId: Scalars['ID'];
}>;


export type GetPersonForDeletionQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: string, first?: string | null, last?: string | null, user?: { __typename?: 'User', id: string } | null } | null };

export type GetFacilitiesByPersonQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type GetFacilitiesByPersonQuery = { __typename?: 'Query', facilities: { __typename?: 'FacilitiesResult', count: number, items: Array<{ __typename?: 'Facility', id: string, name: string, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }> } };

export type DeletePersonMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePersonMutation = { __typename?: 'Mutation', deletePerson?: { __typename?: 'Person', id: string } | null };

export type GetPersonForEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPersonForEditQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: string, tenantId: string, first?: string | null, last?: string | null, email?: string | null, title?: string | null, company?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, country?: string | null, state?: string | null, zip?: string | null, tankOwnerType?: TankOwnerType | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null, facilityContacts?: Array<{ __typename?: 'FacilityContact', id: string, reportingRoles: Array<ContactReportRole>, facility: { __typename?: 'Facility', id: string, name: string, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } }> | null, user?: { __typename?: 'User', id: string, email: string } | null, issues?: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> | null } | null };

export type UpsertPersonMutationVariables = Exact<{
  input: PersonFacilityContactsInput;
}>;


export type UpsertPersonMutation = { __typename?: 'Mutation', upsertPerson: { __typename?: 'Person', id: string } };

export type GetPersonFacilitiesQueryVariables = Exact<{
  personId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type GetPersonFacilitiesQuery = { __typename?: 'Query', personFacilities: { __typename?: 'PersonFacilitiesResult', count: number, items: Array<{ __typename?: 'Facility', id: string, name: string, city?: string | null, state?: string | null }> } };

export type GetPersonQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPersonQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: string, first?: string | null, last?: string | null, email?: string | null, title?: string | null, company?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, country?: string | null, state?: string | null, zip?: string | null, tankOwnerType?: TankOwnerType | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null, user?: { __typename?: 'User', id: string, email: string } | null } | null };

export type CountiesQueryVariables = Exact<{
  state: Scalars['String'];
}>;


export type CountiesQuery = { __typename?: 'Query', counties: { __typename?: 'CountiesResult', items: Array<string>, count: number } };

export type GetDocumentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDocumentQuery = { __typename?: 'Query', document: { __typename?: 'Document', id: string, title: string, fileExtension?: string | null, storageLink: string, downloadLink?: string | null } };

export type SetEmulatedRoleMutationVariables = Exact<{
  tenantId: Scalars['String'];
  permissions: Array<Permission> | Permission;
}>;


export type SetEmulatedRoleMutation = { __typename?: 'Mutation', setEmulatedRole: boolean };

export type ResetEmulatedRoleMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetEmulatedRoleMutation = { __typename?: 'Mutation', resetEmulatedRole: boolean };

export type FacilityPickerFragment = { __typename?: 'Facility', id: string, name: string };

export type FacilitiesPickerQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type FacilitiesPickerQuery = { __typename?: 'Query', facilities: { __typename?: 'FacilitiesResult', count: number, items: Array<{ __typename?: 'Facility', id: string, name: string }> } };

export type FireDepartmentPickerFragment = { __typename?: 'FireDepartment', id: string, name?: string | null, city?: string | null, state?: string | null, mailingAddress?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null };

export type FireDepartmentsQueryVariables = Exact<{
  state?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
}>;


export type FireDepartmentsQuery = { __typename?: 'Query', fireDepartments?: { __typename?: 'FireDepartmentResult', count: number, items: Array<{ __typename?: 'FireDepartment', id: string, name?: string | null, city?: string | null, state?: string | null, mailingAddress?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null }> } | null };

export type DynamicFieldFragment = { __typename?: 'DynamicField', key: string, value?: any | null, jurisdiction: string, label: string, tooltip?: string | null, inputType: DynamicFieldType, layout?: any | null, renderMetadata?: any | null, helperText?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null };

export type GetOneSchemaJwtQueryVariables = Exact<{
  tenantId?: InputMaybe<Scalars['String']>;
}>;


export type GetOneSchemaJwtQuery = { __typename?: 'Query', getOneSchemaJwt?: string | null };

export type GenerateImporterPresignedUrlMutationVariables = Exact<{
  fileName: Scalars['String'];
  tenantId: Scalars['ID'];
  facilityId?: InputMaybe<Scalars['ID']>;
  directory?: InputMaybe<Scalars['String']>;
  contentType: Scalars['String'];
}>;


export type GenerateImporterPresignedUrlMutation = { __typename?: 'Mutation', generatePresignedUrl: { __typename?: 'GeneratePresignedUrlResult', key: string, presignedUrl: string } };

export type ProcessOneschemaFileUploadMutationVariables = Exact<{
  input: ProcessOneschemaFileUploadInput;
}>;


export type ProcessOneschemaFileUploadMutation = { __typename?: 'Mutation', processOneschemaFileUpload: { __typename?: 'ProcessOneschemaFileUploadResult', result: string } };

export type LepcPickerFragment = { __typename?: 'Lepc', id: string, name: string, mailingAddress?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null, isEmailed: boolean };

export type LepcsQueryVariables = Exact<{
  state?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
}>;


export type LepcsQuery = { __typename?: 'Query', lepcs?: { __typename?: 'LepcResult', count?: number | null, items: Array<{ __typename?: 'Lepc', id: string, name: string, mailingAddress?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null, isEmailed: boolean }> } | null };

export type MultipleFacilityPickerFragment = { __typename?: 'Facility', id: string, name: string };

export type PickerFacilitiesQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type PickerFacilitiesQueryQuery = { __typename?: 'Query', facilities: { __typename?: 'FacilitiesResult', count: number, items: Array<{ __typename?: 'Facility', id: string, name: string }> } };

export type MunicipalitiesQueryVariables = Exact<{
  state?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
}>;


export type MunicipalitiesQuery = { __typename?: 'Query', municipalities?: { __typename?: 'MunicipalityResult', count: number, items: Array<{ __typename?: 'Municipality', id: string, name: string }> } | null };

export type FacilityChemicalAggregateFragment = { __typename?: 'FacilityChemical', maxAmount?: number | null, maxAmountCode?: number | null, averageAmount?: number | null, averageAmountCode?: number | null, maxAmountLargestContainer?: number | null, daysOnSite?: number | null, unit?: UnitType | null, facility?: { __typename?: 'Facility', state?: string | null } | null };

export type ReportingFacilityChemicalAggregateFragment = { __typename?: 'ReportingFacilityChemical', reportingYear: number, maxAmount?: number | null, maxAmountCode?: number | null, averageAmount?: number | null, averageAmountCode?: number | null, maxAmountLargestContainer?: number | null, daysOnSite?: number | null, unit?: UnitType | null, manuallyEdited?: boolean | null, facility?: { __typename?: 'Facility', state?: string | null } | null };

export type PersonPickerFragment = { __typename?: 'Person', id: string, first?: string | null, last?: string | null, email?: string | null };

export type PeopleQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type PeopleQuery = { __typename?: 'Query', people: { __typename?: 'PeopleResult', count: number, items: Array<{ __typename?: 'Person', id: string, first?: string | null, last?: string | null, email?: string | null }> } };

export type ProductPickerFragment = { __typename?: 'Product', id: string, name: string };

export type ProductsQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
  facilityId?: InputMaybe<Scalars['ID']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
}>;


export type ProductsQueryQuery = { __typename?: 'Query', products: { __typename?: 'ProductsResult', count: number, items: Array<{ __typename?: 'Product', id: string, name: string, facilityProducts?: Array<{ __typename?: 'FacilityProduct', id: string }> | null }> } };

export type StorageLocationPickerFragment = { __typename?: 'StorageLocation', id: string, description?: string | null, facilityId: string, CA_mapNumber?: string | null, CA_gridNumber?: string | null, OR_insideOutside?: InsideOutside | null, OR_storageArea?: string | null, OR_storageBuilding?: string | null, OR_storageFloor?: string | null, OR_storageQuadrant?: StorageQuadrant | null, OR_storageRoom?: string | null, latitude?: number | null, longitude?: number | null };

export type StorageLocationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type StorageLocationsQuery = { __typename?: 'Query', storageLocations: { __typename?: 'StorageLocationsResult', count: number, items: Array<{ __typename?: 'StorageLocation', id: string, description?: string | null, facilityId: string, CA_mapNumber?: string | null, CA_gridNumber?: string | null, OR_insideOutside?: InsideOutside | null, OR_storageArea?: string | null, OR_storageBuilding?: string | null, OR_storageFloor?: string | null, OR_storageQuadrant?: StorageQuadrant | null, OR_storageRoom?: string | null, latitude?: number | null, longitude?: number | null }> } };

export type TagPickerFragment = { __typename?: 'Tag', id: string, name: string };

export type TagsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type TagsQuery = { __typename?: 'Query', tags: { __typename?: 'TagsResult', count: number, items: Array<{ __typename?: 'Tag', id: string, name: string }> } };

export type ListOrganizationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type ListOrganizationsQuery = { __typename?: 'Query', tenants: { __typename?: 'TenantsResult', count: number, items: Array<{ __typename?: 'Tenant', id: string, name: string, isDisabled: boolean, isDemo: boolean, isPartner: boolean, partnerTenantId?: string | null }> } };

export type GetTierIiReportTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTierIiReportTagsQuery = { __typename?: 'Query', getAllTierIIReportTags: Array<string> };

export type StaffUsersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type StaffUsersQuery = { __typename?: 'Query', staffUsers: { __typename?: 'UsersResult', items: Array<{ __typename?: 'User', id: string, email: string, person?: { __typename?: 'Person', id: string, first?: string | null, last?: string | null } | null }> } };

export type VerifierFragmentFragment = { __typename?: 'Person', id: string, first?: string | null, last?: string | null, email?: string | null, state?: string | null, title?: string | null, company?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, zip?: string | null, tenant?: { __typename?: 'Tenant', id: string, name: string } | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null };

export type VerifiersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type VerifiersQuery = { __typename?: 'Query', people: { __typename?: 'PeopleResult', count: number, items: Array<{ __typename?: 'Person', id: string, first?: string | null, last?: string | null, email?: string | null, state?: string | null, title?: string | null, company?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, zip?: string | null, tenant?: { __typename?: 'Tenant', id: string, name: string } | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null }> } };

export type ActivityFragment = { __typename?: 'Activity', description?: string | null };

export type ActivityFragmentFragment = { __typename?: 'Activity', id: string, type: ActivityType, status: ActivityStatus, executionPlan: ExecutionPlanType, description?: string | null, assigneeId?: string | null, assignee?: { __typename?: 'User', id: string, email: string, person?: { __typename?: 'Person', id: string, first?: string | null, last?: string | null } | null } | null, workflow: { __typename?: 'Workflow', id: string, tierIIReportId?: string | null } };

export type UpdateActivityMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ActivityInput;
}>;


export type UpdateActivityMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'Activity', id: string, type: ActivityType, status: ActivityStatus, executionPlan: ExecutionPlanType, description?: string | null, assigneeId?: string | null, assignee?: { __typename?: 'User', id: string, email: string, person?: { __typename?: 'Person', id: string, first?: string | null, last?: string | null } | null } | null, workflow: { __typename?: 'Workflow', id: string, tierIIReportId?: string | null } } };

export type UpdateActivitiesMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  input: ActivityInput;
}>;


export type UpdateActivitiesMutation = { __typename?: 'Mutation', updateActivities: Array<{ __typename?: 'Activity', id: string, type: ActivityType, status: ActivityStatus, executionPlan: ExecutionPlanType, description?: string | null, assigneeId?: string | null, assignee?: { __typename?: 'User', id: string, email: string, person?: { __typename?: 'Person', id: string, first?: string | null, last?: string | null } | null } | null, workflow: { __typename?: 'Workflow', id: string, tierIIReportId?: string | null } }> };

export type RequeueActivitiesMutationVariables = Exact<{
  activityIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RequeueActivitiesMutation = { __typename?: 'Mutation', requeueActivities: { __typename?: 'RequeueActivitiesResult', activitiesUpdated: Array<string>, updatedCount: number } };

export type UpsertCommentMutationVariables = Exact<{
  input: CommentInput;
}>;


export type UpsertCommentMutation = { __typename?: 'Mutation', upsertComment: { __typename?: 'Comment', id: string, userId?: string | null, reportId?: string | null, workflowId?: string | null, activityId?: string | null, comment: string, updatedAt: any, user?: { __typename?: 'User', id: string, email: string } | null } };

export type DeleteDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
  retainAsset?: InputMaybe<Scalars['Boolean']>;
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument: { __typename?: 'Document', id: string, reportId?: string | null } };

export type UpdateDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
  input: DocumentInput;
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument: { __typename?: 'Document', id: string, title: string, description?: string | null, storageLink: string, documentType: DocumentType, updatedAt?: any | null, createdAt?: any | null, reportId?: string | null, documentTags?: Array<{ __typename?: 'Tag', id: string, name: string, tenantId: string, isDisabled: boolean, type: TagType }> | null } };

export type RemoveDocumentFromActivityMutationVariables = Exact<{
  activityId: Scalars['ID'];
  documentId: Scalars['ID'];
}>;


export type RemoveDocumentFromActivityMutation = { __typename?: 'Mutation', removeDocumentFromActivity: { __typename?: 'ActivityDocument', activityId: string, documentId: string } };

export type UpdateTierIiReportReviewersMutationVariables = Exact<{
  tierIIReportIds: Array<Scalars['ID']> | Scalars['ID'];
  personIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UpdateTierIiReportReviewersMutation = { __typename?: 'Mutation', setTierIIReportReviewers: Array<{ __typename?: 'TierIIReport', id: string, reviewers: Array<{ __typename?: 'TierIIReportAssignee', id: string, assignmentType: AssignmentType, isComplete?: boolean | null, person: { __typename?: 'Person', id: string, first?: string | null, last?: string | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null } }> }> };

export type UpdateTierIiReportAssigneesMutationVariables = Exact<{
  tierIIReportIds: Array<Scalars['ID']> | Scalars['ID'];
  personIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UpdateTierIiReportAssigneesMutation = { __typename?: 'Mutation', setTierIIReportAssignees: Array<{ __typename?: 'TierIIReport', id: string, assignees: Array<{ __typename?: 'TierIIReportAssignee', id: string, assignmentType: AssignmentType, person: { __typename?: 'Person', id: string, first?: string | null, last?: string | null } }> }> };

export type RemoveTierIiReportReviewersMutationVariables = Exact<{
  tierIIReportIds: Array<Scalars['ID']> | Scalars['ID'];
  personIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveTierIiReportReviewersMutation = { __typename?: 'Mutation', removeTierIIReportReviewers: Array<{ __typename?: 'TierIIReport', id: string, reviewers: Array<{ __typename?: 'TierIIReportAssignee', id: string, assignmentType: AssignmentType, person: { __typename?: 'Person', id: string, first?: string | null, last?: string | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null } }> }> };

export type RemoveTierIiReportAssigneesMutationVariables = Exact<{
  tierIIReportIds: Array<Scalars['ID']> | Scalars['ID'];
  personIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveTierIiReportAssigneesMutation = { __typename?: 'Mutation', removeTierIIReportAssignees: Array<{ __typename?: 'TierIIReport', id: string, assignees: Array<{ __typename?: 'TierIIReportAssignee', id: string, assignmentType: AssignmentType, person: { __typename?: 'Person', id: string, first?: string | null, last?: string | null } }> }> };

export type CheckForFileQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type CheckForFileQuery = { __typename?: 'Query', checkForFile: { __typename?: 'CheckForFileResult', exists: boolean, signedUrl?: string | null } };

export type CreateTierIiReportMutationVariables = Exact<{
  facilityId: Scalars['ID'];
  reportingYear: Scalars['Int'];
  reportKind: TierIiReportKind;
}>;


export type CreateTierIiReportMutation = { __typename?: 'Mutation', createTierIIReport: { __typename?: 'TierIIReport', id: string } };

export type ImplementationsCreateWebAutomationJobsMutationVariables = Exact<{
  input: Array<CreateWebAutomationJobInput> | CreateWebAutomationJobInput;
}>;


export type ImplementationsCreateWebAutomationJobsMutation = { __typename?: 'Mutation', createWebAutomationJobs?: { __typename?: 'WebAutomationJobResult', count: number } | null };

export type DocumentTagsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type DocumentTagsQuery = { __typename?: 'Query', tags: { __typename?: 'TagsResult', items: Array<{ __typename?: 'Tag', id: string, name: string }> } };

export type InventoryOverviewQueryVariables = Exact<{
  facilityId: Scalars['ID'];
}>;


export type InventoryOverviewQuery = { __typename?: 'Query', facility?: { __typename?: 'Facility', id: string, name: string, streetAddress1?: string | null, city?: string | null, state?: string | null, zip?: string | null, collectionMode?: CollectionMode | null } | null };

export type GetJobQueryVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type GetJobQuery = { __typename?: 'Query', job: { __typename?: 'Job', status: JobStatus } };

export type CollectionModeFragment = { __typename?: 'Facility', id: string, collectionMode?: CollectionMode | null };

export type PaymentRowFragment = { __typename?: 'Payment', id: string, payee?: string | null, paidAt: any, paymentMethod?: PaymentMethod | null, amount?: number | null, payeeType?: Payee | null, activityId?: string | null, status: PaymentStatus, tenantId: string, lobMail?: { __typename?: 'LobMail', id: string, lobId: string, status?: LobMailStatus | null, type: LobMailType } | null };

export type SendLobCheckMutationVariables = Exact<{
  input: SendLobCheckInput;
}>;


export type SendLobCheckMutation = { __typename?: 'Mutation', sendLobCheck: { __typename?: 'Payment', id: string, payee?: string | null, paidAt: any, paymentMethod?: PaymentMethod | null, amount?: number | null, payeeType?: Payee | null, activityId?: string | null, status: PaymentStatus, tenantId: string, lobMail?: { __typename?: 'LobMail', id: string, lobId: string, status?: LobMailStatus | null, type: LobMailType } | null } };

export type UpsertPaymentMutationVariables = Exact<{
  input: PaymentInput;
}>;


export type UpsertPaymentMutation = { __typename?: 'Mutation', upsertPayment: { __typename?: 'Payment', id: string, payee?: string | null, paidAt: any, paymentMethod?: PaymentMethod | null, amount?: number | null, payeeType?: Payee | null, activityId?: string | null, status: PaymentStatus, tenantId: string, lobMail?: { __typename?: 'LobMail', id: string, lobId: string, status?: LobMailStatus | null, type: LobMailType } | null } };

export type CancelPaymentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CancelPaymentMutation = { __typename?: 'Mutation', cancelPayment: { __typename?: 'Payment', id: string, lobMail?: { __typename?: 'LobMail', lobId: string, type: LobMailType } | null } };

export type PaymentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PaymentQuery = { __typename?: 'Query', payment: { __typename?: 'Payment', id: string, payee?: string | null, paidAt: any, paymentMethod?: PaymentMethod | null, amount?: number | null, description?: string | null, status: PaymentStatus, payeeType?: Payee | null, company?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null, memo?: string | null, activityId?: string | null, document?: { __typename?: 'Document', fileExtension?: string | null, lobId?: string | null, id: string, title: string, description?: string | null, storageLink: string, documentType: DocumentType, updatedAt?: any | null, createdAt?: any | null, facilities?: Array<{ __typename?: 'Facility', id: string, name: string }> | null } | null, paymentInvoices?: Array<{ __typename?: 'PaymentInvoice', invoiceNumber?: string | null, invoiceDocument?: { __typename?: 'Document', fileExtension?: string | null, id: string, title: string, description?: string | null, storageLink: string, documentType: DocumentType, updatedAt?: any | null, createdAt?: any | null, facilities?: Array<{ __typename?: 'Facility', id: string, name: string }> | null } | null }> | null, tierIIReports?: Array<{ __typename?: 'TierIIReportPayment', amount?: number | null, tierIIReport?: { __typename?: 'TierIIReport', id: string } | null }> | null, facilities?: Array<{ __typename?: 'FacilityPayment', amount?: number | null, facility?: { __typename?: 'Facility', id: string } | null }> | null } };

export type PaymentsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type PaymentsQuery = { __typename?: 'Query', payments: { __typename?: 'PaymentsResult', count: number, items: Array<{ __typename?: 'Payment', id: string, tenantId: string, status: PaymentStatus, paymentMethod?: PaymentMethod | null, amount?: number | null, description?: string | null, memo?: string | null, payee?: string | null, paidAt: any, payeeType?: Payee | null, recordedByEmail?: string | null, tenant?: { __typename?: 'Tenant', name: string } | null, lobMail?: { __typename?: 'LobMail', lobId: string, type: LobMailType } | null, facilities?: Array<{ __typename?: 'FacilityPayment', facility?: { __typename?: 'Facility', id: string } | null }> | null, tierIIReports?: Array<{ __typename?: 'TierIIReportPayment', tierIIReport?: { __typename?: 'TierIIReport', id: string } | null }> | null, job?: { __typename?: 'Job', id: string, status: JobStatus } | null }> } };

export type TenantFragment = { __typename?: 'Tenant', id: string, name: string, isDisabled: boolean, isDemo: boolean, isPartner: boolean, partnerTenantId?: string | null };

export type GetTenantQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type GetTenantQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', featureFlags: any, id: string, name: string, isDisabled: boolean, isDemo: boolean, isPartner: boolean, partnerTenantId?: string | null } };

export type SetUserTenantMutationVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type SetUserTenantMutation = { __typename?: 'Mutation', setUserTenant: boolean };

export type VerifyCredentialMutationVariables = Exact<{
  input: VerifyCredentialInput;
}>;


export type VerifyCredentialMutation = { __typename?: 'Mutation', verifyCredential: { __typename?: 'VerifyCredentialResult', facilityId: string, queued: boolean } };

export type VerifyCredentialsMutationVariables = Exact<{
  input: Array<VerifyCredentialInput> | VerifyCredentialInput;
}>;


export type VerifyCredentialsMutation = { __typename?: 'Mutation', verifyCredentials: { __typename?: 'VerifyCredentialsResult', count: number, results: Array<{ __typename?: 'VerifyCredentialResult', facilityId: string, queued: boolean }> } };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', getCurrentUser: { __typename?: 'User', id: string, email: string, type: UserType, isPartner: boolean, isEmulating?: boolean | null, originalUserType?: UserType | null, person?: { __typename?: 'Person', id: string, first?: string | null, last?: string | null } | null, UserTenant: Array<{ __typename?: 'UserTenant', tenantId: string, role?: { __typename?: 'Role', permissions?: Array<Permission> | null } | null, tenant?: { __typename?: 'Tenant', id: string, partnersTenants: Array<{ __typename?: 'Tenant', id: string }> } | null }>, facilities: Array<{ __typename?: 'Facility', id: string }> } };

export type GetDocumentDownloadLinkQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDocumentDownloadLinkQuery = { __typename?: 'Query', getDocumentDownloadLink?: string | null };

export type RolesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type RolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, name: string, description?: string | null, permissions?: Array<Permission> | null }> };

export type GetRequiredStaffInputsQueryVariables = Exact<{
  activityDescription: Scalars['String'];
}>;


export type GetRequiredStaffInputsQuery = { __typename?: 'Query', getRequiredStaffInputs?: { __typename?: 'RequiredStaffInputResult', activityType?: string | null, jurisdictionType?: string | null, consolidated?: string | null, requiredStaffInputs: Array<{ __typename?: 'RequiredStaffInputItem', name: StaffInput, inputType?: StaffInputType | null }>, links?: Array<{ __typename?: 'StaffInputLink', name?: string | null, link: string }> | null } | null };

export type MyFacilitiesTagsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type MyFacilitiesTagsQuery = { __typename?: 'Query', tags: { __typename?: 'TagsResult', count: number, items: Array<{ __typename?: 'Tag', id: string, name: string, type: TagType }> } };

export type ChemicalDetailFragment = { __typename?: 'Chemical', id: string, name: string, alternateId?: string | null, casNumber?: string | null, density?: number | null, densityUnits?: DensityUnits | null, ehsForm?: EhsForm | null, healthHazards: Array<HealthHazard>, ifcHazards: Array<InternationalFireCodeHazard>, isEhs: boolean, isTradeSecret: boolean, noCasNumber?: boolean | null, noHazardsNotReporting?: boolean | null, oregonHazards: Array<OregonHazard>, physicalHazards: Array<PhysicalHazard>, pureOrMixture?: PureOrMixture | null, stateOfMatter: Array<StateOfMatter>, manufacturerSupplier?: string | null, version?: string | null, recommendedUse?: string | null, revisionDate?: any | null, verifiedAt?: any | null, verifiedBy?: string | null, components?: Array<{ __typename?: 'ChemicalComponent', id: string, casNumber?: string | null, componentPercentage?: number | null, name: string, weightOrVolume?: WeightOrVolume | null, isEhs: boolean, ehsForm?: EhsForm | null }> | null, stateFields?: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, tooltip?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }> | null, documents?: Array<{ __typename?: 'ChemicalDocument', id: string, chemicalId: string, documentId: string, document: { __typename?: 'Document', id: string, title: string, storageLink: string, fileExtension?: string | null, documentType: DocumentType } }> | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }>, verifier?: { __typename?: 'User', id: string, email: string, person?: { __typename?: 'Person', first?: string | null, last?: string | null } | null } | null };

export type ChemicalDetailChemicalQueryQueryVariables = Exact<{
  chemicalId: Scalars['ID'];
}>;


export type ChemicalDetailChemicalQueryQuery = { __typename?: 'Query', chemicalWithAssociatedData: { __typename?: 'ChemicalWithAssociatedData', jurisdictions: Array<string>, chemical: { __typename?: 'Chemical', id: string, name: string, alternateId?: string | null, casNumber?: string | null, density?: number | null, densityUnits?: DensityUnits | null, ehsForm?: EhsForm | null, healthHazards: Array<HealthHazard>, ifcHazards: Array<InternationalFireCodeHazard>, isEhs: boolean, isTradeSecret: boolean, noCasNumber?: boolean | null, noHazardsNotReporting?: boolean | null, oregonHazards: Array<OregonHazard>, physicalHazards: Array<PhysicalHazard>, pureOrMixture?: PureOrMixture | null, stateOfMatter: Array<StateOfMatter>, manufacturerSupplier?: string | null, version?: string | null, recommendedUse?: string | null, revisionDate?: any | null, verifiedAt?: any | null, verifiedBy?: string | null, components?: Array<{ __typename?: 'ChemicalComponent', id: string, casNumber?: string | null, componentPercentage?: number | null, name: string, weightOrVolume?: WeightOrVolume | null, isEhs: boolean, ehsForm?: EhsForm | null }> | null, stateFields?: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, tooltip?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }> | null, documents?: Array<{ __typename?: 'ChemicalDocument', id: string, chemicalId: string, documentId: string, document: { __typename?: 'Document', id: string, title: string, storageLink: string, fileExtension?: string | null, documentType: DocumentType } }> | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }>, verifier?: { __typename?: 'User', id: string, email: string, person?: { __typename?: 'Person', first?: string | null, last?: string | null } | null } | null } } };

export type ChemicalDetailForFacilityQueryQueryVariables = Exact<{
  chemicalId: Scalars['ID'];
  facilityId: Scalars['ID'];
}>;


export type ChemicalDetailForFacilityQueryQuery = { __typename?: 'Query', chemicalWithAssociatedDataForFacility: { __typename?: 'ChemicalWithAssociatedData', jurisdictions: Array<string>, chemical: { __typename?: 'Chemical', id: string, name: string, alternateId?: string | null, casNumber?: string | null, density?: number | null, densityUnits?: DensityUnits | null, ehsForm?: EhsForm | null, healthHazards: Array<HealthHazard>, ifcHazards: Array<InternationalFireCodeHazard>, isEhs: boolean, isTradeSecret: boolean, noCasNumber?: boolean | null, noHazardsNotReporting?: boolean | null, oregonHazards: Array<OregonHazard>, physicalHazards: Array<PhysicalHazard>, pureOrMixture?: PureOrMixture | null, stateOfMatter: Array<StateOfMatter>, manufacturerSupplier?: string | null, version?: string | null, recommendedUse?: string | null, revisionDate?: any | null, verifiedAt?: any | null, verifiedBy?: string | null, components?: Array<{ __typename?: 'ChemicalComponent', id: string, casNumber?: string | null, componentPercentage?: number | null, name: string, weightOrVolume?: WeightOrVolume | null, isEhs: boolean, ehsForm?: EhsForm | null }> | null, stateFields?: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, tooltip?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }> | null, documents?: Array<{ __typename?: 'ChemicalDocument', id: string, chemicalId: string, documentId: string, document: { __typename?: 'Document', id: string, title: string, storageLink: string, fileExtension?: string | null, documentType: DocumentType } }> | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }>, verifier?: { __typename?: 'User', id: string, email: string, person?: { __typename?: 'Person', first?: string | null, last?: string | null } | null } | null } } };

export type ChemicalDetailSaveChemicalMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ChemicalInput;
}>;


export type ChemicalDetailSaveChemicalMutation = { __typename?: 'Mutation', upsertChemical: { __typename?: 'Chemical', id: string, name: string, alternateId?: string | null, casNumber?: string | null, density?: number | null, densityUnits?: DensityUnits | null, ehsForm?: EhsForm | null, healthHazards: Array<HealthHazard>, ifcHazards: Array<InternationalFireCodeHazard>, isEhs: boolean, isTradeSecret: boolean, noCasNumber?: boolean | null, noHazardsNotReporting?: boolean | null, oregonHazards: Array<OregonHazard>, physicalHazards: Array<PhysicalHazard>, pureOrMixture?: PureOrMixture | null, stateOfMatter: Array<StateOfMatter>, manufacturerSupplier?: string | null, version?: string | null, recommendedUse?: string | null, revisionDate?: any | null, verifiedAt?: any | null, verifiedBy?: string | null, components?: Array<{ __typename?: 'ChemicalComponent', id: string, casNumber?: string | null, componentPercentage?: number | null, name: string, weightOrVolume?: WeightOrVolume | null, isEhs: boolean, ehsForm?: EhsForm | null }> | null, stateFields?: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, tooltip?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }> | null, documents?: Array<{ __typename?: 'ChemicalDocument', id: string, chemicalId: string, documentId: string, document: { __typename?: 'Document', id: string, title: string, storageLink: string, fileExtension?: string | null, documentType: DocumentType } }> | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }>, verifier?: { __typename?: 'User', id: string, email: string, person?: { __typename?: 'Person', first?: string | null, last?: string | null } | null } | null } };

export type VerifyChemicalMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type VerifyChemicalMutation = { __typename?: 'Mutation', verifyChemical?: { __typename?: 'Chemical', verifiedAt?: any | null, verifiedBy?: string | null, verifier?: { __typename?: 'User', id: string, email: string, person?: { __typename?: 'Person', first?: string | null, last?: string | null } | null } | null } | null };

export type UnverifyChemicalMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnverifyChemicalMutation = { __typename?: 'Mutation', unverifyChemical?: boolean | null };

export type DeleteChemicalDocumentMutationVariables = Exact<{
  input: DeleteChemicalDocumentInput;
}>;


export type DeleteChemicalDocumentMutation = { __typename?: 'Mutation', deleteChemicalDocument: { __typename?: 'DeleteChemicalDocumentResult', chemicalDocumentId?: string | null, document: { __typename?: 'Document', id: string } } };

export type FacilityUsageQueryQueryVariables = Exact<{
  chemicalId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  includeItems?: InputMaybe<Scalars['Boolean']>;
}>;


export type FacilityUsageQueryQuery = { __typename?: 'Query', facilityUsage: { __typename?: 'FacilityUsage', facilityCount: number, tenantCount: number, items?: Array<{ __typename?: 'Facility', id: string, name: string, tenant?: { __typename?: 'Tenant', id: string, name: string } | null }> } };

export type ProductChemicalFormFragment = { __typename?: 'ProductChemical', id: string, amount: number, chemicalId: string, pressure?: Pressure | null, productId: string, storageType?: string | null, storageTypeDescription?: string | null, temperature?: Temperature | null, unit: UnitType, overrides: Array<{ __typename?: 'ProductChemicalOverride', id: string, jurisdiction: string, storageType?: string | null, storageTypeDescription?: string | null, temperature?: Temperature | null, pressure?: Pressure | null }>, chemical: { __typename?: 'Chemical', id: string, name: string, pureOrMixture?: PureOrMixture | null, casNumber?: string | null, isEhs: boolean, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null } };

export type UpsertProductMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ProductInput;
}>;


export type UpsertProductMutation = { __typename?: 'Mutation', upsertProduct: { __typename?: 'Product', id: string, name: string } };

export type ProductDetailQueryQueryVariables = Exact<{
  productId: Scalars['ID'];
}>;


export type ProductDetailQueryQuery = { __typename?: 'Query', productWithFacilityCount: { __typename?: 'ProductWithFacilityCount', facilityCount: number, product: { __typename?: 'Product', id: string, name: string, alternateId?: string | null, reference?: string | null, productChemicals?: Array<{ __typename?: 'ProductChemical', id: string, amount: number, chemicalId: string, pressure?: Pressure | null, productId: string, storageType?: string | null, storageTypeDescription?: string | null, temperature?: Temperature | null, unit: UnitType, overrides: Array<{ __typename?: 'ProductChemicalOverride', id: string, jurisdiction: string, storageType?: string | null, storageTypeDescription?: string | null, temperature?: Temperature | null, pressure?: Pressure | null }>, chemical: { __typename?: 'Chemical', id: string, name: string, pureOrMixture?: PureOrMixture | null, casNumber?: string | null, isEhs: boolean, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null } }> | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> } } };

export type BulkVerifyChemicalsMutationVariables = Exact<{
  chemicalIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type BulkVerifyChemicalsMutation = { __typename?: 'Mutation', verifyChemicals?: boolean | null };

export type BulkUnverifyChemicalsMutationVariables = Exact<{
  chemicalIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type BulkUnverifyChemicalsMutation = { __typename?: 'Mutation', unverifyChemicals?: boolean | null };

export type GetCandidateChemicalsQueryVariables = Exact<{
  chemicalIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetCandidateChemicalsQuery = { __typename?: 'Query', chemicalsByIds: Array<{ __typename?: 'Chemical', id: string, name: string, casNumber?: string | null, alternateId?: string | null, ehsForm?: EhsForm | null, stateOfMatter: Array<StateOfMatter>, density?: number | null, densityUnits?: DensityUnits | null, isEhs: boolean, noHazardsNotReporting?: boolean | null, isTradeSecret: boolean, manufacturerSupplier?: string | null, recommendedUse?: string | null, version?: string | null, revisionDate?: any | null, pureOrMixture?: PureOrMixture | null, physicalHazards: Array<PhysicalHazard>, healthHazards: Array<HealthHazard>, documents?: Array<{ __typename?: 'ChemicalDocument', id: string, key: string, name: string, documentId: string, document: { __typename?: 'Document', id: string, documentType: DocumentType, title: string, description?: string | null, storageLink: string } }> | null, components?: Array<{ __typename?: 'ChemicalComponent', id: string, name: string, componentPercentage?: number | null, weightOrVolume?: WeightOrVolume | null, casNumber?: string | null, isEhs: boolean, noCasNumber?: boolean | null }> | null, stateFields?: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, label: string, jurisdiction: string, tooltip?: string | null }> | null, associatedFacilities: Array<{ __typename?: 'Facility', id: string }>, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> }> };

export type MergeChemicalsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  input: ChemicalInput;
}>;


export type MergeChemicalsMutation = { __typename?: 'Mutation', mergeChemicals?: { __typename?: 'Chemical', id: string, name: string } | null };

export type TenantCatalogChemicalFragment = { __typename?: 'Chemical', id: string, name: string, casNumber?: string | null, isEhs: boolean, pureOrMixture?: PureOrMixture | null, alternateId?: string | null, needsReview: boolean, issueCount?: number | null, documents?: Array<{ __typename?: 'ChemicalDocument', id: string, document: { __typename?: 'Document', id: string, documentType: DocumentType } }> | null, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null };

export type TenantCatalogChemicalsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type TenantCatalogChemicalsQuery = { __typename?: 'Query', chemicals: { __typename?: 'ChemicalsResult', count: number, items: Array<{ __typename?: 'Chemical', id: string, name: string, casNumber?: string | null, isEhs: boolean, pureOrMixture?: PureOrMixture | null, alternateId?: string | null, needsReview: boolean, issueCount?: number | null, documents?: Array<{ __typename?: 'ChemicalDocument', id: string, document: { __typename?: 'Document', id: string, documentType: DocumentType } }> | null, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null }> } };

export type TenantCatalogProductFragment = { __typename?: 'Product', id: string, name: string, alternateId?: string | null, reference?: string | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type TenantCatalogProductsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type TenantCatalogProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductsResult', count: number, items: Array<{ __typename?: 'Product', id: string, name: string, alternateId?: string | null, reference?: string | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> }> } };

export type CreateNewProductMutationVariables = Exact<{
  productInput: ProductInput;
}>;


export type CreateNewProductMutation = { __typename?: 'Mutation', upsertProduct: { __typename?: 'Product', id: string } };

export type CreateNewChemicalMutationVariables = Exact<{
  chemicalInput: ChemicalInput;
}>;


export type CreateNewChemicalMutation = { __typename?: 'Mutation', upsertChemical: { __typename?: 'Chemical', id: string } };

export type DeleteTenantCatalogProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTenantCatalogProductMutation = { __typename?: 'Mutation', deleteProduct: { __typename?: 'Product', id: string } };

export type DeleteTenantCatalogChemicalMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTenantCatalogChemicalMutation = { __typename?: 'Mutation', deleteChemical: { __typename?: 'Chemical', id: string } };

export type JobQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type JobQuery = { __typename?: 'Query', job: { __typename?: 'Job', id: string, status: JobStatus } };

export type ChemicalsWithMeasurementsQueryVariables = Exact<{
  facilityId: Scalars['ID'];
  reportingYear: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type ChemicalsWithMeasurementsQuery = { __typename?: 'Query', facilityChemicalMeasurementsForReport: { __typename?: 'facilityChemicalMeasurementsForReportResult', count: number, items: Array<{ __typename?: 'ChemicalMeasurementSummary', id: string, name: string, pureOrMixture?: PureOrMixture | null, casNumber?: string | null, isEhs?: boolean | null, alternateId?: string | null, totalMeasurements?: number | null, hasCarryOver?: boolean | null, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null, maxAmount?: { __typename?: 'AmountWithUnit', amount?: number | null, amountCode?: number | null, unit?: UnitType | null } | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> }> } };

export type DeleteFacilityChemicalMeasurementsByChemicalAndYearMutationVariables = Exact<{
  facilityId: Scalars['ID'];
  chemicalId: Scalars['ID'];
  reportingYear: Scalars['Int'];
  addZeroMeasurement?: InputMaybe<Scalars['Boolean']>;
}>;


export type DeleteFacilityChemicalMeasurementsByChemicalAndYearMutation = { __typename?: 'Mutation', deleteFacilityChemicalMeasurementsByChemicalAndYear?: { __typename?: 'deleteFacilityChemicalMeasurementsByChemicalAndYearResult', facilityId: string, chemicalId: string, reportingYear: number } | null };

export type ContactsFacilitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type ContactsFacilitiesQuery = { __typename?: 'Query', facilities: { __typename?: 'FacilitiesResult', count: number, items: Array<{ __typename?: 'Facility', id: string, name: string, customerFacilityId?: string | null, collectionMode?: CollectionMode | null, streetAddress1?: string | null, city?: string | null, state?: string | null, issues: Array<{ __typename?: 'Issue', key?: string | null, modelName: string }> }> } };

export type DocumentFacilitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type DocumentFacilitiesQuery = { __typename?: 'Query', facilities: { __typename?: 'FacilitiesResult', count: number, items: Array<{ __typename?: 'Facility', id: string, name: string, customerFacilityId?: string | null, collectionMode?: CollectionMode | null, streetAddress1?: string | null, city?: string | null, state?: string | null, issues: Array<{ __typename?: 'Issue', key?: string | null, modelName: string }> }> } };

export type FacilitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type FacilitiesQuery = { __typename?: 'Query', facilities: { __typename?: 'FacilitiesResult', count: number, items: Array<{ __typename?: 'Facility', id: string, name: string, customerFacilityId?: string | null, streetAddress1?: string | null, city?: string | null, state?: string | null, zip?: string | null, tenantId?: string | null }> } };

export type UpsertFacilityChemicalMeasurementMutationVariables = Exact<{
  id: Scalars['ID'];
  input: FacilityChemicalMeasurementInput;
}>;


export type UpsertFacilityChemicalMeasurementMutation = { __typename?: 'Mutation', upsertFacilityChemicalMeasurement?: { __typename?: 'FacilityChemicalMeasurement', id: string } | null };

export type FacilityChemicalMeasurementQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FacilityChemicalMeasurementQuery = { __typename?: 'Query', facilityChemicalMeasurement?: { __typename?: 'FacilityChemicalMeasurement', id: string, amount: number, unit: UnitType, pressure?: Pressure | null, otherPressureValue?: string | null, temperature?: Temperature | null, measuredAtUtc: any, storageType?: string | null, storageTypeDescription?: string | null, chemicalId: string, storageLocationId: string, chemical?: { __typename?: 'Chemical', alternateId?: string | null, id: string, name: string, pureOrMixture?: PureOrMixture | null, casNumber?: string | null, isEhs: boolean, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null } | null, storageLocation?: { __typename?: 'StorageLocation', id: string, description?: string | null, facilityId: string, CA_mapNumber?: string | null, CA_gridNumber?: string | null, OR_insideOutside?: InsideOutside | null, OR_storageArea?: string | null, OR_storageBuilding?: string | null, OR_storageFloor?: string | null, OR_storageQuadrant?: StorageQuadrant | null, OR_storageRoom?: string | null, latitude?: number | null, longitude?: number | null } | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> } | null };

export type FacilityChemicalsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type FacilityChemicalsQuery = { __typename?: 'Query', facilityChemicals: { __typename?: 'FacilityChemicalsResult', count: number, items: Array<{ __typename?: 'FacilityChemical', id: string, maxAmount?: number | null, maxAmountCode?: number | null, averageAmount?: number | null, averageAmountCode?: number | null, unit?: UnitType | null, isAlwaysReported?: boolean | null, facility?: { __typename?: 'Facility', state?: string | null } | null, chemical?: { __typename?: 'Chemical', id: string, alternateId?: string | null, isEhs: boolean, noHazardsNotReporting?: boolean | null, name: string, pureOrMixture?: PureOrMixture | null, casNumber?: string | null, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null } | null, reportingFacilityChemical?: { __typename?: 'ReportingFacilityChemical', id: string, isOverThreshold?: boolean | null } | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> }> } };

export type GetFacilityChemicalInventoryStatusQueryVariables = Exact<{
  facilityId: Scalars['ID'];
  toYear: Scalars['Int'];
}>;


export type GetFacilityChemicalInventoryStatusQuery = { __typename?: 'Query', facilityInventoryStatus: { __typename?: 'InventoryStatusResult', exists: boolean, mostRecentYear?: number | null } };

export type DeleteFacilityChemicalMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFacilityChemicalMutation = { __typename?: 'Mutation', deleteFacilityChemical: { __typename?: 'FacilityChemical', id: string } };

export type CopyChemicalInventoryMutationVariables = Exact<{
  facilityId: Scalars['ID'];
  toYear: Scalars['Int'];
}>;


export type CopyChemicalInventoryMutation = { __typename?: 'Mutation', copyFacilityChemicals: { __typename?: 'CopyInventoryResult', success: boolean, reason?: string | null, fromYear?: number | null } };

export type UpsertFacilityProductMeasurementMutationVariables = Exact<{
  id: Scalars['ID'];
  input: FacilityProductMeasurementInput;
}>;


export type UpsertFacilityProductMeasurementMutation = { __typename?: 'Mutation', upsertFacilityProductMeasurement?: { __typename?: 'FacilityProductMeasurement', id: string } | null };

export type FacilityProductMeasurementQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FacilityProductMeasurementQuery = { __typename?: 'Query', facilityProductMeasurement?: { __typename?: 'FacilityProductMeasurement', id: string, measuredAtUtc: any, quantity: number, storageLocationId: string, product?: { __typename?: 'Product', id: string, name: string } | null, storageLocation?: { __typename?: 'StorageLocation', id: string, description?: string | null, facilityId: string, CA_mapNumber?: string | null, CA_gridNumber?: string | null, OR_insideOutside?: InsideOutside | null, OR_storageArea?: string | null, OR_storageBuilding?: string | null, OR_storageFloor?: string | null, OR_storageQuadrant?: StorageQuadrant | null, OR_storageRoom?: string | null, latitude?: number | null, longitude?: number | null } | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> } | null };

export type ProductForFacilityQueryVariables = Exact<{
  productId: Scalars['ID'];
  facilityId: Scalars['ID'];
}>;


export type ProductForFacilityQuery = { __typename?: 'Query', productForFacility: { __typename?: 'Product', id: string, name: string, productChemicals?: Array<{ __typename?: 'ProductChemical', chemical: { __typename?: 'Chemical', id: string, name: string } }> | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> } };

export type DeleteFacilityProductMeasurementMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFacilityProductMeasurementMutation = { __typename?: 'Mutation', deleteFacilityProductMeasurement: { __typename?: 'FacilityProductMeasurement', id: string } };

export type CopyProductInventoryMutationVariables = Exact<{
  facilityId: Scalars['ID'];
  toYear: Scalars['Int'];
}>;


export type CopyProductInventoryMutation = { __typename?: 'Mutation', copyFacilityProducts: { __typename?: 'CopyInventoryResult', success: boolean, reason?: string | null, fromYear?: number | null } };

export type GetFacilityProductInventoryStatusQueryVariables = Exact<{
  facilityId: Scalars['ID'];
  toYear: Scalars['Int'];
}>;


export type GetFacilityProductInventoryStatusQuery = { __typename?: 'Query', facilityInventoryStatus: { __typename?: 'InventoryStatusResult', exists: boolean, mostRecentYear?: number | null } };

export type FacilityChemicalChemicalFragment = { __typename?: 'Chemical', id: string, alternateId?: string | null, isEhs: boolean, name: string, pureOrMixture?: PureOrMixture | null, casNumber?: string | null, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null };

export type FacilityChemicalDetailsFragment = { __typename?: 'FacilityChemical', id: string, reportingYear: number, unit?: UnitType | null, hasConfidentialStorageLocations?: boolean | null, isAlwaysReported?: boolean | null, jurisdictions?: Array<string> | null, maxAmount?: number | null, maxAmountCode?: number | null, averageAmount?: number | null, averageAmountCode?: number | null, maxAmountLargestContainer?: number | null, daysOnSite?: number | null, facility?: { __typename?: 'Facility', id: string, name: string, state?: string | null } | null, chemical?: { __typename?: 'Chemical', id: string, alternateId?: string | null, isEhs: boolean, name: string, pureOrMixture?: PureOrMixture | null, casNumber?: string | null, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null } | null, storageLocations?: Array<{ __typename?: 'FacilityChemicalStorageLocation', id: string, maxAmount?: number | null, storageLocationId: string, pressure?: Pressure | null, otherPressureValue?: string | null, storageType?: string | null, storageTypeDescription?: string | null, temperature?: Temperature | null, unit?: UnitType | null, storageLocation?: { __typename?: 'StorageLocation', id: string, description?: string | null, facilityId: string, CA_mapNumber?: string | null, CA_gridNumber?: string | null, OR_insideOutside?: InsideOutside | null, OR_storageArea?: string | null, OR_storageBuilding?: string | null, OR_storageFloor?: string | null, OR_storageQuadrant?: StorageQuadrant | null, OR_storageRoom?: string | null, latitude?: number | null, longitude?: number | null } | null }> | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }>, stateFields: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, tooltip?: string | null, group?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }> };

export type FacilityChemicalDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FacilityChemicalDetailsQuery = { __typename?: 'Query', facilityChemical?: { __typename?: 'FacilityChemical', id: string, reportingYear: number, unit?: UnitType | null, hasConfidentialStorageLocations?: boolean | null, isAlwaysReported?: boolean | null, jurisdictions?: Array<string> | null, maxAmount?: number | null, maxAmountCode?: number | null, averageAmount?: number | null, averageAmountCode?: number | null, maxAmountLargestContainer?: number | null, daysOnSite?: number | null, facility?: { __typename?: 'Facility', id: string, name: string, state?: string | null } | null, chemical?: { __typename?: 'Chemical', id: string, alternateId?: string | null, isEhs: boolean, name: string, pureOrMixture?: PureOrMixture | null, casNumber?: string | null, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null } | null, storageLocations?: Array<{ __typename?: 'FacilityChemicalStorageLocation', id: string, maxAmount?: number | null, storageLocationId: string, pressure?: Pressure | null, otherPressureValue?: string | null, storageType?: string | null, storageTypeDescription?: string | null, temperature?: Temperature | null, unit?: UnitType | null, storageLocation?: { __typename?: 'StorageLocation', id: string, description?: string | null, facilityId: string, CA_mapNumber?: string | null, CA_gridNumber?: string | null, OR_insideOutside?: InsideOutside | null, OR_storageArea?: string | null, OR_storageBuilding?: string | null, OR_storageFloor?: string | null, OR_storageQuadrant?: StorageQuadrant | null, OR_storageRoom?: string | null, latitude?: number | null, longitude?: number | null } | null }> | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }>, stateFields: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, tooltip?: string | null, group?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }> } | null };

export type EditFacilityChemicalMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  input: FacilityChemicalInput;
  reportId?: InputMaybe<Scalars['ID']>;
}>;


export type EditFacilityChemicalMutation = { __typename?: 'Mutation', upsertFacilityChemical: { __typename?: 'FacilityChemical', id: string, reportingYear: number, unit?: UnitType | null, hasConfidentialStorageLocations?: boolean | null, isAlwaysReported?: boolean | null, jurisdictions?: Array<string> | null, maxAmount?: number | null, maxAmountCode?: number | null, averageAmount?: number | null, averageAmountCode?: number | null, maxAmountLargestContainer?: number | null, daysOnSite?: number | null, facility?: { __typename?: 'Facility', id: string, name: string, state?: string | null } | null, chemical?: { __typename?: 'Chemical', id: string, alternateId?: string | null, isEhs: boolean, name: string, pureOrMixture?: PureOrMixture | null, casNumber?: string | null, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null } | null, storageLocations?: Array<{ __typename?: 'FacilityChemicalStorageLocation', id: string, maxAmount?: number | null, storageLocationId: string, pressure?: Pressure | null, otherPressureValue?: string | null, storageType?: string | null, storageTypeDescription?: string | null, temperature?: Temperature | null, unit?: UnitType | null, storageLocation?: { __typename?: 'StorageLocation', id: string, description?: string | null, facilityId: string, CA_mapNumber?: string | null, CA_gridNumber?: string | null, OR_insideOutside?: InsideOutside | null, OR_storageArea?: string | null, OR_storageBuilding?: string | null, OR_storageFloor?: string | null, OR_storageQuadrant?: StorageQuadrant | null, OR_storageRoom?: string | null, latitude?: number | null, longitude?: number | null } | null }> | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }>, stateFields: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, tooltip?: string | null, group?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }> } };

export type PreviousYearValuesQueryVariables = Exact<{
  facilityId: Scalars['ID'];
  chemicalId: Scalars['ID'];
  reportingYear: Scalars['Int'];
}>;


export type PreviousYearValuesQuery = { __typename?: 'Query', facilityChemicalByYear?: { __typename?: 'FacilityChemical', maxAmount?: number | null, unit?: UnitType | null } | null };

export type IsChemicalOverThresholdQueryVariables = Exact<{
  input: FacilityChemicalInput;
}>;


export type IsChemicalOverThresholdQuery = { __typename?: 'Query', getFacilityChemicalThresholdData: { __typename?: 'FacilityChemicalThresholdData', isOverThreshold?: boolean | null } };

export type GetFacilityChemicalStateFieldsQueryVariables = Exact<{
  facilityId: Scalars['ID'];
}>;


export type GetFacilityChemicalStateFieldsQuery = { __typename?: 'Query', facilityChemicalStateFieldsForFacility?: { __typename?: 'DynamicFieldsResult', items: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, jurisdiction: string, label: string, tooltip?: string | null, type?: ProgramArea | null, inputType: DynamicFieldType, group?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }> } | null };

export type DeleteFacilityChemicalMeasurementMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFacilityChemicalMeasurementMutation = { __typename?: 'Mutation', deleteFacilityChemicalMeasurement: { __typename?: 'FacilityChemicalMeasurement', id: string } };

export type ReportingFacilityChemicalStorageLocationFormFragment = { __typename?: 'ReportingFacilityChemicalStorageLocation', id: string, maxAmount?: number | null, storageLocationId: string, pressure?: Pressure | null, otherPressureValue?: string | null, storageType?: string | null, storageTypeDescription?: string | null, temperature?: Temperature | null, unit?: UnitType | null, storageLocation?: { __typename?: 'StorageLocation', id: string, description?: string | null, facilityId: string, CA_mapNumber?: string | null, CA_gridNumber?: string | null, OR_insideOutside?: InsideOutside | null, OR_storageArea?: string | null, OR_storageBuilding?: string | null, OR_storageFloor?: string | null, OR_storageQuadrant?: StorageQuadrant | null, OR_storageRoom?: string | null, latitude?: number | null, longitude?: number | null } | null };

export type FacilityChemicalStorageLocationFormFragment = { __typename?: 'FacilityChemicalStorageLocation', id: string, maxAmount?: number | null, storageLocationId: string, pressure?: Pressure | null, otherPressureValue?: string | null, storageType?: string | null, storageTypeDescription?: string | null, temperature?: Temperature | null, unit?: UnitType | null, storageLocation?: { __typename?: 'StorageLocation', id: string, description?: string | null, facilityId: string, CA_mapNumber?: string | null, CA_gridNumber?: string | null, OR_insideOutside?: InsideOutside | null, OR_storageArea?: string | null, OR_storageBuilding?: string | null, OR_storageFloor?: string | null, OR_storageQuadrant?: StorageQuadrant | null, OR_storageRoom?: string | null, latitude?: number | null, longitude?: number | null } | null };

export type InventoryFacilityChemicalsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type InventoryFacilityChemicalsQuery = { __typename?: 'Query', facilityChemicals: { __typename?: 'FacilityChemicalsResult', count: number, items: Array<{ __typename?: 'FacilityChemical', id: string, reportingYear: number, maxAmount?: number | null, maxAmountCode?: number | null, averageAmount?: number | null, averageAmountCode?: number | null, unit?: UnitType | null, updatedAt: any, issueCount?: number | null, chemical?: { __typename?: 'Chemical', id: string, alternateId?: string | null, name: string, pureOrMixture?: PureOrMixture | null, casNumber?: string | null, isEhs: boolean, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null } | null, facility?: { __typename?: 'Facility', state?: string | null } | null, storageLocations?: Array<{ __typename?: 'FacilityChemicalStorageLocation', id: string }> | null }> } };

export type GetFacilityProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetFacilityProductQuery = { __typename?: 'Query', facilityProduct: { __typename?: 'FacilityProduct', id: string, reportingYear: number, maxQuantity?: number | null, averageQuantity?: number | null, daysOnSite?: number | null, hasConfidentialStorageLocations?: boolean | null, facilityId: string, productId: string, product?: { __typename?: 'Product', id: string, name: string, productChemicals?: Array<{ __typename?: 'ProductChemical', id: string, amount: number, unit: UnitType, storageType?: string | null, storageTypeDescription?: string | null, pressure?: Pressure | null, temperature?: Temperature | null, chemical: { __typename?: 'Chemical', id: string, name: string } }> | null } | null, storageLocations?: Array<{ __typename?: 'FacilityProductStorageLocation', id: string, maxQuantity?: number | null, storageLocation?: { __typename?: 'StorageLocation', id: string, description?: string | null, facilityId: string, CA_mapNumber?: string | null, CA_gridNumber?: string | null, OR_insideOutside?: InsideOutside | null, OR_storageArea?: string | null, OR_storageBuilding?: string | null, OR_storageFloor?: string | null, OR_storageQuadrant?: StorageQuadrant | null, OR_storageRoom?: string | null, latitude?: number | null, longitude?: number | null } | null }> | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> } };

export type GetFacilityProductPreviousYearValuesQueryVariables = Exact<{
  facilityId: Scalars['ID'];
  productId: Scalars['ID'];
  reportingYear: Scalars['Int'];
}>;


export type GetFacilityProductPreviousYearValuesQuery = { __typename?: 'Query', facilityProductByYear?: { __typename?: 'FacilityProduct', id: string, reportingYear: number, maxQuantity?: number | null, averageQuantity?: number | null, daysOnSite?: number | null } | null };

export type SaveFacilityProductMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  input: FacilityProductInput;
}>;


export type SaveFacilityProductMutation = { __typename?: 'Mutation', upsertFacilityProduct: { __typename?: 'FacilityProduct', id: string } };

export type FacilityChemicalMeasurementsDetailsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type FacilityChemicalMeasurementsDetailsQuery = { __typename?: 'Query', facilityChemicalMeasurements: { __typename?: 'FacilityChemicalMeasurementsResult', count: number, items: Array<{ __typename?: 'FacilityChemicalMeasurement', id: string, amount: number, unit: UnitType, pressure?: Pressure | null, otherPressureValue?: string | null, temperature?: Temperature | null, measuredAtUtc: any, storageType?: string | null, storageTypeDescription?: string | null, chemicalId: string, storageLocationId: string, issueCount?: number | null, chemical?: { __typename?: 'Chemical', alternateId?: string | null, id: string, name: string, pureOrMixture?: PureOrMixture | null, casNumber?: string | null, isEhs: boolean, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null } | null, storageLocation?: { __typename?: 'StorageLocation', id: string, description?: string | null, facilityId: string, CA_mapNumber?: string | null, CA_gridNumber?: string | null, OR_insideOutside?: InsideOutside | null, OR_storageArea?: string | null, OR_storageBuilding?: string | null, OR_storageFloor?: string | null, OR_storageQuadrant?: StorageQuadrant | null, OR_storageRoom?: string | null, latitude?: number | null, longitude?: number | null } | null }> } };

export type FacilityProductMeasurementsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type FacilityProductMeasurementsQuery = { __typename?: 'Query', facilityProductMeasurements: { __typename?: 'FacilityProductMeasurementsResult', count: number, items: Array<{ __typename?: 'FacilityProductMeasurement', id: string, measuredAtUtc: any, quantity: number, storageLocationId: string, storageLocation?: { __typename?: 'StorageLocation', id: string, description?: string | null, facilityId: string, CA_mapNumber?: string | null, CA_gridNumber?: string | null, OR_insideOutside?: InsideOutside | null, OR_storageArea?: string | null, OR_storageBuilding?: string | null, OR_storageFloor?: string | null, OR_storageQuadrant?: StorageQuadrant | null, OR_storageRoom?: string | null, latitude?: number | null, longitude?: number | null } | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> }> } };

export type InventoryFacilitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type InventoryFacilitiesQuery = { __typename?: 'Query', facilities: { __typename?: 'FacilitiesResult', count: number, items: Array<{ __typename?: 'Facility', id: string, name: string, customerFacilityId?: string | null, collectionMode?: CollectionMode | null, streetAddress1?: string | null, city?: string | null, state?: string | null, isSubjectToEmergencyPlanning?: boolean | null }> } };

export type ChemicalAnomaliesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  filter?: InputMaybe<ChemicalOverviewFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type ChemicalAnomaliesQuery = { __typename?: 'Query', chemicalAnomalies: { __typename?: 'ChemicalAnomaliesResult', count: number, items: Array<{ __typename?: 'ChemicalAnomaly', facilityId: string, facilityName: string, chemicalId: string, chemicalName: string, previousYearMaxAmount?: number | null, previousYearUnit?: UnitType | null, previousYearReportId?: string | null, currentYearMaxAmount?: number | null, currentYearUnit?: UnitType | null, currentYearReportId?: string | null }> } };

export type EncampFilingStatusQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  reportKind: TierIiReportKind;
  filter?: InputMaybe<ChemicalOverviewFilter>;
}>;


export type EncampFilingStatusQuery = { __typename?: 'Query', encampFilingStatus: { __typename?: 'EncampFilingStatusResult', totalWaitingToReceive: number, totalWaitingToFile: number, totalFiled: number } };

export type EncampStatsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type EncampStatsQuery = { __typename?: 'Query', encampStats: { __typename?: 'EncampStats', treesPlanted: number, hoursSaved: number, totalPaymentsManaged: number, totalPaymentsMade: number } };

export type MyFacilitiesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  filter?: InputMaybe<ChemicalOverviewFilter>;
}>;


export type MyFacilitiesQuery = { __typename?: 'Query', myTierIIFacilities: { __typename?: 'MyTierIIFacilityResult', myReportingFacilityCount: number, myNonReportingFacilityCount: number, totalFacilityCount: number, myAssignedFacilityCount: number, myAuthorizedFacilityCount: number } };

export type MyProgressQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  filter?: InputMaybe<ChemicalOverviewFilter>;
}>;


export type MyProgressQuery = { __typename?: 'Query', chemicalsOverviewMyProgress: { __typename?: 'ChemicalsOverviewMyProgressResult', reportsRemaining: number, reportsTotal: number, dueDate: string } };

export type MyReportStatusQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  reportKind: TierIiReportKind;
  filter?: InputMaybe<ChemicalOverviewFilter>;
}>;


export type MyReportStatusQuery = { __typename?: 'Query', myReportStatus: { __typename?: 'MyReportStatus', notStarted: { __typename?: 'MyReportStatusItem', count: number, percent: number }, inProgress: { __typename?: 'MyReportStatusItem', count: number, percent: number }, inReview: { __typename?: 'MyReportStatusItem', count: number, percent: number }, submittedToEncamp: { __typename?: 'MyReportStatusItem', count: number, percent: number }, notReporting: { __typename?: 'MyReportStatusItem', count: number, percent: number } } };

export type OutstandingReviewsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  filter?: InputMaybe<ChemicalOverviewFilter>;
}>;


export type OutstandingReviewsQuery = { __typename?: 'Query', outstandingReviews: { __typename?: 'OutstandingReviewsResult', reportsWithoutReviewerCount: number, reviewers: Array<{ __typename?: 'OutstandingReviewer', userId: string, first: string, last: string, email: string, reportCount: number }> } };

export type ProblematicReportsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  filter?: InputMaybe<ChemicalOverviewFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type ProblematicReportsQuery = { __typename?: 'Query', problematicReports: { __typename?: 'FacilityTierIIReportsResult', count: number, items: Array<{ __typename?: 'FacilityTierIIReport', tierIIReportId?: string | null, facilityId: string, facilityName?: string | null, streetAddress1?: string | null, city?: string | null, state?: string | null, zip?: string | null, reportKind?: TierIiReportKind | null, issueCount?: number | null }> } };

export type ProlificIssuesQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  filter?: InputMaybe<ChemicalOverviewFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type ProlificIssuesQuery = { __typename?: 'Query', prolificIssues: { __typename?: 'ProlificIssuesResult', count: number, items: Array<{ __typename?: 'ProlificIssue', reportsAffected: number, url?: string | null, issue: { __typename?: 'ModelIssue', id: string, modelName: string, dataName?: string | null, message: string } }> } };

export type ProductsWithMeasurementsQueryVariables = Exact<{
  facilityId: Scalars['ID'];
  reportingYear: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type ProductsWithMeasurementsQuery = { __typename?: 'Query', productMeasurementsForReport: { __typename?: 'ProductMeasurementsForReportResult', count: number, items: Array<{ __typename?: 'ProductMeasurementSummary', id: string, name: string, totalMeasurements: number, productChemicals: Array<{ __typename?: 'ProductChemicalMeasurementSummary', chemical: { __typename?: 'Chemical', name: string, id: string, pureOrMixture?: PureOrMixture | null, casNumber?: string | null, isEhs: boolean, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null }, maxAmount?: { __typename?: 'AmountWithUnit', amount?: number | null, unit?: UnitType | null } | null }>, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> }> } };

export type DeleteFacilityProductMeasurementsByProductAndYearMutationVariables = Exact<{
  facilityId: Scalars['ID'];
  productId: Scalars['ID'];
  reportingYear: Scalars['Int'];
}>;


export type DeleteFacilityProductMeasurementsByProductAndYearMutation = { __typename?: 'Mutation', deleteFacilityProductMeasurementsByProductAndYear?: { __typename?: 'deleteFacilityProductMeasurementsByProductAndYearResult', facilityId: string, productId: string, reportingYear: number } | null };

export type RemoveFacilityChemicalMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveFacilityChemicalMutation = { __typename?: 'Mutation', deleteFacilityChemical: { __typename?: 'FacilityChemical', id: string } };

export type FacilityInfoFragment = { __typename?: 'Facility', id: string, name: string, companyName?: string | null, department?: string | null, isMailingAddressSameAsFacility?: boolean | null, isMailingAddressEncamp?: boolean | null, isUnmanned?: boolean | null, maxNumOccupants?: number | null, fireDepartmentId?: string | null, lepcId?: string | null, dbNumber?: string | null, naicsCode?: number | null, longitude?: number | null, latitude?: number | null, state?: string | null, county?: string | null, municipality?: string | null, phone?: string | null, phone24Hour?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, zip?: string | null, mailingStreetAddress1?: string | null, mailingStreetAddress2?: string | null, mailingCity?: string | null, mailingState?: string | null, mailingZip?: string | null, dateClosed?: any | null, dateOpened?: any | null, dateInactive?: any | null, status?: FacilityStatus | null, fireDepartment?: { __typename?: 'FireDepartment', id: string, name?: string | null, city?: string | null, state?: string | null, mailingAddress?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null } | null, lepc?: { __typename?: 'Lepc', id: string, name: string, mailingAddress?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null, isEmailed: boolean } | null };

export type FacilityQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FacilityQuery = { __typename?: 'Query', facility?: { __typename?: 'Facility', isInactive?: boolean | null, isClosed?: boolean | null, isNotReporting?: boolean | null, isNotReportingThroughEncamp?: boolean | null, dateClosed?: any | null, dateInactive?: any | null, colocationReportingFacility?: { __typename?: 'Facility', id: string } | null } | null };

export type RegulatoryInfoFragment = { __typename?: 'Facility', isSubjectToChemicalAccidentPrevention?: boolean | null, isSubjectToEmergencyPlanning?: boolean | null, isSubjectToToxicsReleaseInventoryReporting?: boolean | null, facilityAlternateIds?: Array<{ __typename?: 'AlternateId', id: string, type: string, value: string, expiresAt?: any | null, hasNoId: boolean }> | null };

export type UpdateNotesToRegulatorMutationVariables = Exact<{
  reportId: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
}>;


export type UpdateNotesToRegulatorMutation = { __typename?: 'Mutation', updateNotesToRegulators: { __typename?: 'TierIIReport', id: string, organizationStatus: TierIiReportOrgStatus, notesToRegulators?: string | null, touchedSteps?: Array<TierIiReportStep> | null, assignees: Array<{ __typename?: 'TierIIReportAssignee', id: string, isComplete?: boolean | null }> } };

export type SetInReviewStatusMutationVariables = Exact<{
  reportId: Scalars['ID'];
  inReview: Scalars['Boolean'];
}>;


export type SetInReviewStatusMutation = { __typename?: 'Mutation', setInReviewStatus: { __typename?: 'TierIIReport', id: string, organizationStatus: TierIiReportOrgStatus, reviewers: Array<{ __typename?: 'TierIIReportAssignee', id: string, isComplete?: boolean | null }> } };

export type EmailReviewersMutationVariables = Exact<{
  reportId: Scalars['ID'];
}>;


export type EmailReviewersMutation = { __typename?: 'Mutation', emailReviewers: { __typename?: 'EmailReviewersResult', success: boolean, ids: Array<string> } };

export type CompleteReviewMutationVariables = Exact<{
  reportId: Scalars['ID'];
}>;


export type CompleteReviewMutation = { __typename?: 'Mutation', completeTierIIReportReviewStep: { __typename?: 'TierIIReport', id: string, reviewCompletedByUserId?: string | null } };

export type SetReviewCompleteMutationVariables = Exact<{
  reportId: Scalars['ID'];
  reviewComplete: Scalars['Boolean'];
}>;


export type SetReviewCompleteMutation = { __typename?: 'Mutation', setReviewComplete: { __typename?: 'TierIIReport', id: string, organizationStatus: TierIiReportOrgStatus, notesToRegulators?: string | null, touchedSteps?: Array<TierIiReportStep> | null, reviewers: Array<{ __typename?: 'TierIIReportAssignee', id: string, assignmentType: AssignmentType, isComplete?: boolean | null, person: { __typename?: 'Person', id: string, first?: string | null, last?: string | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null } }> } };

export type StateInfoFragment = { __typename?: 'Facility', stateFields: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, tooltip?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }> };

export type SubmitReportMutationVariables = Exact<{
  reportId: Scalars['ID'];
  verifier: TierIiReportVerifier;
}>;


export type SubmitReportMutation = { __typename?: 'Mutation', updateTierIIReportVerifier: { __typename?: 'TierIIReport', id: string, organizationStatus: TierIiReportOrgStatus, encampStatus: TierIiReportEncampStatus } };

export type GenerateTierIiReportPreviewMutationVariables = Exact<{
  tierIIReportId: Scalars['ID'];
}>;


export type GenerateTierIiReportPreviewMutation = { __typename?: 'Mutation', generateTierIIPdfPreview: { __typename?: 'GenerateTierIIPdfPreviewResult', s3Key: string, jobId: string } };

export type PersonFragment = { __typename?: 'Person', id: string, first?: string | null, last?: string | null, email?: string | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null };

export type FacilityContactsFragment = { __typename?: 'Facility', contacts?: Array<{ __typename?: 'FacilityContact', id: string, reportingRoles: Array<ContactReportRole>, person: { __typename?: 'Person', id: string, tenantId: string, first?: string | null, last?: string | null, email?: string | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null } }> | null };

export type ReportFacilitySectionFragment = { __typename?: 'Facility', id: string, name: string, dateClosed?: any | null, dateInactive?: any | null, colocationReportingFacilityId?: string | null, isClosed?: boolean | null, isInactive?: boolean | null, isNotReporting?: boolean | null, isNotReportingThroughEncamp?: boolean | null, collectionMode?: CollectionMode | null, isSubjectToChemicalAccidentPrevention?: boolean | null, isSubjectToEmergencyPlanning?: boolean | null, isSubjectToToxicsReleaseInventoryReporting?: boolean | null, companyName?: string | null, department?: string | null, isMailingAddressSameAsFacility?: boolean | null, isMailingAddressEncamp?: boolean | null, isUnmanned?: boolean | null, maxNumOccupants?: number | null, fireDepartmentId?: string | null, lepcId?: string | null, dbNumber?: string | null, naicsCode?: number | null, longitude?: number | null, latitude?: number | null, state?: string | null, county?: string | null, municipality?: string | null, phone?: string | null, phone24Hour?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, zip?: string | null, mailingStreetAddress1?: string | null, mailingStreetAddress2?: string | null, mailingCity?: string | null, mailingState?: string | null, mailingZip?: string | null, dateOpened?: any | null, status?: FacilityStatus | null, facilityAlternateIds?: Array<{ __typename?: 'AlternateId', id: string, type: string, value: string, expiresAt?: any | null, hasNoId: boolean }> | null, fireDepartment?: { __typename?: 'FireDepartment', id: string, name?: string | null, city?: string | null, state?: string | null, mailingAddress?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null } | null, lepc?: { __typename?: 'Lepc', id: string, name: string, mailingAddress?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null, isEmailed: boolean } | null, stateFields: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, tooltip?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }>, contacts?: Array<{ __typename?: 'FacilityContact', id: string, reportingRoles: Array<ContactReportRole>, person: { __typename?: 'Person', id: string, tenantId: string, first?: string | null, last?: string | null, email?: string | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null } }> | null };

export type GetReportDetailsQueryVariables = Exact<{
  reportId: Scalars['ID'];
  programArea?: InputMaybe<ProgramArea>;
  version?: InputMaybe<Scalars['String']>;
}>;


export type GetReportDetailsQuery = { __typename?: 'Query', tierIIReport: { __typename?: 'TierIIReport', id: string, tenantId: string, reportingYear: number, reportKind: TierIiReportKind, organizationStatus: TierIiReportOrgStatus, encampStatus: TierIiReportEncampStatus, isVerified?: boolean | null, verifiedAt?: any | null, notesToRegulators?: string | null, touchedSteps?: Array<TierIiReportStep> | null, department?: string | null, reviewCompletedByUserId?: string | null, facility: { __typename?: 'Facility', id: string, name: string, dateClosed?: any | null, dateInactive?: any | null, colocationReportingFacilityId?: string | null, isClosed?: boolean | null, isInactive?: boolean | null, isNotReporting?: boolean | null, isNotReportingThroughEncamp?: boolean | null, collectionMode?: CollectionMode | null, isSubjectToChemicalAccidentPrevention?: boolean | null, isSubjectToEmergencyPlanning?: boolean | null, isSubjectToToxicsReleaseInventoryReporting?: boolean | null, companyName?: string | null, department?: string | null, isMailingAddressSameAsFacility?: boolean | null, isMailingAddressEncamp?: boolean | null, isUnmanned?: boolean | null, maxNumOccupants?: number | null, fireDepartmentId?: string | null, lepcId?: string | null, dbNumber?: string | null, naicsCode?: number | null, longitude?: number | null, latitude?: number | null, state?: string | null, county?: string | null, municipality?: string | null, phone?: string | null, phone24Hour?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, zip?: string | null, mailingStreetAddress1?: string | null, mailingStreetAddress2?: string | null, mailingCity?: string | null, mailingState?: string | null, mailingZip?: string | null, dateOpened?: any | null, status?: FacilityStatus | null, facilityAlternateIds?: Array<{ __typename?: 'AlternateId', id: string, type: string, value: string, expiresAt?: any | null, hasNoId: boolean }> | null, fireDepartment?: { __typename?: 'FireDepartment', id: string, name?: string | null, city?: string | null, state?: string | null, mailingAddress?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null } | null, lepc?: { __typename?: 'Lepc', id: string, name: string, mailingAddress?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null, isEmailed: boolean } | null, stateFields: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, tooltip?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }>, contacts?: Array<{ __typename?: 'FacilityContact', id: string, reportingRoles: Array<ContactReportRole>, person: { __typename?: 'Person', id: string, tenantId: string, first?: string | null, last?: string | null, email?: string | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null } }> | null }, assignees: Array<{ __typename?: 'TierIIReportAssignee', id: string, assignmentType: AssignmentType, person: { __typename?: 'Person', id: string, first?: string | null, last?: string | null, email?: string | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null } }>, reviewers: Array<{ __typename?: 'TierIIReportAssignee', id: string, assignmentType: AssignmentType, isComplete?: boolean | null, person: { __typename?: 'Person', id: string, first?: string | null, last?: string | null, email?: string | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null } }>, documents?: Array<{ __typename?: 'Document', id: string, title: string, fileExtension?: string | null, documentType: DocumentType, createdAt?: any | null, facilities?: Array<{ __typename?: 'Facility', id: string, name: string }> | null }> | null, issues: Array<{ __typename?: 'Issue', jurisdictions?: Array<string> | null, key?: string | null, message: string, modelName: string, modelId?: string | null, metadata?: any | null, facilityId?: string | null, tenantId?: string | null, level: IssueLevel, schemaPath?: string | null }> } };

export type UpdateFacilityReportMutationVariables = Exact<{
  id: Scalars['ID'];
  facility: FacilityInput;
  reportId?: InputMaybe<Scalars['ID']>;
  programArea?: InputMaybe<ProgramArea>;
}>;


export type UpdateFacilityReportMutation = { __typename?: 'Mutation', updateFacility?: { __typename?: 'Facility', id: string, name: string, dateClosed?: any | null, dateInactive?: any | null, colocationReportingFacilityId?: string | null, isClosed?: boolean | null, isInactive?: boolean | null, isNotReporting?: boolean | null, isNotReportingThroughEncamp?: boolean | null, collectionMode?: CollectionMode | null, isSubjectToChemicalAccidentPrevention?: boolean | null, isSubjectToEmergencyPlanning?: boolean | null, isSubjectToToxicsReleaseInventoryReporting?: boolean | null, companyName?: string | null, department?: string | null, isMailingAddressSameAsFacility?: boolean | null, isMailingAddressEncamp?: boolean | null, isUnmanned?: boolean | null, maxNumOccupants?: number | null, fireDepartmentId?: string | null, lepcId?: string | null, dbNumber?: string | null, naicsCode?: number | null, longitude?: number | null, latitude?: number | null, state?: string | null, county?: string | null, municipality?: string | null, phone?: string | null, phone24Hour?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, zip?: string | null, mailingStreetAddress1?: string | null, mailingStreetAddress2?: string | null, mailingCity?: string | null, mailingState?: string | null, mailingZip?: string | null, dateOpened?: any | null, status?: FacilityStatus | null, facilityAlternateIds?: Array<{ __typename?: 'AlternateId', id: string, type: string, value: string, expiresAt?: any | null, hasNoId: boolean }> | null, fireDepartment?: { __typename?: 'FireDepartment', id: string, name?: string | null, city?: string | null, state?: string | null, mailingAddress?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null } | null, lepc?: { __typename?: 'Lepc', id: string, name: string, mailingAddress?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null, isEmailed: boolean } | null, stateFields: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, tooltip?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }>, contacts?: Array<{ __typename?: 'FacilityContact', id: string, reportingRoles: Array<ContactReportRole>, person: { __typename?: 'Person', id: string, tenantId: string, first?: string | null, last?: string | null, email?: string | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null } }> | null } | null };

export type TouchTierIiReportStepMutationVariables = Exact<{
  reportId: Scalars['ID'];
  step: TierIiReportStep;
}>;


export type TouchTierIiReportStepMutation = { __typename?: 'Mutation', touchTierIIReportStep: boolean };

export type IssueFragment = { __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null };

export type ValidateChemicalInputQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  data: ChemicalInput;
}>;


export type ValidateChemicalInputQuery = { __typename?: 'Query', chemicalInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type ValidateCredentialInputQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  data: CredentialInputForValidation;
}>;


export type ValidateCredentialInputQuery = { __typename?: 'Query', credentialInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type ValidateDocumentInputQueryVariables = Exact<{
  input: DocumentInput;
  fileSize?: InputMaybe<Scalars['Int']>;
}>;


export type ValidateDocumentInputQuery = { __typename?: 'Query', documentInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type ValidateFacilityChemicalInputQueryVariables = Exact<{
  input: FacilityChemicalInput;
}>;


export type ValidateFacilityChemicalInputQuery = { __typename?: 'Query', facilityChemicalInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type ValidateFacilityChemicalMeasurementInputQueryVariables = Exact<{
  input: FacilityChemicalMeasurementInput;
}>;


export type ValidateFacilityChemicalMeasurementInputQuery = { __typename?: 'Query', facilityChemicalMeasurementInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type ValidateFacilityChemicalStorageLocationInputQueryVariables = Exact<{
  input: FacilityChemicalStorageLocationInput;
  facilityId: Scalars['String'];
  facilityChemicalId: Scalars['String'];
  facilityChemical?: InputMaybe<FacilityChemicalInput>;
}>;


export type ValidateFacilityChemicalStorageLocationInputQuery = { __typename?: 'Query', facilityChemicalStorageLocationInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type ValidateFacilityContactInputQueryVariables = Exact<{
  data: FacilityContactInput;
}>;


export type ValidateFacilityContactInputQuery = { __typename?: 'Query', facilityContactInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type ValidateFacilityInputQueryVariables = Exact<{
  id: Scalars['ID'];
  data: FacilityInput;
  reportId?: InputMaybe<Scalars['ID']>;
  omit?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  pick?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ValidateFacilityInputQuery = { __typename?: 'Query', facilityInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type ValidateFacilityProductInputQueryVariables = Exact<{
  input: FacilityProductInput;
}>;


export type ValidateFacilityProductInputQuery = { __typename?: 'Query', facilityProductInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type ValidateFacilityProductMeasurementInputQueryVariables = Exact<{
  input: FacilityProductMeasurementInput;
}>;


export type ValidateFacilityProductMeasurementInputQuery = { __typename?: 'Query', facilityProductMeasurementInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type ValidateFacilityProductStorageLocationInputQueryVariables = Exact<{
  input: FacilityProductStorageLocationInput;
  facilityId: Scalars['String'];
}>;


export type ValidateFacilityProductStorageLocationInputQuery = { __typename?: 'Query', facilityProductStorageLocationInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type ValidatePersonFacilityContactsInputQueryVariables = Exact<{
  data: PersonFacilityContactsInput;
}>;


export type ValidatePersonFacilityContactsInputQuery = { __typename?: 'Query', personFacilityContactsInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type ValidateProductChemicalInputQueryVariables = Exact<{
  input: ProductChemicalInput;
}>;


export type ValidateProductChemicalInputQuery = { __typename?: 'Query', productChemicalInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type ValidateProductInputQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  input: ProductInput;
}>;


export type ValidateProductInputQuery = { __typename?: 'Query', productInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type ValidateRegulatoryInputQueryVariables = Exact<{
  id: Scalars['ID'];
  data: FacilityInput;
  reportId?: InputMaybe<Scalars['ID']>;
  omit?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  pick?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ValidateRegulatoryInputQuery = { __typename?: 'Query', regulatoryInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type ValidateReportingFacilityChemicalInputQueryVariables = Exact<{
  id: Scalars['ID'];
  input: Array<FacilityChemicalStateFieldInput> | FacilityChemicalStateFieldInput;
}>;


export type ValidateReportingFacilityChemicalInputQuery = { __typename?: 'Query', reportingFacilityChemicalInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type ValidateVerifyInputQueryVariables = Exact<{
  id: Scalars['ID'];
  facilityId: Scalars['ID'];
  data: TierIiReportVerifier;
}>;


export type ValidateVerifyInputQuery = { __typename?: 'Query', tierIIReportVerifyStepValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type UpsertFacilityChemicalStateFieldsMutationVariables = Exact<{
  input: Array<FacilityChemicalStateFieldInput> | FacilityChemicalStateFieldInput;
  facilityId: Scalars['ID'];
  chemicalId: Scalars['ID'];
  reportingYear: Scalars['Int'];
}>;


export type UpsertFacilityChemicalStateFieldsMutation = { __typename?: 'Mutation', upsertFacilityChemicalStateFields?: Array<{ __typename?: 'FacilityChemicalStateField', id: string } | null> | null };

export type SetIsAlwaysReportedOnRfcMutationVariables = Exact<{
  id: Scalars['ID'];
  isAlwaysReported?: InputMaybe<Scalars['Boolean']>;
}>;


export type SetIsAlwaysReportedOnRfcMutation = { __typename?: 'Mutation', setIsAlwaysReportedOnReportingFacilityChemical: { __typename?: 'ReportingFacilityChemical', id: string, isAlwaysReported?: boolean | null } };

export type ReportingFacilityChemicalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReportingFacilityChemicalQuery = { __typename?: 'Query', reportingFacilityChemical: { __typename?: 'ReportingFacilityChemical', id: string, facilityId: string, aggregationErrorMessage?: string | null, maxAmount?: number | null, unit?: UnitType | null, averageAmount?: number | null, isOverThreshold?: boolean | null, chemicalId: string, reportingYear: number, hasConfidentialStorageLocations?: boolean | null, isAlwaysReported?: boolean | null, manuallyEdited?: boolean | null, jurisdictions: Array<string>, maxAmountCode?: number | null, averageAmountCode?: number | null, maxAmountLargestContainer?: number | null, daysOnSite?: number | null, chemical?: { __typename?: 'Chemical', noHazardsNotReporting?: boolean | null, id: string, alternateId?: string | null, isEhs: boolean, name: string, pureOrMixture?: PureOrMixture | null, casNumber?: string | null, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null } | null, storageLocations?: Array<{ __typename?: 'ReportingFacilityChemicalStorageLocation', id: string, maxAmount?: number | null, storageLocationId: string, pressure?: Pressure | null, otherPressureValue?: string | null, storageType?: string | null, storageTypeDescription?: string | null, temperature?: Temperature | null, unit?: UnitType | null, storageLocation?: { __typename?: 'StorageLocation', id: string, description?: string | null, facilityId: string, CA_mapNumber?: string | null, CA_gridNumber?: string | null, OR_insideOutside?: InsideOutside | null, OR_storageArea?: string | null, OR_storageBuilding?: string | null, OR_storageFloor?: string | null, OR_storageQuadrant?: StorageQuadrant | null, OR_storageRoom?: string | null, latitude?: number | null, longitude?: number | null } | null }> | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }>, previousYearMaxAmount?: { __typename?: 'AmountWithUnit', amount?: number | null, unit?: UnitType | null } | null, stateFields: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, tooltip?: string | null, group?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }>, maxAmountProductChemicalBreakdown?: { __typename?: 'ProductChemicalBreakdown', productMaxAmount?: { __typename?: 'AmountWithUnit', amount?: number | null, unit?: UnitType | null } | null, chemicalMaxAmount?: { __typename?: 'AmountWithUnit', amount?: number | null, unit?: UnitType | null } | null } | null, origin?: { __typename?: 'ReportingFacilityChemicalOrigin', facilityChemicalId?: string | null, facilityProducts?: Array<{ __typename?: 'FacilityProduct', id: string, daysOnSite?: number | null, maxQuantity?: number | null, averageQuantity?: number | null, product?: { __typename?: 'Product', id: string, name: string, productChemicals?: Array<{ __typename?: 'ProductChemical', amount: number, chemicalId: string }> | null } | null }> | null, facilityProductMeasurements?: Array<{ __typename?: 'FacilityProductMeasurement', id: string, quantity: number, product?: { __typename?: 'Product', id: string, name: string, productChemicals?: Array<{ __typename?: 'ProductChemical', id: string, chemicalId: string, amount: number, unit: UnitType }> | null } | null }> | null, facilityChemicalMeasurements?: Array<{ __typename?: 'FacilityChemicalMeasurement', id: string, measuredAtUtc: any, amount: number, unit: UnitType, storageType?: string | null, storageLocation?: { __typename?: 'StorageLocation', description?: string | null } | null }> | null } | null, facility?: { __typename?: 'Facility', state?: string | null } | null } };

export type ReportingFacilityChemicalsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type ReportingFacilityChemicalsQuery = { __typename?: 'Query', reportingFacilityChemicals: { __typename?: 'ReportingFacilityChemicalsResult', count: number, items: Array<{ __typename?: 'ReportingFacilityChemical', id: string, maxAmount?: number | null, maxAmountCode?: number | null, averageAmount?: number | null, averageAmountCode?: number | null, unit?: UnitType | null, isOverThreshold?: boolean | null, isAlwaysReported?: boolean | null, issueCount?: number | null, aggregationErrorMessage?: string | null, chemical?: { __typename?: 'Chemical', alternateId?: string | null, isEhs: boolean, noHazardsNotReporting?: boolean | null, id: string, name: string, pureOrMixture?: PureOrMixture | null, casNumber?: string | null, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null } | null, facility?: { __typename?: 'Facility', state?: string | null } | null }> } };

export type PersonSelectListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type PersonSelectListQuery = { __typename?: 'Query', people: { __typename?: 'PeopleResult', count: number, items: Array<{ __typename?: 'Person', id: string, first?: string | null, last?: string | null, title?: string | null, phones?: Array<{ __typename?: 'Phone', type: PhoneType, number?: string | null }> | null, user?: { __typename?: 'User', status: UserStatus, email: string } | null }> } };

export type CloseTierIiReportMutationVariables = Exact<{
  tierIIReportId: Scalars['ID'];
}>;


export type CloseTierIiReportMutation = { __typename?: 'Mutation', closeTierIIReport?: boolean | null };

export type MarkAsReportingMutationVariables = Exact<{
  facilityIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MarkAsReportingMutation = { __typename?: 'Mutation', markAsReporting?: boolean | null };

export type CoLocatedFacilityQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CoLocatedFacilityQuery = { __typename?: 'Query', facility?: { __typename?: 'Facility', id: string, name: string } | null };

export type BulkUpdateNotReportingReasonMutationVariables = Exact<{
  input: NotReportingReasonInput;
}>;


export type BulkUpdateNotReportingReasonMutation = { __typename?: 'Mutation', bulkUpdateNotReportingReason?: { __typename?: 'BulkUpdateNotReportingReasonResult', succeeded?: boolean | null } | null };

export type OpenAnnualReportsMutationVariables = Exact<{
  reportingYear: Scalars['Int'];
  reportKind: TierIiReportKind;
  facilityIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type OpenAnnualReportsMutation = { __typename?: 'Mutation', createTierIIReports: Array<{ __typename?: 'TierIIReport', id: string }> };

export type FacilityTierIiReportsQueryVariables = Exact<{
  tenantId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type FacilityTierIiReportsQuery = { __typename?: 'Query', facilityTierIIReports: { __typename?: 'FacilityTierIIReportsResult', count: number, items: Array<{ __typename?: 'FacilityTierIIReport', viewId: string, facilityId: string, customerFacilityId?: string | null, facilityName?: string | null, facilityDateClosed?: any | null, facilityDateInactive?: any | null, tierIIReportId?: string | null, reportingYear: number, reportKind?: TierIiReportKind | null, organizationStatus?: TierIiReportOrgStatus | null, encampStatus?: TierIiReportEncampStatus | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, county?: string | null, state?: string | null, zip?: string | null, tenantId: string, organizationStatusAnnual?: TierIiReportOrgStatus | null, encampStatusAnnual?: TierIiReportEncampStatus | null, hasOpenRevision?: boolean | null, hasVerifiedRevision?: boolean | null, hasOpenInitial?: boolean | null, hasVerifiedInitial?: boolean | null, reportUpdatedAt?: any | null, isInactive?: boolean | null, isClosed?: boolean | null, colocationReportingFacilityId?: string | null, isNotReporting?: boolean | null, isNotReportingThroughEncamp?: boolean | null, issueCount?: number | null, assignees: Array<{ __typename?: 'TierIIReportAssignee', id: string, assignmentType: AssignmentType, isComplete?: boolean | null, person: { __typename?: 'Person', id: string, first?: string | null, last?: string | null } }>, reviewers: Array<{ __typename?: 'TierIIReportAssignee', id: string, assignmentType: AssignmentType, isComplete?: boolean | null, person: { __typename?: 'Person', id: string, first?: string | null, last?: string | null } }>, reportUpdatedByUser?: { __typename?: 'User', id: string, email: string, person?: { __typename?: 'Person', first?: string | null, last?: string | null } | null } | null }> } };

export type FacilityProductsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type FacilityProductsQuery = { __typename?: 'Query', facilityProducts: { __typename?: 'FacilityProductsResult', count: number, items: Array<{ __typename?: 'FacilityProduct', id: string, maxQuantity?: number | null, averageQuantity?: number | null, updatedAt: any, product?: { __typename?: 'Product', id: string, name: string } | null, chemicalAmounts?: Array<{ __typename?: 'FacilityProductChemicalAmounts', chemicalId: string, maxAmount?: number | null, averageAmount?: number | null, unit?: UnitType | null, chemical: { __typename?: 'Chemical', id: string, name: string, pureOrMixture?: PureOrMixture | null, casNumber?: string | null, isEhs: boolean, components?: Array<{ __typename?: 'ChemicalComponent', name: string, casNumber?: string | null, componentPercentage?: number | null, isEhs: boolean }> | null } }> | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> }> } };

export type DeleteFacilityProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFacilityProductMutation = { __typename?: 'Mutation', deleteFacilityProduct?: { __typename?: 'FacilityProduct', id: string } | null };

export type GetCandidateContactsQueryVariables = Exact<{
  contactIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetCandidateContactsQuery = { __typename?: 'Query', peopleByIds: Array<{ __typename?: 'Person', id: string, first?: string | null, last?: string | null, email?: string | null, title?: string | null, company?: string | null, tenantId: string, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, country?: string | null, state?: string | null, zip?: string | null, phones?: Array<{ __typename?: 'Phone', type: PhoneType, number?: string | null }> | null, facilityContacts?: Array<{ __typename?: 'FacilityContact', id: string, reportingRoles: Array<ContactReportRole>, facility: { __typename?: 'Facility', id: string, name: string } }> | null, issues?: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> | null }> };

export type MergeContactsMutationVariables = Exact<{
  input: PersonInput;
  mergedPeopleIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type MergeContactsMutation = { __typename?: 'Mutation', mergePeople?: { __typename?: 'Person', id: string, first?: string | null, last?: string | null } | null };

export type SearchContactForReplaceQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type SearchContactForReplaceQuery = { __typename?: 'Query', people: { __typename?: 'PeopleResult', count: number, items: Array<{ __typename?: 'Person', id: string, tenantId: string, first?: string | null, last?: string | null, email?: string | null }> } };

export type ReplacePersonFacilityAssociationsMutationVariables = Exact<{
  oldPersonId: Scalars['ID'];
  newPersonId: Scalars['ID'];
  reportingRoles?: InputMaybe<Array<ContactReportRole> | ContactReportRole>;
}>;


export type ReplacePersonFacilityAssociationsMutation = { __typename?: 'Mutation', replacePersonFacilityAssociations?: boolean | null };

export type ReplaceConfirmQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type ReplaceConfirmQueryQuery = { __typename?: 'Query', people: { __typename?: 'PeopleResult', count: number, items: Array<{ __typename?: 'Person', id: string, tenantId: string, first?: string | null, last?: string | null, facilityContacts?: Array<{ __typename?: 'FacilityContact', id: string, reportingRoles: Array<ContactReportRole> }> | null }> } };

export type UpsertFacilityContactMutationVariables = Exact<{
  data: FacilityContactInput;
}>;


export type UpsertFacilityContactMutation = { __typename?: 'Mutation', upsertFacilityContact?: { __typename?: 'FacilityContact', id: string } | null };

export type DeleteFacilityContactMutationVariables = Exact<{
  facilityContactId: Scalars['ID'];
}>;


export type DeleteFacilityContactMutation = { __typename?: 'Mutation', deleteFacilityContact: boolean };

export type GetAssociatedFacilitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetAssociatedFacilitiesQuery = { __typename?: 'Query', facilities: { __typename?: 'FacilitiesResult', items: Array<{ __typename?: 'Facility', id: string, name: string, streetAddress1?: string | null, city?: string | null, state?: string | null, zip?: string | null }> } };

export type DeleteCredentialMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCredentialMutation = { __typename?: 'Mutation', deleteCredential: { __typename?: 'Credential', id: string } };

export type GetCredentialQueryVariables = Exact<{
  id: Scalars['ID'];
  facilitiesPage?: InputMaybe<Scalars['Int']>;
  facilitiesPageSize?: InputMaybe<Scalars['Int']>;
}>;


export type GetCredentialQuery = { __typename?: 'Query', credential: { __typename?: 'Credential', id: string, name?: string | null, username: string, password: string, kind: CredentialKind, email?: string | null, facilityCount?: number | null, tenantId: string, lastVerificationSuccessAt?: any | null, lastVerificationCheckAt?: any | null, verificationStatus: CredentialVerificationStatus, facilities?: Array<{ __typename?: 'Facility', id: string, name: string, streetAddress1?: string | null, city?: string | null, state?: string | null, zip?: string | null, portalCredential?: { __typename?: 'PortalCredential', url?: string | null } | null }> | null, issues?: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> | null } };

export type GetFacilitiesForCredentialQueryVariables = Exact<{
  credentialId: Scalars['ID'];
}>;


export type GetFacilitiesForCredentialQuery = { __typename?: 'Query', facilitiesForCredential: Array<{ __typename?: 'Facility', id: string, name: string, streetAddress1?: string | null, city?: string | null, state?: string | null, zip?: string | null }> };

export type CredentialsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type CredentialsQuery = { __typename?: 'Query', credentials: { __typename?: 'CredentialResult', count?: number | null, items: Array<{ __typename?: 'Credential', id: string, name?: string | null, username: string, kind: CredentialKind, email?: string | null, facilityCount?: number | null, states?: Array<string> | null, verificationStatus: CredentialVerificationStatus, lastVerificationSuccessAt?: any | null, lastVerificationCheckAt?: any | null }> } };

export type UpsertCredentialMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  input: CredentialInput;
}>;


export type UpsertCredentialMutation = { __typename?: 'Mutation', upsertCredential: { __typename?: 'Credential', id: string, name?: string | null, username: string, kind: CredentialKind, email?: string | null, tenantId: string, facilityCount?: number | null, facilities?: Array<{ __typename?: 'Facility', id: string }> | null } };

export type FacilitiesWithCredentialsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type FacilitiesWithCredentialsQuery = { __typename?: 'Query', facilities: { __typename?: 'FacilitiesResult', count: number, items: Array<{ __typename?: 'Facility', id: string, name: string, customerFacilityId?: string | null, streetAddress1?: string | null, city?: string | null, state?: string | null, zip?: string | null, facilityCredentials?: Array<{ __typename?: 'FacilityCredential', id: string }> | null }> } };

export type CreateChemicalsFromSdsMutationVariables = Exact<{
  input: CreateChemicalsFromSdsInput;
}>;


export type CreateChemicalsFromSdsMutation = { __typename?: 'Mutation', queueSdsParsingJobs: Array<{ __typename?: 'Job', id: string, task?: JobTask | null, status: JobStatus, createdAt: any, updatedAt: any }> };

export type DocumentGridRowFragment = { __typename?: 'Document', id: string, title: string, fileExtension?: string | null, documentType: DocumentType, createdAt?: any | null };

export type DocumentFieldsFragment = { __typename?: 'Document', id: string, tenantId?: string | null, title: string, documentType: DocumentType, fileExtension?: string | null, storageLink: string, createdAt?: any | null, report?: { __typename?: 'TierIIReport', encampStatus: TierIiReportEncampStatus } | null, facilities?: Array<{ __typename?: 'Facility', id: string, name: string }> | null, documentTags?: Array<{ __typename?: 'Tag', name: string, id: string }> | null, chemicalDocument?: Array<{ __typename?: 'ChemicalDocument', chemical: { __typename?: 'Chemical', name: string, id: string } }> | null, job?: Array<{ __typename?: 'Job', id: string, status: JobStatus, task?: JobTask | null }> | null };

export type DocumentsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type DocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentsResult', count?: number | null, items: Array<{ __typename?: 'Document', id: string, tenantId?: string | null, title: string, documentType: DocumentType, fileExtension?: string | null, storageLink: string, createdAt?: any | null, report?: { __typename?: 'TierIIReport', encampStatus: TierIiReportEncampStatus } | null, facilities?: Array<{ __typename?: 'Facility', id: string, name: string }> | null, documentTags?: Array<{ __typename?: 'Tag', name: string, id: string }> | null, chemicalDocument?: Array<{ __typename?: 'ChemicalDocument', chemical: { __typename?: 'Chemical', name: string, id: string } }> | null, job?: Array<{ __typename?: 'Job', id: string, status: JobStatus, task?: JobTask | null }> | null }> } };

export type DocumentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DocumentQuery = { __typename?: 'Query', document: { __typename?: 'Document', id: string, tenantId?: string | null, title: string, documentType: DocumentType, fileExtension?: string | null, storageLink: string, createdAt?: any | null, report?: { __typename?: 'TierIIReport', encampStatus: TierIiReportEncampStatus } | null, facilities?: Array<{ __typename?: 'Facility', id: string, name: string }> | null, documentTags?: Array<{ __typename?: 'Tag', name: string, id: string }> | null, chemicalDocument?: Array<{ __typename?: 'ChemicalDocument', chemical: { __typename?: 'Chemical', name: string, id: string } }> | null, job?: Array<{ __typename?: 'Job', id: string, status: JobStatus, task?: JobTask | null }> | null } };

export type GetFacilityContactsQueryVariables = Exact<{
  facilityId: Scalars['ID'];
  programArea?: InputMaybe<ProgramArea>;
}>;


export type GetFacilityContactsQuery = { __typename?: 'Query', facility?: { __typename?: 'Facility', id: string, name: string, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }>, contacts?: Array<{ __typename?: 'FacilityContact', id: string, reportingRoles: Array<ContactReportRole>, person: { __typename?: 'Person', id: string, tenantId: string, first?: string | null, last?: string | null, email?: string | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null } }> | null } | null };

export type FacilityDocumentsQueryVariables = Exact<{
  facilityId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type FacilityDocumentsQuery = { __typename?: 'Query', facility?: { __typename?: 'Facility', id: string, name: string, documents?: Array<{ __typename?: 'Document', documentType: DocumentType }> | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> } | null, documents: { __typename?: 'DocumentsResult', count?: number | null, items: Array<{ __typename?: 'Document', id: string, title: string, fileExtension?: string | null, documentType: DocumentType, createdAt?: any | null, facilities?: Array<{ __typename?: 'Facility', id: string, name: string }> | null }> } };

export type FacilityBasicWithAltidsQueryVariables = Exact<{
  facilityId: Scalars['ID'];
}>;


export type FacilityBasicWithAltidsQuery = { __typename?: 'Query', facility?: { __typename?: 'Facility', id: string, name: string, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, state?: string | null, zip?: string | null, facilityAlternateIds?: Array<{ __typename?: 'AlternateId', id: string, type: string, value: string, expiresAt?: any | null }> | null } | null };

export type AddAlternateIdMutationVariables = Exact<{
  facilityId: Scalars['ID'];
  alternateIds: Array<AlternateIdInput> | AlternateIdInput;
}>;


export type AddAlternateIdMutation = { __typename?: 'Mutation', addFacilityAlternateIds: boolean };

export type StateFieldFragmentFragment = { __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, layout?: any | null, renderMetadata?: any | null, helperText?: string | null, tooltip?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null };

export type FacilityStateFieldsQueryVariables = Exact<{
  input: FacilityStateFieldsInput;
}>;


export type FacilityStateFieldsQuery = { __typename?: 'Query', facilityStateFields: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, layout?: any | null, renderMetadata?: any | null, helperText?: string | null, tooltip?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }> };

export type FacilityProfileFragment = { __typename?: 'Facility', id: string, name: string, businessUnit?: string | null, customerFacilityId?: string | null, companyName?: string | null, department?: string | null, phone?: string | null, phone24Hour?: string | null, maxNumOccupants?: number | null, isUnmanned?: boolean | null, facilityType?: string | null, collectionMode?: CollectionMode | null, dbNumber?: string | null, naicsCode?: number | null, status?: FacilityStatus | null, statusReason?: string | null, dateOpened?: any | null, dateClosed?: any | null, dateInactive?: any | null, isInactive?: boolean | null, isSubjectToChemicalAccidentPrevention?: boolean | null, isSubjectToEmergencyPlanning?: boolean | null, isSubjectToToxicsReleaseInventoryReporting?: boolean | null, county?: string | null, municipality?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, zip?: string | null, state?: string | null, country?: string | null, mailingStreetAddress1?: string | null, mailingStreetAddress2?: string | null, mailingCity?: string | null, mailingState?: string | null, mailingZip?: string | null, mailingCountry?: string | null, isMailingAddressEncamp?: boolean | null, isMailingAddressSameAsFacility?: boolean | null, latitude?: number | null, longitude?: number | null, colocationReportingFacility?: { __typename?: 'Facility', id: string, name: string } | null, facilityAlternateIds?: Array<{ __typename?: 'AlternateId', id: string, type: string, value: string, hasNoId: boolean, expiresAt?: any | null }> | null, fireDepartment?: { __typename?: 'FireDepartment', id: string, name?: string | null, city?: string | null, state?: string | null, mailingAddress?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null } | null, lepc?: { __typename?: 'Lepc', id: string, name: string, mailingAddress?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null, isEmailed: boolean } | null, stateFields: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, layout?: any | null, renderMetadata?: any | null, helperText?: string | null, tooltip?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }>, issues: Array<{ __typename?: 'Issue', message: string, key?: string | null, modelId?: string | null, modelName: string, jurisdictions?: Array<string> | null, level: IssueLevel }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> };

export type GetFacilityQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetFacilityQuery = { __typename?: 'Query', facility?: { __typename?: 'Facility', id: string, name: string, businessUnit?: string | null, customerFacilityId?: string | null, companyName?: string | null, department?: string | null, phone?: string | null, phone24Hour?: string | null, maxNumOccupants?: number | null, isUnmanned?: boolean | null, facilityType?: string | null, collectionMode?: CollectionMode | null, dbNumber?: string | null, naicsCode?: number | null, status?: FacilityStatus | null, statusReason?: string | null, dateOpened?: any | null, dateClosed?: any | null, dateInactive?: any | null, isInactive?: boolean | null, isSubjectToChemicalAccidentPrevention?: boolean | null, isSubjectToEmergencyPlanning?: boolean | null, isSubjectToToxicsReleaseInventoryReporting?: boolean | null, county?: string | null, municipality?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, zip?: string | null, state?: string | null, country?: string | null, mailingStreetAddress1?: string | null, mailingStreetAddress2?: string | null, mailingCity?: string | null, mailingState?: string | null, mailingZip?: string | null, mailingCountry?: string | null, isMailingAddressEncamp?: boolean | null, isMailingAddressSameAsFacility?: boolean | null, latitude?: number | null, longitude?: number | null, colocationReportingFacility?: { __typename?: 'Facility', id: string, name: string } | null, facilityAlternateIds?: Array<{ __typename?: 'AlternateId', id: string, type: string, value: string, hasNoId: boolean, expiresAt?: any | null }> | null, fireDepartment?: { __typename?: 'FireDepartment', id: string, name?: string | null, city?: string | null, state?: string | null, mailingAddress?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null } | null, lepc?: { __typename?: 'Lepc', id: string, name: string, mailingAddress?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null, isEmailed: boolean } | null, stateFields: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, layout?: any | null, renderMetadata?: any | null, helperText?: string | null, tooltip?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }>, issues: Array<{ __typename?: 'Issue', message: string, key?: string | null, modelId?: string | null, modelName: string, jurisdictions?: Array<string> | null, level: IssueLevel }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } | null };

export type UpdateFacilityProfileMutationVariables = Exact<{
  id: Scalars['ID'];
  facility: FacilityInput;
}>;


export type UpdateFacilityProfileMutation = { __typename?: 'Mutation', updateFacility?: { __typename?: 'Facility', id: string, name: string, businessUnit?: string | null, customerFacilityId?: string | null, companyName?: string | null, department?: string | null, phone?: string | null, phone24Hour?: string | null, maxNumOccupants?: number | null, isUnmanned?: boolean | null, facilityType?: string | null, collectionMode?: CollectionMode | null, dbNumber?: string | null, naicsCode?: number | null, status?: FacilityStatus | null, statusReason?: string | null, dateOpened?: any | null, dateClosed?: any | null, dateInactive?: any | null, isInactive?: boolean | null, isSubjectToChemicalAccidentPrevention?: boolean | null, isSubjectToEmergencyPlanning?: boolean | null, isSubjectToToxicsReleaseInventoryReporting?: boolean | null, county?: string | null, municipality?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, zip?: string | null, state?: string | null, country?: string | null, mailingStreetAddress1?: string | null, mailingStreetAddress2?: string | null, mailingCity?: string | null, mailingState?: string | null, mailingZip?: string | null, mailingCountry?: string | null, isMailingAddressEncamp?: boolean | null, isMailingAddressSameAsFacility?: boolean | null, latitude?: number | null, longitude?: number | null, colocationReportingFacility?: { __typename?: 'Facility', id: string, name: string } | null, facilityAlternateIds?: Array<{ __typename?: 'AlternateId', id: string, type: string, value: string, hasNoId: boolean, expiresAt?: any | null }> | null, fireDepartment?: { __typename?: 'FireDepartment', id: string, name?: string | null, city?: string | null, state?: string | null, mailingAddress?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null } | null, lepc?: { __typename?: 'Lepc', id: string, name: string, mailingAddress?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null, isEmailed: boolean } | null, stateFields: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, layout?: any | null, renderMetadata?: any | null, helperText?: string | null, tooltip?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }>, issues: Array<{ __typename?: 'Issue', message: string, key?: string | null, modelId?: string | null, modelName: string, jurisdictions?: Array<string> | null, level: IssueLevel }>, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } | null };

export type InsightsCohortsQueryVariables = Exact<{
  tenantId: Scalars['String'];
}>;


export type InsightsCohortsQuery = { __typename?: 'Query', insightsCohorts: Array<{ __typename?: 'InsightsCohort', tenantId: string, id: string, name: string, nameSearches: Array<string>, domainSearches: Array<string> }> };

export type CreateInsightsCohortMutationVariables = Exact<{
  tenantId: Scalars['String'];
  name: Scalars['String'];
  nameSearches: Array<Scalars['String']> | Scalars['String'];
  domainSearches: Array<Scalars['String']> | Scalars['String'];
}>;


export type CreateInsightsCohortMutation = { __typename?: 'Mutation', createInsightsCohort: { __typename?: 'InsightsCohort', id: string, name: string, nameSearches: Array<string>, domainSearches: Array<string> } };

export type UpdateInsightsCohortMutationVariables = Exact<{
  id: Scalars['String'];
  name: Scalars['String'];
  nameSearches: Array<Scalars['String']> | Scalars['String'];
  domainSearches: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateInsightsCohortMutation = { __typename?: 'Mutation', updateInsightsCohort: { __typename?: 'InsightsCohort', id: string, name: string, nameSearches: Array<string>, domainSearches: Array<string> } };

export type DeleteInsightsCohortMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteInsightsCohortMutation = { __typename?: 'Mutation', deleteInsightsCohort: { __typename?: 'InsightsCohort', id: string } };

export type EchoOverviewQueryVariables = Exact<{
  tenantId: Scalars['String'];
  filterTenantId?: InputMaybe<Scalars['String']>;
  naicsCode?: InputMaybe<Scalars['String']>;
  cohortIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type EchoOverviewQuery = { __typename?: 'Query', echoOverview?: { __typename?: 'EchoOverview', stats: { __typename?: 'EchoOverviewStats', totalFacilityCount?: number | null, activeFacilityCount?: number | null, airFacilityCount?: number | null, airSignificantViolatorCount?: number | null, airViolatorCount?: number | null, waterFacilityCount?: number | null, waterViolatorCount?: number | null, waterSignificantViolatorCount?: number | null, wasteFacilityCount?: number | null, wasteViolatorCount?: number | null, wasteSignificantViolatorCount?: number | null, airComplianceStatusCounts?: Array<{ __typename?: 'Counts', countKey?: string | null, count?: number | null }> | null, airPermitTypeCounts?: Array<{ __typename?: 'Counts', countKey?: string | null, count?: number | null }> | null, waterComplianceStatusCounts?: Array<{ __typename?: 'Counts', countKey?: string | null, count?: number | null }> | null, waterPermitTypeCounts?: Array<{ __typename?: 'Counts', countKey?: string | null, count?: number | null }> | null, wasteComplianceStatusCounts?: Array<{ __typename?: 'Counts', countKey?: string | null, count?: number | null }> | null, wastePermitTypeCounts?: Array<{ __typename?: 'Counts', countKey?: string | null, count?: number | null }> | null }, history: Array<{ __typename?: 'EchoOverviewHistory', quarter: string, program: string, significantNoncompliance: number, violation: number, noViolation: number, unknown: number }> } | null };

export type FacilityCountQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type FacilityCountQuery = { __typename?: 'Query', facilities: { __typename?: 'FacilitiesResult', count: number } };

export type GetEchoExporterQueryVariables = Exact<{
  registryId: Scalars['String'];
  tenantId: Scalars['String'];
}>;


export type GetEchoExporterQuery = { __typename?: 'Query', echoExporter: { __typename?: 'EchoExporter', registryId: string, facName?: string | null, facStreet?: string | null, facCity?: string | null, facState?: string | null, facZip?: string | null, facCounty?: string | null, facFipsCode?: string | null, facActiveFlag?: boolean | null, airFlag?: boolean | null, npdesFlag?: boolean | null, rcraFlag?: boolean | null, facLat?: number | null, facLong?: number | null, facMajorFlag?: boolean | null, facInspectionCount?: number | null, facDaysLastInspection?: number | null, facInformalCount?: number | null, facFormalActionCount?: number | null, facDateLastFormalAction?: any | null, caaEvaluationCount?: number | null, caaDaysLastEvaluation?: number | null, caaInformalCount?: number | null, caaFormalActionCount?: number | null, caaDateLastFormalAction?: any | null, cwaInspectionCount?: number | null, cwaDaysLastInspection?: number | null, cwaInformalCount?: number | null, cwaFormalActionCount?: number | null, cwaDateLastFormalAction?: any | null, rcraInspectionCount?: number | null, rcraDaysLastEvaluation?: number | null, rcraInformalCount?: number | null, rcraFormalActionCount?: number | null, rcraDateLastFormalAction?: any | null, facTotalPenalties?: number | null, facLastPenaltyAmt?: number | null, facDateLastPenalty?: any | null, caaPenalties?: number | null, caaLastPenaltyAmt?: number | null, caaLastPenaltyDate?: any | null, cwaPenalties?: number | null, cwaLastPenaltyAmt?: number | null, cwaLastPenaltyDate?: any | null, rcraPenalties?: number | null, rcraLastPenaltyAmt?: number | null, rcraLastPenaltyDate?: any | null, facProgramsWithSnc?: number | null, airIds: Array<string>, caaPermitTypes: Array<string>, npdesIds: Array<string>, cwaPermitTypes: Array<string>, rcraIds: Array<string>, rcraPermitTypes: Array<string>, triIds: Array<string>, triReporterInPast?: boolean | null, triReporter?: boolean | null, caaComplianceStatus?: string | null, rcraComplianceStatus?: string | null, facComplianceStatus?: string | null, cwaComplianceStatus?: string | null, caaHpvFlag?: boolean | null, cwaSncFlag?: boolean | null, rcraSncFlag?: boolean | null, facSncFlg?: boolean | null, caaQtrsWithNc?: number | null, cwaQtrsWithNc?: number | null, rcraQtrsWithNc?: number | null, facQtrsWithNc?: number | null, caa3yrComplQtrsHistory: Array<{ __typename?: 'QuarterlyHistory', quarter: string, status: EchoQuarterlyHistory }>, cwa13qtrsComplHistory: Array<{ __typename?: 'QuarterlyHistory', quarter: string, status: EchoQuarterlyHistory }>, rcra3yrComplQtrsHistory: Array<{ __typename?: 'QuarterlyHistory', quarter: string, status: EchoQuarterlyHistory }>, fac3yrComplianceHistory: Array<{ __typename?: 'QuarterlyHistory', quarter: string, status: EchoQuarterlyHistory }> } };

export type InsightsEchoFacilitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
  tenantId: Scalars['String'];
}>;


export type InsightsEchoFacilitiesQuery = { __typename?: 'Query', insightsEchoMyFacilities: { __typename?: 'InsightsEchoFacilitiesResult', count: number, items: Array<{ __typename?: 'FacilityEchoExporter', registryId?: string | null, facilityId?: string | null, customerFacilityId?: string | null, echoFacilityName?: string | null, facilityStreet?: string | null, facilityCity?: string | null, facilityState?: string | null, facilityZip?: string | null, facilityCounty?: string | null, nonComplianceCountLast12Qrtrs?: number | null, violationCountLast12Qrtrs?: number | null, penaltiesLast12Qrtrs?: number | null, echoFirstNaicsCode?: string | null, id: string }> } };

export type InsightsEchoAllFacilitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
  tenantId: Scalars['String'];
}>;


export type InsightsEchoAllFacilitiesQuery = { __typename?: 'Query', insightsEchoAllFacilities: { __typename?: 'InsightsEchoAllFacilitiesResult', count: number, items: Array<{ __typename?: 'EchoExporterAggregated', registryId: string, echoFacilityName?: string | null, facilityStreet?: string | null, facilityCity?: string | null, facilityState?: string | null, facilityZip?: string | null, facilityCounty?: string | null, nonComplianceCountLast12Qrtrs?: number | null, violationCountLast12Qrtrs?: number | null, penaltiesLast12Qrtrs?: number | null, echoFirstNaicsCode?: string | null, id: string }> } };

export type NpdesFacilitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
  tenantId: Scalars['String'];
  filterTenantId?: InputMaybe<Scalars['String']>;
}>;


export type NpdesFacilitiesQuery = { __typename?: 'Query', npdesFacilities: { __typename?: 'NpdesFacilityResult', count: number, items: Array<{ __typename?: 'NpdesFacility', facilityUin?: string | null, facilityName?: string | null, locationAddress?: string | null, city?: string | null, stateCode?: string | null, zip?: string | null, id?: string | null }> } };

export type GetNpdesDetailQueryVariables = Exact<{
  npdesId: Scalars['String'];
  tenantId: Scalars['String'];
}>;


export type GetNpdesDetailQuery = { __typename?: 'Query', npdesDetail: { __typename?: 'NpdesDetailResult', facility?: { __typename?: 'NpdesFacility', icisFacilityInterestId: string, npdesId?: string | null, facilityUin?: string | null, facilityTypeCode?: FacilityTypeCode | null, facilityName?: string | null, locationAddress?: string | null, supplementalAddressText?: string | null, city?: string | null, countyCode?: string | null, stateCode?: string | null, zip?: string | null, geocodeLatitude?: number | null, geocodeLongitude?: number | null, impairedWaters?: string | null } | null, permits: Array<{ __typename?: 'NpdesPermit', activityId?: string | null, externalPermitNmbr?: string | null, versionNmbr?: number | null, facilityTypeIndicator?: FacilityTypeIndicator | null, permitTypeCode?: PermitTypeCode | null, majorMinorStatusFlag?: MajorMinorStatusFlag | null, permitStatusCode?: PermitStatusCode | null, totalDesignFlowNmbr?: number | null, actualAverageFlowNmbr?: number | null, stateWaterBody?: string | null, stateWaterBodyName?: string | null, permitName?: string | null, agencyTypeCode?: AgencyTypeCode | null, originalIssueDate?: any | null, issueDate?: any | null, issuingAgency?: string | null, effectiveDate?: any | null, expirationDate?: any | null, retirementDate?: any | null, terminationDate?: any | null, permitCompStatusFlag?: boolean | null, dmrNonReceiptFlag?: boolean | null, rncTrackingFlag?: boolean | null, masterExternalPermitNmbr?: string | null, tmdlInterfaceFlag?: boolean | null, edmrAuthorizationFlag?: boolean | null, pretreatmentIndicatorCode?: PretreatmentIndicatorCode | null, radWbdHuc12s?: string | null }> } };

export type InsightsFacilityMixQueryVariables = Exact<{
  tenantId: Scalars['String'];
  programArea?: InputMaybe<Scalars['String']>;
  naicsCode?: InputMaybe<Scalars['String']>;
}>;


export type InsightsFacilityMixQuery = { __typename?: 'Query', insightsFacilityMix: { __typename?: 'InsightsFacilityMix', facilitiesCount: number, connectedFacilitiesCount: number, hasNoGovtIdCount: number, filteredFacilitiesCount: number, facilitiesWithMultiplePrograms: number, facilityNaicsTypes: Array<{ __typename?: 'InsightsFacilityNaicsType', name: string, naicsCode: string, count: number }>, programAreas: Array<{ __typename?: 'InsightsFacilityProgramArea', key: string, count: number }> } };

export type GetInsightsNonComplianceQueryVariables = Exact<{
  tenantId: Scalars['String'];
  filter?: InputMaybe<InsightsFilter>;
}>;


export type GetInsightsNonComplianceQuery = { __typename?: 'Query', insightsNonCompliance: { __typename?: 'InsightsNonCompliance', byProgramArea: Array<{ __typename?: 'CountStat', count: number, key: string, name: string }>, quarterlyBySignificance: Array<{ __typename?: 'QuarterlyStat', quarter: string, group?: string | null, count: number }>, quarterlyByProgramArea: Array<{ __typename?: 'QuarterlyStat', quarter: string, group?: string | null, count: number }>, violationsByFacility: Array<{ __typename?: 'CountStat', count: number, key: string, name: string }> } };

export type InsightPenaltiesQueryVariables = Exact<{
  tenantId: Scalars['String'];
  filter?: InputMaybe<InsightsFilter>;
}>;


export type InsightPenaltiesQuery = { __typename?: 'Query', insightsPenalties: { __typename?: 'InsightsPenalties', totalPenalties: number, averagePenalties: number, averageCostPerViolation: number, byQuarter: Array<{ __typename?: 'InsightsPenalty', cost: number, label: string }>, byFacility: Array<{ __typename?: 'InsightsPenalty', frsId?: string | null, cost: number, label: string }>, byProgramArea: Array<{ __typename?: 'InsightsPenalty', cost: number, label: string }>, byQuarterByProgramArea: Array<{ __typename?: 'InsightsPenaltyQuarter', quarter: string, programAreas: Array<{ __typename?: 'InsightsPenalty', cost: number, label: string }> }> } };

export type InsightViolationsQueryVariables = Exact<{
  tenantId: Scalars['ID'];
  filter?: InputMaybe<InsightsFilter>;
}>;


export type InsightViolationsQuery = { __typename?: 'Query', insightsViolations: { __typename?: 'InsightsViolations', totalViolations: number, percentageFacilitiesWithViolation: number, programAreas: Array<string>, violationsByProgramArea: Array<{ __typename?: 'InsightsViolationsProgramArea', name: string, totalViolations: number }>, violationsByQuarter: Array<{ __typename?: 'InsightsViolationsQuarter', quarter: string, violationsByProgramArea: Array<{ __typename?: 'InsightsViolationsProgramArea', name: string, totalViolations: number }> }>, violationsByFacility: Array<{ __typename?: 'InsightsViolationsFacility', frsId?: string | null, name: string, totalViolations: number }> } };

export type RcraInfoHdHandlersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
  tenantId: Scalars['String'];
  filterTenantId?: InputMaybe<Scalars['String']>;
}>;


export type RcraInfoHdHandlersQuery = { __typename?: 'Query', rcraInfoHdHandlers: { __typename?: 'HdHandlerResult', count: number, items: Array<{ __typename?: 'HdHandler', handlerName?: string | null, activityLocation: string, locationStreetNo?: string | null, locationStreet1?: string | null, locationStreet2?: string | null, locationCity?: string | null, locationState?: string | null, locationZip?: string | null, locationCountry?: string | null, fedWasteGenerator?: RcraInfoFederalWasteGeneratorStatus | null, contactEmailAddress?: string | null, ownerName?: string | null, operatorName?: string | null, id: string }> } };

export type GetRcraInfoHandlerQueryVariables = Exact<{
  handlerId: Scalars['String'];
  tenantId: Scalars['String'];
}>;


export type GetRcraInfoHandlerQuery = { __typename?: 'Query', rcraInfoHdHandler: Array<{ __typename?: 'HdHandler', handlerId: string, activityLocation: string, seqNumber: number, handlerName?: string | null, receiveDate?: any | null, sourceType: RcraInfoSourceType, publicNotes?: string | null, fedWasteGenerator?: RcraInfoFederalWasteGeneratorStatus | null, locationStreetNo?: string | null, locationStreet1?: string | null, locationStreet2?: string | null, locationCity?: string | null, locationState?: string | null, locationZip?: string | null, locationCountry?: string | null, locationLatitude?: number | null, locationLongitude?: number | null, currentRecord?: boolean | null, mailStreetNo?: string | null, mailStreet1?: string | null, mailStreet2?: string | null, mailCity?: string | null, mailState?: string | null, mailZip?: string | null, mailCountry?: string | null, contactFirstName?: string | null, contactLastName?: string | null, contactTitle?: string | null, contactEmailAddress?: string | null, contactPhone?: string | null, contactStreetNo?: string | null, contactStreet1?: string | null, contactStreet2?: string | null, contactCity?: string | null, contactState?: string | null, contactZip?: string | null, contactCountry?: string | null, subpartPHealthcare?: boolean | null, hdOwnerOperators: Array<{ __typename?: 'HdOwnerOperator', ownerOperatorName?: string | null, ownerOperatorIndicator?: RcraInfoOwnerOperatorIndicator | null, dateBecameCurrent?: any | null, email?: string | null, phone?: string | null, streetNo?: string | null, street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }> }> };

export type CreateTaskMutationVariables = Exact<{
  input: CreateTaskInput;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask?: boolean | null };

export type TaskFacilitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type TaskFacilitiesQuery = { __typename?: 'Query', facilities: { __typename?: 'FacilitiesResult', count: number, items: Array<{ __typename?: 'Facility', id: string, name: string, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, state?: string | null, zip?: string | null }> } };

export type GetVirtualEventQueryVariables = Exact<{
  taskId: Scalars['ID'];
  deadline: Scalars['DateTime'];
}>;


export type GetVirtualEventQuery = { __typename?: 'Query', virtualEvent?: { __typename?: 'VirtualEvent', id: string, taskId: string, seriesId: string, title: string, description?: string | null, deadline: any, completedAt?: any | null, shouldNotify: boolean, frequency: Frequency, interval?: number | null, links?: Array<string> | null, assignee?: { __typename?: 'User', id: string, email: string, person?: { __typename?: 'Person', first?: string | null, last?: string | null } | null } | null, subtasks?: Array<{ __typename?: 'VirtualEventSubtask', id: string, title: string, completedAt?: any | null }> | null, facilities?: Array<{ __typename?: 'Facility', id: string }> | null, watchers?: Array<{ __typename?: 'User', id: string }> | null, documents?: Array<{ __typename?: 'Document', id: string, fileExtension?: string | null, title: string, documentType: DocumentType }> | null, tags?: Array<{ __typename?: 'Tag', id: string, name: string }> | null } | null };

export type TasksQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type TasksQuery = { __typename?: 'Query', virtualEvents: { __typename?: 'VirtualEventResult', count: number, items: Array<{ __typename?: 'VirtualEvent', id: string, seriesId: string, taskId: string, frequency: Frequency, interval?: number | null, title: string, status: VirtualEventStatus, deadline: any, facilities?: Array<{ __typename?: 'Facility', id: string, name: string }> | null, assignee?: { __typename?: 'User', id: string, email: string, person?: { __typename?: 'Person', first?: string | null, last?: string | null, email?: string | null } | null } | null, tags?: Array<{ __typename?: 'Tag', name: string }> | null }> } };

export type DeleteTaskMutationVariables = Exact<{
  input: EventMutationInput;
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask?: boolean | null };

export type UpdateTaskSingleMutationVariables = Exact<{
  input: UpdateTaskSingleInput;
}>;


export type UpdateTaskSingleMutation = { __typename?: 'Mutation', updateTaskSingle?: { __typename?: 'VirtualEvent', id: string } | null };

export type UpdateTaskRecurringMutationVariables = Exact<{
  input: UpdateTaskRecurringInput;
}>;


export type UpdateTaskRecurringMutation = { __typename?: 'Mutation', updateTaskRecurring?: { __typename?: 'VirtualEvent', id: string } | null };

export type AssigneePickerFragment = { __typename?: 'User', id: string, email: string, person?: { __typename?: 'Person', first?: string | null, last?: string | null, email?: string | null } | null };

export type GetUsersQueryVariables = Exact<{
  search: Scalars['String'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersResult', count: number, items: Array<{ __typename?: 'User', id: string, email: string, person?: { __typename?: 'Person', first?: string | null, last?: string | null, email?: string | null } | null }> } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string } };

export type TenantFacilitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type TenantFacilitiesQuery = { __typename?: 'Query', facilities: { __typename?: 'FacilitiesResult', count: number, items: Array<{ __typename?: 'Facility', id: string, name: string, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, state?: string | null, zip?: string | null, customerFacilityId?: string | null }> } };

export type UpsertUserFacilitiesForTenantMutationVariables = Exact<{
  userId: Scalars['ID'];
  facilityIds: Array<Scalars['ID']> | Scalars['ID'];
  tenantId: Scalars['ID'];
}>;


export type UpsertUserFacilitiesForTenantMutation = { __typename?: 'Mutation', upsertUserFacilitiesForTenant: { __typename?: 'UpsertUserFacilitiesForTenantResult', count: number, userFacilities: Array<{ __typename?: 'UserFacility', facilityId: string, facility?: { __typename?: 'Facility', name: string, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, state?: string | null, zip?: string | null, customerFacilityId?: string | null } | null }> } };

export type UserDetailQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UserDetailQuery = { __typename?: 'Query', user?: { __typename?: 'User', status: UserStatus, id: string, email: string, type: UserType, facilities: Array<{ __typename?: 'Facility', id: string, name: string, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, state?: string | null, zip?: string | null, customerFacilityId?: string | null }>, UserTenant: Array<{ __typename?: 'UserTenant', id: string, tenantId: string, role?: { __typename?: 'Role', id: string, name: string, permissions?: Array<Permission> | null } | null }>, person?: { __typename?: 'Person', id: string, first?: string | null, last?: string | null } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string } };

export type UsersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type UsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersResult', count: number, items: Array<{ __typename?: 'User', id: string, email: string, status: UserStatus, facilities: Array<{ __typename?: 'Facility', id: string }>, person?: { __typename?: 'Person', first?: string | null, last?: string | null } | null, UserTenant: Array<{ __typename?: 'UserTenant', tenantId: string, role?: { __typename?: 'Role', name: string, permissions?: Array<Permission> | null } | null }> }> } };

export type ResendInviteMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResendInviteMutation = { __typename?: 'Mutation', resendInvitationToUser: boolean };

export type ValidateUserInputQueryVariables = Exact<{
  input: UserInput;
}>;


export type ValidateUserInputQuery = { __typename?: 'Query', userInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type WasteShipmentsQueryVariables = Exact<{
  facilityId: Scalars['ID'];
  year: Scalars['Int'];
}>;


export type WasteShipmentsQuery = { __typename?: 'Query', wasteShipmentsByFacility: { __typename?: 'WasteShipmentsByFacility', hazardousWasteShipments?: { __typename?: 'HazardousWasteShipmentsByFacility', totalAmount: number, totalHazardousAmount: number, totalAcutelyHazardousAmount: number, highestWasteMonths: Array<string>, highestHazardousMonths: Array<string>, highestAcutelyHazardousMonths: Array<string>, byMonth: Array<{ __typename?: 'HazardousWasteByMonth', acutelyHazardous: number, hazardous: number, month: any }> } | null, wasteShipmentsByMonth?: { __typename?: 'AllWasteShipmentsByFacility', totalNonHazardousAmount: number, totalHazardousAmount: number, totalUniversalAmount: number, byMonth: Array<{ __typename?: 'AllWasteByMonth', month: any, nonHazardous: number, hazardous: number, universal: number }> } | null, highestWasteStreamShipments?: Array<{ __typename?: 'WasteStreamShipment', amount: number, wasteStream: { __typename?: 'FacilityWasteStream', id: string, dotDescription?: string | null } }> | null } };

export type FacilityWasteStreamsQueryVariables = Exact<{
  facilityId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type FacilityWasteStreamsQuery = { __typename?: 'Query', facility?: { __typename?: 'Facility', wasteStreams?: { __typename?: 'FacilityWasteStreamResult', count: number, items: Array<{ __typename?: 'FacilityWasteStream', id: string, facilityId: string, dotDescription?: string | null, federalWasteCodes?: Array<string> | null, stateWasteCodes?: Array<string> | null, classification?: WasteClassification | null, wasteStreamHashKey?: string | null, facilityWasteStreamYearToDates?: Array<{ __typename?: 'FacilityWasteStreamYearToDate', shipments?: number | null, managementMethodCodes?: Array<string> | null, finalDestinations?: Array<string> | null }> | null }> } | null } | null };

export type WasteFacilityDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WasteFacilityDetailsQuery = { __typename?: 'Query', facility?: { __typename?: 'Facility', id: string, name: string, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, state?: string | null, zip?: string | null, latitude?: number | null, longitude?: number | null, county?: string | null, facilityAlternateIds?: Array<{ __typename?: 'AlternateId', id: string, type: string, value: string, hasNoId: boolean }> | null, regulatoryStatus?: { __typename?: 'FacilityRegulatoryStatus', rcraInfo: RcraInfoFederalWasteGeneratorStatus, rcraInfoHighestStatusThisYear: RcraInfoFederalWasteGeneratorStatus, eManifestHighestStatusThisYear: RcraInfoFederalWasteGeneratorStatus, vendorHighestStatusThisYear: RcraInfoFederalWasteGeneratorStatus } | null } | null };

export type WasteFacilitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type WasteFacilitiesQuery = { __typename?: 'Query', facilities: { __typename?: 'FacilitiesResult', count: number, items: Array<{ __typename?: 'Facility', id: string, name: string, streetAddress1?: string | null, city?: string | null, state?: string | null, zip?: string | null, facilityAlternateIds?: Array<{ __typename?: 'AlternateId', id: string, type: string, value: string, hasNoId: boolean }> | null, regulatoryStatus?: { __typename?: 'FacilityRegulatoryStatus', rcraInfo: RcraInfoFederalWasteGeneratorStatus, rcraInfoHighestStatusThisYear: RcraInfoFederalWasteGeneratorStatus, eManifestHighestStatusThisYear: RcraInfoFederalWasteGeneratorStatus, vendorHighestStatusThisYear: RcraInfoFederalWasteGeneratorStatus } | null }> } };

export type WasteLineFragmentFragment = { __typename?: 'WasteLine', quantity?: number | null, manifestId: string, qtyUnitOfMeasureDesc?: string | null, dotHazardous?: boolean | null, dotPrintedInformation?: string | null, nonHazWasteDescription?: string | null, vendorProfileDescription?: string | null, vendorProfileNumber?: string | null, managementMethodCode?: string | null, dotIdNumberDescription?: string | null, federalWasteCodes?: Array<string> | null, qtyUnitOfMeasureCode?: string | null, quantityTons?: number | null, quantityAcuteTons?: number | null, quantityNonAcuteTons?: number | null, quantityKg?: number | null, quantityAcuteKg?: number | null, quantityNonAcuteKg?: number | null };

export type WasteManifestsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type WasteManifestsQuery = { __typename?: 'Query', wasteManifests: { __typename?: 'WasteManifestsResult', count: number, items: Array<{ __typename?: 'ProcessedManifestSummary', id: string, displayedManifestId?: string | null, epaId?: string | null, manifestTrackingNumber?: string | null, vendor?: WasteManifestSource | null, shippedDate?: any | null, facilityName?: string | null, hasEManifest?: boolean | null, hasVendorManifest?: boolean | null, hasIssues?: boolean | null, hasIssuesReason?: Array<{ __typename?: 'HasIssuesReason', field: string }> | null, wasteLines: { __typename?: 'WasteManifestLineItemsResult', count: number, items: Array<{ __typename?: 'WasteLine', quantity?: number | null, manifestId: string, qtyUnitOfMeasureDesc?: string | null, dotHazardous?: boolean | null, dotPrintedInformation?: string | null, nonHazWasteDescription?: string | null, vendorProfileDescription?: string | null, vendorProfileNumber?: string | null, managementMethodCode?: string | null, dotIdNumberDescription?: string | null, federalWasteCodes?: Array<string> | null, qtyUnitOfMeasureCode?: string | null, quantityTons?: number | null, quantityAcuteTons?: number | null, quantityNonAcuteTons?: number | null, quantityKg?: number | null, quantityAcuteKg?: number | null, quantityNonAcuteKg?: number | null }> } }> } };

export type WasteLinesQueryVariables = Exact<{
  wasteManifestId: Scalars['String'];
}>;


export type WasteLinesQuery = { __typename?: 'Query', wasteManifestLineItems: { __typename?: 'WasteManifestLineItemsResult', count: number, items: Array<{ __typename?: 'WasteLine', quantity?: number | null, manifestId: string, qtyUnitOfMeasureDesc?: string | null, dotHazardous?: boolean | null, dotPrintedInformation?: string | null, nonHazWasteDescription?: string | null, vendorProfileDescription?: string | null, vendorProfileNumber?: string | null, managementMethodCode?: string | null, dotIdNumberDescription?: string | null, federalWasteCodes?: Array<string> | null, qtyUnitOfMeasureCode?: string | null, quantityTons?: number | null, quantityAcuteTons?: number | null, quantityNonAcuteTons?: number | null, quantityKg?: number | null, quantityAcuteKg?: number | null, quantityNonAcuteKg?: number | null }> } };

export type FireDepartmentSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
  tenantId?: InputMaybe<Scalars['String']>;
}>;


export type FireDepartmentSearchQuery = { __typename?: 'Query', fireDepartmentSearch: { __typename?: 'FireDepartmentResult', count: number, items: Array<{ __typename?: 'FireDepartment', id: string, name?: string | null, mailingAddress?: string | null, mailingAddressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, latitude?: number | null, longitude?: number | null, additionalComments?: string | null, stateSubmitsToFireDept?: boolean | null, needsT2sFile?: boolean | null, isEmailed?: boolean | null, isMailed?: boolean | null, isSubmittedViaPortal?: boolean | null, portalId?: string | null, portalName?: string | null, issues?: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> | null }> } };

export type FireDepartmentQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type FireDepartmentQuery = { __typename?: 'Query', fireDepartment: { __typename?: 'FireDepartment', id: string, name?: string | null, mailingAddress?: string | null, mailingAddressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, latitude?: number | null, longitude?: number | null, additionalComments?: string | null, stateSubmitsToFireDept?: boolean | null, needsT2sFile?: boolean | null, isEmailed?: boolean | null, isMailed?: boolean | null, isSubmittedViaPortal?: boolean | null, portalId?: string | null, portalName?: string | null, issues?: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> | null } };

export type UpsertFireDepartmentMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  input: FireDepartmentInput;
}>;


export type UpsertFireDepartmentMutation = { __typename?: 'Mutation', upsertFireDepartment: { __typename?: 'FireDepartment', id: string, name?: string | null, mailingAddress?: string | null, mailingAddressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, latitude?: number | null, longitude?: number | null, additionalComments?: string | null, stateSubmitsToFireDept?: boolean | null, needsT2sFile?: boolean | null, isEmailed?: boolean | null, isMailed?: boolean | null, isSubmittedViaPortal?: boolean | null, portalId?: string | null, portalName?: string | null } };

export type DeleteFireDepartmentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteFireDepartmentMutation = { __typename?: 'Mutation', deleteFireDepartment: { __typename?: 'FireDepartment', id: string } };

export type ValidateFireDepartmentInputQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  data: FireDepartmentInput;
}>;


export type ValidateFireDepartmentInputQuery = { __typename?: 'Query', fireDepartmentInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type LepcFragmentFragment = { __typename?: 'Lepc', id: string, name: string, state?: string | null, city?: string | null, county?: string | null, zip?: string | null, mailingAddress?: string | null, mailingAddressLine2?: string | null, contactName?: string | null, email?: string | null, phone?: string | null, feeStructure?: string | null, latitude?: number | null, longitude?: number | null, leadAgency?: string | null, paymentMethod?: string | null, t2sValue?: string | null, submissionNotes?: string | null, requirementDetails?: string | null, additionalComments?: string | null, additionaRequirements?: string | null, additionalFees?: string | null, isEmailed: boolean, isCurrent1AsOf2021?: boolean | null, isMailed?: boolean | null, deactivated?: boolean | null, isStateSubmits?: boolean | null, needsT2sFile?: boolean | null, isSubmittedViaPortal?: boolean | null, needsXmlZipFile?: boolean | null, portalId?: string | null, portalName?: string | null, issues?: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> | null };

export type LepcSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
  tenantId?: InputMaybe<Scalars['String']>;
}>;


export type LepcSearchQuery = { __typename?: 'Query', lepcSearch: { __typename?: 'LepcResult', count?: number | null, items: Array<{ __typename?: 'Lepc', id: string, name: string, state?: string | null, city?: string | null, county?: string | null, zip?: string | null, mailingAddress?: string | null, mailingAddressLine2?: string | null, contactName?: string | null, email?: string | null, phone?: string | null, feeStructure?: string | null, latitude?: number | null, longitude?: number | null, leadAgency?: string | null, paymentMethod?: string | null, t2sValue?: string | null, submissionNotes?: string | null, requirementDetails?: string | null, additionalComments?: string | null, additionaRequirements?: string | null, additionalFees?: string | null, isEmailed: boolean, isCurrent1AsOf2021?: boolean | null, isMailed?: boolean | null, deactivated?: boolean | null, isStateSubmits?: boolean | null, needsT2sFile?: boolean | null, isSubmittedViaPortal?: boolean | null, needsXmlZipFile?: boolean | null, portalId?: string | null, portalName?: string | null, issues?: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> | null }> } };

export type LepcQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type LepcQuery = { __typename?: 'Query', lepc: { __typename?: 'Lepc', id: string, name: string, state?: string | null, city?: string | null, county?: string | null, zip?: string | null, mailingAddress?: string | null, mailingAddressLine2?: string | null, contactName?: string | null, email?: string | null, phone?: string | null, feeStructure?: string | null, latitude?: number | null, longitude?: number | null, leadAgency?: string | null, paymentMethod?: string | null, t2sValue?: string | null, submissionNotes?: string | null, requirementDetails?: string | null, additionalComments?: string | null, additionaRequirements?: string | null, additionalFees?: string | null, isEmailed: boolean, isCurrent1AsOf2021?: boolean | null, isMailed?: boolean | null, deactivated?: boolean | null, isStateSubmits?: boolean | null, needsT2sFile?: boolean | null, isSubmittedViaPortal?: boolean | null, needsXmlZipFile?: boolean | null, portalId?: string | null, portalName?: string | null, issues?: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> | null } };

export type UpsertLepcMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  input: LepcInput;
}>;


export type UpsertLepcMutation = { __typename?: 'Mutation', upsertLepc: { __typename?: 'Lepc', id: string, name: string, state?: string | null, city?: string | null, county?: string | null, zip?: string | null, mailingAddress?: string | null, mailingAddressLine2?: string | null, contactName?: string | null, email?: string | null, phone?: string | null, feeStructure?: string | null, latitude?: number | null, longitude?: number | null, leadAgency?: string | null, paymentMethod?: string | null, t2sValue?: string | null, submissionNotes?: string | null, requirementDetails?: string | null, additionalComments?: string | null, additionaRequirements?: string | null, additionalFees?: string | null, isEmailed: boolean, isCurrent1AsOf2021?: boolean | null, isMailed?: boolean | null, deactivated?: boolean | null, isStateSubmits?: boolean | null, needsT2sFile?: boolean | null, isSubmittedViaPortal?: boolean | null, needsXmlZipFile?: boolean | null, portalId?: string | null, portalName?: string | null, issues?: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> | null } };

export type DeleteLepcMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteLepcMutation = { __typename?: 'Mutation', deleteLepc: { __typename?: 'Lepc', id: string } };

export type ValidateLepcInputQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  data: LepcInput;
}>;


export type ValidateLepcInputQuery = { __typename?: 'Query', lepcInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type ValidateLeadAgencylInputQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  data: LeadAgencyInput;
}>;


export type ValidateLeadAgencylInputQuery = { __typename?: 'Query', leadAgencyInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type LeadAgenciesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
  tenantId?: InputMaybe<Scalars['String']>;
}>;


export type LeadAgenciesQuery = { __typename?: 'Query', leadAgencies: { __typename?: 'leadAgencyResult', count: number, items: Array<{ __typename?: 'LeadAgency', id: number, address: string, name: string, attn: string, city: string, consolidated: string, phone: string, state: string, zip: string, email?: string | null }> } };

export type LeadAgencyQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LeadAgencyQuery = { __typename?: 'Query', leadAgency: { __typename?: 'LeadAgency', id: number, address: string, name: string, attn: string, city: string, consolidated: string, phone: string, state: string, zip: string, email?: string | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> } };

export type UpsertLeadAgencyMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  input: LeadAgencyInput;
}>;


export type UpsertLeadAgencyMutation = { __typename?: 'Mutation', upsertLeadAgency: { __typename?: 'LeadAgency', id: number, address: string, name: string, attn: string, city: string, consolidated: string, phone: string, state: string, zip: string, email?: string | null } };

export type DeleteLeadAgencyMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteLeadAgencyMutation = { __typename?: 'Mutation', deleteLeadAgency: { __typename?: 'LeadAgency', id: number } };

export type ValidatePoliceDepartmentInputQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  data: PoliceDepartmentForValidation;
}>;


export type ValidatePoliceDepartmentInputQuery = { __typename?: 'Query', policeDepartmentInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type PoliceDepartmentsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
  tenantId?: InputMaybe<Scalars['String']>;
}>;


export type PoliceDepartmentsQuery = { __typename?: 'Query', policeDepartments: { __typename?: 'PoliceDepartmentResult', count: number, items: Array<{ __typename?: 'PoliceDepartment', id: number, address: string, name: string, additionalComments?: string | null, attn?: string | null, city: string, state?: string | null, zip?: string | null, email?: string | null, contactName?: string | null }> } };

export type PoliceDepartmentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type PoliceDepartmentQuery = { __typename?: 'Query', policeDepartment: { __typename?: 'PoliceDepartment', id: number, address: string, name: string, additionalComments?: string | null, attn?: string | null, city: string, state?: string | null, zip?: string | null, email?: string | null, contactName?: string | null, issues: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> } };

export type UpsertPoliceDepartmentMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  input: PoliceDepartmentInput;
}>;


export type UpsertPoliceDepartmentMutation = { __typename?: 'Mutation', upsertPoliceDepartment: { __typename?: 'PoliceDepartment', id: number, address: string, name: string, additionalComments?: string | null, attn?: string | null, city: string, state?: string | null, zip?: string | null, email?: string | null, contactName?: string | null } };

export type DeletePoliceDepartmentMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeletePoliceDepartmentMutation = { __typename?: 'Mutation', deletePoliceDepartment: { __typename?: 'PoliceDepartment', id: number } };

export type DemoAccountCandidateSearchQueryVariables = Exact<{
  input: DemoOrganizationInput;
}>;


export type DemoAccountCandidateSearchQuery = { __typename?: 'Query', demoAccountCandidates: { __typename?: 'DemoAccountCandidateSearchResult', count: number, items: Array<{ __typename?: 'DemoAccountCandidate', registryId?: string | null, rcraIds?: Array<string | null> | null, naics?: Array<string | null> | null, name?: string | null, streetAddress?: string | null, city?: string | null, zip?: string | null, state?: string | null, county?: string | null, latitude?: number | null, longitude?: number | null, emails?: Array<string | null> | null, ownerName?: string | null, operatorName?: string | null }> } };

export type CreateDemoOrganizationMutationVariables = Exact<{
  input: DemoOrganizationInput;
}>;


export type CreateDemoOrganizationMutation = { __typename?: 'Mutation', createDemoOrganization: boolean };

export type ManageTagsMutationVariables = Exact<{
  tierIIReportIds: Array<Scalars['ID']> | Scalars['ID'];
  action: ManageTagsAction;
  tags: Array<Scalars['String']> | Scalars['String'];
}>;


export type ManageTagsMutation = { __typename?: 'Mutation', manageTierIIReportsTags: Array<{ __typename?: 'TierIIReport', id: string, tags?: Array<string> | null }> };

export type BulkVerifyMutationVariables = Exact<{
  reportIds: Array<Scalars['ID']> | Scalars['ID'];
  verifier: TierIiReportVerifierInput;
}>;


export type BulkVerifyMutation = { __typename?: 'Mutation', bulkVerifyAndSubmitReports: { __typename?: 'BulkVerifyAndSubmitReportsResult', succeeded: boolean } };

export type UpdateFacilitiesMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  facility: FacilityInput;
}>;


export type UpdateFacilitiesMutation = { __typename?: 'Mutation', updateFacilities: Array<{ __typename?: 'Facility', id: string, name: string, companyName?: string | null, department?: string | null, isMailingAddressSameAsFacility?: boolean | null, isMailingAddressEncamp?: boolean | null, isUnmanned?: boolean | null, maxNumOccupants?: number | null, fireDepartmentId?: string | null, lepcId?: string | null, dbNumber?: string | null, naicsCode?: number | null, longitude?: number | null, latitude?: number | null, state?: string | null, county?: string | null, municipality?: string | null, phone?: string | null, phone24Hour?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, zip?: string | null, mailingStreetAddress1?: string | null, mailingStreetAddress2?: string | null, mailingCity?: string | null, mailingState?: string | null, mailingZip?: string | null, dateClosed?: any | null, dateOpened?: any | null, dateInactive?: any | null, status?: FacilityStatus | null, isSubjectToChemicalAccidentPrevention?: boolean | null, isSubjectToEmergencyPlanning?: boolean | null, isSubjectToToxicsReleaseInventoryReporting?: boolean | null, fireDepartment?: { __typename?: 'FireDepartment', id: string, name?: string | null, city?: string | null, state?: string | null, mailingAddress?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null } | null, lepc?: { __typename?: 'Lepc', id: string, name: string, mailingAddress?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, phone?: string | null, email?: string | null, isEmailed: boolean } | null, facilityAlternateIds?: Array<{ __typename?: 'AlternateId', id: string, type: string, value: string, expiresAt?: any | null, hasNoId: boolean }> | null, stateFields: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, tooltip?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }> }> };

export type ExportGridToCsvMutationVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type ExportGridToCsvMutation = { __typename?: 'Mutation', exportFulfillmentGridToCsv: { __typename?: 'ExportFulfillmentGridToCsvResult', success: boolean, errorMsg?: string | null, downloadUrl?: string | null } };

export type TierIiReportActivitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type TierIiReportActivitiesQuery = { __typename?: 'Query', tierIIReportActivities: { __typename?: 'TierIIReportActivitiesResult', count: number, items: Array<{ __typename?: 'TierIIReportActivity', id: string, tenantId: string, tierIIReportId?: string | null, reportingYear?: number | null, productCount?: number | null, organizationStatus?: string | null, encampStatus?: string | null, jobStatus?: JobStatus | null, reportKind?: string | null, state?: string | null, facilityName: string, customerFacilityId?: string | null, facilityId: string, organizationName: string, workflowId?: string | null, activityId?: string | null, activityType?: string | null, activityDescription?: string | null, activityAssigneeFirst?: string | null, activityAssigneeLast?: string | null, activityAssigneeEmail?: string | null, activityExecutionPlan?: string | null, activityStatus?: string | null, activityErrorMessage?: string | null, hasIncompleteReviews?: boolean | null, isChampionReport?: boolean | null, partnerTenant?: string | null, isValid?: boolean | null, lastValidatedTime?: any | null, tags?: Array<string> | null }> } };

export type SetValueOnActivityUserInputMutationVariables = Exact<{
  id: Scalars['ID'];
  value: Scalars['String'];
}>;


export type SetValueOnActivityUserInputMutation = { __typename?: 'Mutation', setValueOnActivityUserInput: { __typename?: 'ActivityUserInput', id: string, value?: string | null } };

export type RecordLobFeeMutationVariables = Exact<{
  input: RecordLobFeeInput;
}>;


export type RecordLobFeeMutation = { __typename?: 'Mutation', recordLobFee: { __typename?: 'Payment', id: string, payee?: string | null, paidAt: any, paymentMethod?: PaymentMethod | null, amount?: number | null, status: PaymentStatus, activityId?: string | null } };

export type WaitForAllCohortQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type WaitForAllCohortQuery = { __typename?: 'Query', tierIIReportActivities: { __typename?: 'TierIIReportActivitiesResult', count: number, items: Array<{ __typename?: 'TierIIReportActivity', id: string, tenantId: string, tierIIReportId?: string | null, reportingYear?: number | null, productCount?: number | null, organizationStatus?: string | null, encampStatus?: string | null, state?: string | null, facilityName: string, facilityId: string, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, zip?: string | null, customerFacilityId?: string | null, organizationName: string, workflowId?: string | null, activityId?: string | null, activityType?: string | null, activityDescription?: string | null, activityAssigneeFirst?: string | null, activityAssigneeLast?: string | null, activityAssigneeEmail?: string | null, activityExecutionPlan?: string | null, activityStatus?: string | null, hasIncompleteReviews?: boolean | null, isChampionReport?: boolean | null }> } };

export type ConductReportMutationVariables = Exact<{
  reportId: Scalars['ID'];
}>;


export type ConductReportMutation = { __typename?: 'Mutation', conductReport: boolean };

export type GenerateT2SMutationVariables = Exact<{
  reportId: Scalars['ID'];
}>;


export type GenerateT2SMutation = { __typename?: 'Mutation', generateT2S: string };

export type AssociatedTierIiReportsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type AssociatedTierIiReportsQuery = { __typename?: 'Query', tierIIReports: { __typename?: 'TierIIReportsResult', count: number, items: Array<{ __typename?: 'TierIIReport', id: string, reportingYear: number, reportKind: TierIiReportKind, facility: { __typename?: 'Facility', id: string, name: string, streetAddress1?: string | null, city?: string | null, state?: string | null, zip?: string | null }, tenant: { __typename?: 'Tenant', id: string, name: string } }> } };

export type AssociatedFacilitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type AssociatedFacilitiesQuery = { __typename?: 'Query', facilities: { __typename?: 'FacilitiesResult', count: number, items: Array<{ __typename?: 'Facility', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, state?: string | null, zip?: string | null, id: string, name: string, tenant?: { __typename?: 'Tenant', id: string, name: string } | null }> } };

export type ResetReportMutationVariables = Exact<{
  inputs: ResetReportInput;
}>;


export type ResetReportMutation = { __typename?: 'Mutation', resetReport: string };

export type ReportSafeToResetQueryVariables = Exact<{
  reportId: Scalars['ID'];
}>;


export type ReportSafeToResetQuery = { __typename?: 'Query', reportSafeToReset: { __typename?: 'ReportSafeToResetResponse', isSafeToReset: boolean, unsafeResetReasons: Array<string>, activities?: Array<{ __typename?: 'ActivitySafeToResetResponse', isSafeToReset: boolean, activity?: { __typename?: 'Activity', id: string, type: ActivityType } | null } | null> | null } };

export type UpdateReportTagsMutationVariables = Exact<{
  tierIIReportId: Scalars['ID'];
  input: TierIiReportUpdateInput;
}>;


export type UpdateReportTagsMutation = { __typename?: 'Mutation', updateTierIIReport: { __typename?: 'TierIIReport', id: string, tags?: Array<string> | null } };

export type PersonFragmentFragment = { __typename?: 'Person', id: string, first?: string | null, last?: string | null, email?: string | null, tenantId: string, title?: string | null, city?: string | null, state?: string | null, streetAddress1?: string | null, zip?: string | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null };

export type GetTierIiReportQueryVariables = Exact<{
  reportId: Scalars['ID'];
  version?: InputMaybe<Scalars['String']>;
}>;


export type GetTierIiReportQuery = { __typename?: 'Query', tierIIReport: { __typename?: 'TierIIReport', id: string, tenantId: string, reportingYear: number, reportKind: TierIiReportKind, productCount: number, organizationStatus: TierIiReportOrgStatus, encampStatus: TierIiReportEncampStatus, tags?: Array<string> | null, isVerified?: boolean | null, verifierFullName?: string | null, verifierTitle?: string | null, verifiedAt?: any | null, tenant: { __typename?: 'Tenant', id: string, name: string }, reviewers: Array<{ __typename?: 'TierIIReportAssignee', isComplete?: boolean | null }>, facility: { __typename?: 'Facility', id: string, name: string, county?: string | null, companyName?: string | null, naicsCode?: number | null, customerFacilityId?: string | null, reportsManually?: boolean | null, city?: string | null, state?: string | null, streetAddress1?: string | null, zip?: string | null, stateFields: Array<{ __typename?: 'DynamicField', key: string, value?: any | null, type?: ProgramArea | null, jurisdiction: string, inputType: DynamicFieldType, label: string, tooltip?: string | null, selectOptions?: Array<{ __typename?: 'DynamicFieldOption', label: string, value: any }> | null }>, portalCredential?: { __typename?: 'PortalCredential', type?: PortalType | null, url?: string | null, credential?: { __typename?: 'Credential', id: string, isEncampOwned: boolean, kind: CredentialKind, password: string, username: string, lastVerificationCheckAt?: any | null, lastVerificationSuccessAt?: any | null, verificationStatus: CredentialVerificationStatus, tenantId: string } | null } | null, jobs?: Array<{ __typename?: 'Job', id: string, action?: WebAutomationAction | null, status: JobStatus, createdAt: any, logs: Array<{ __typename?: 'JobLog', id: string, jobId?: string | null, createdAt: any, status: JobStatus, errorMessage?: string | null, cloudWatchLogStream?: string | null, screenshotKey?: string | null, screenshotUrl?: string | null, updatedAt: any }>, stepsDone: Array<{ __typename?: 'JobStepsDone', id: string, jobId: string, name?: string | null, createdAt: any, updatedAt: any }> }> | null, contacts?: Array<{ __typename?: 'FacilityContact', id: string, reportingRoles: Array<ContactReportRole>, person: { __typename?: 'Person', id: string, first?: string | null, last?: string | null, email?: string | null, tenantId: string, title?: string | null, city?: string | null, state?: string | null, streetAddress1?: string | null, zip?: string | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null } }> | null, facilityAlternateIds?: Array<{ __typename?: 'AlternateId', id: string, type: string, value: string }> | null, lepc?: { __typename?: 'Lepc', id: string, name: string, email?: string | null, mailingAddress?: string | null, mailingAddressLine2?: string | null, city?: string | null, state?: string | null, county?: string | null, zip?: string | null, isEmailed: boolean, isMailed?: boolean | null, phone?: string | null, additionalComments?: string | null, needsT2sFile?: boolean | null, isStateSubmits?: boolean | null } | null, fireDepartment?: { __typename?: 'FireDepartment', id: string, fireDeptId?: string | null, name?: string | null, email?: string | null, mailingAddress?: string | null, mailingAddressLine2?: string | null, city?: string | null, state?: string | null, county?: string | null, zip?: string | null, isMailed?: boolean | null, isEmailed?: boolean | null, phone?: string | null, phoneExt?: string | null, additionalComments?: string | null, stateSubmitsToFireDept?: boolean | null, needsT2sFile?: boolean | null } | null }, currentWorkflow?: { __typename?: 'Workflow', id: string, currentActivityId?: string | null, activities: Array<{ __typename?: 'Activity', id: string, type: ActivityType, status: ActivityStatus, executionPlan: ExecutionPlanType, description?: string | null, championId?: string | null, nonChampionIds?: Array<string> | null, cohortFacilityIds?: Array<string> | null, reportDetailsExtended?: any | null, inputs?: Array<{ __typename?: 'ActivityUserInput', id: string, activityId: string, label: string, shortName: string, value?: string | null, required: boolean, type: ActivityUserInputType } | null> | null, documents?: Array<{ __typename?: 'ActivityDocument', document: { __typename?: 'Document', id: string, title: string, description?: string | null, storageLink: string, documentType: DocumentType, updatedAt?: any | null, createdAt?: any | null } }> | null, logs?: Array<{ __typename?: 'ActivityLog', id: string, activityId: string, status: ActivityStatus, errorType?: string | null, message?: string | null, time?: any | null }> | null, job?: { __typename?: 'Job', id: string, status: JobStatus, action?: WebAutomationAction | null } | null, payments?: Array<{ __typename?: 'Payment', id: string, status: PaymentStatus, paidAt: any, tenantId: string, amount?: number | null, lobMail?: { __typename?: 'LobMail', id: string, lobId: string, status?: LobMailStatus | null, type: LobMailType } | null }> | null }>, currentActivity?: { __typename?: 'Activity', id: string, type: ActivityType, status: ActivityStatus, executionPlan: ExecutionPlanType, description?: string | null, assigneeId?: string | null, jobId?: string | null, job?: { __typename?: 'Job', id: string, taskArn?: string | null, taskUrl?: string | null } | null, assignee?: { __typename?: 'User', id: string, email: string, person?: { __typename?: 'Person', first?: string | null, last?: string | null } | null } | null, logs?: Array<{ __typename?: 'ActivityLog', id: string, activityId: string, status: ActivityStatus, errorType?: string | null, message?: string | null, time?: any | null }> | null, documents?: Array<{ __typename?: 'ActivityDocument', document: { __typename?: 'Document', id: string, title: string, description?: string | null, storageLink: string, documentType: DocumentType, updatedAt?: any | null, createdAt?: any | null } }> | null } | null } | null, documents?: Array<{ __typename?: 'Document', id: string, title: string, description?: string | null, storageLink: string, documentType: DocumentType, updatedAt?: any | null, createdAt?: any | null, activities?: Array<{ __typename?: 'Activity', id: string, type: ActivityType, description?: string | null }> | null }> | null, verifier?: { __typename?: 'Person', id: string, first?: string | null, last?: string | null, email?: string | null, tenantId: string, title?: string | null, city?: string | null, state?: string | null, streetAddress1?: string | null, zip?: string | null, phones?: Array<{ __typename?: 'Phone', number?: string | null, type: PhoneType }> | null } | null, comments?: Array<{ __typename?: 'Comment', id: string, reportId?: string | null, userId?: string | null, workflowId?: string | null, activityId?: string | null, comment: string, updatedAt: any, user?: { __typename?: 'User', id: string, email: string } | null }> | null, payments?: Array<{ __typename?: 'Payment', id: string, payee?: string | null, paidAt: any, paymentMethod?: PaymentMethod | null, amount?: number | null, payeeType?: Payee | null, activityId?: string | null, status: PaymentStatus, tenantId: string, lobMail?: { __typename?: 'LobMail', id: string, lobId: string, status?: LobMailStatus | null, type: LobMailType } | null }> | null } };

export type ReportingSeasonSummaryQueryVariables = Exact<{
  year: Scalars['Int'];
}>;


export type ReportingSeasonSummaryQuery = { __typename?: 'Query', reportingSeasonSummary: { __typename?: 'ReportingSeasonSummary', year: number, noReportsTotal: number, facilitiesTotal: number, reportsInFilingComplete: number, reportsInAwaitingVerification: number, reportsInNotReporting: number, reportsInProcessing: number, reportsUnverified: number, reportsTotal: number, workflowsCountHuman: number, workflowsCountError: number, workflowsCountWaitForAll: number, stateSummaries: Array<{ __typename?: 'UnverifiedSummary', id: string, name: string, unverifiedCount: number, reportCount: number }>, organizationSummaries: Array<{ __typename?: 'UnverifiedSummary', id: string, name: string, unverifiedCount: number, reportCount: number }>, staffSummaries: Array<{ __typename?: 'StaffSummary', id: string, name: string, reportCount: number, completedCount: number }> } };

export type SetCollectionModesMutationVariables = Exact<{
  facilityIds: Array<Scalars['ID']> | Scalars['ID'];
  collectionMode?: InputMaybe<CollectionMode>;
}>;


export type SetCollectionModesMutation = { __typename?: 'Mutation', setCollectionMode?: { __typename?: 'SetCollectionModeResult', succeeded?: boolean | null } | null };

export type ExtractionsWebAutomationJobsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type ExtractionsWebAutomationJobsQuery = { __typename?: 'Query', webAutomationJobs: { __typename?: 'WebAutomationJobsResult', count: number, items: Array<{ __typename?: 'WebAutomationJobWithPromotionJob', id: string, action?: WebAutomationAction | null, reportingYear?: number | null, status?: JobStatus | null, stateOrTerritory?: string | null, tenantId: string, facilityId?: string | null, reportId?: string | null, createdAt: any, updatedAt: any, promotedAt?: any | null, promotionJobId?: string | null, promotionJobStatus?: JobStatus | null, promotionJobUpdatedAt?: any | null, facility?: { __typename?: 'Facility', name: string, customerFacilityId?: string | null } | null, tenant?: { __typename?: 'Tenant', name: string } | null }> } };

export type ExtractionsJobQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ExtractionsJobQuery = { __typename?: 'Query', webAutomationJob: { __typename?: 'WebAutomationJobWithPromotionJob', id: string, action?: WebAutomationAction | null, reportingYear?: number | null, status?: JobStatus | null, stateOrTerritory?: string | null, tenantId: string, facilityId?: string | null, reportId?: string | null, extractionKey?: string | null, extraction?: any | null, createdAt: any, updatedAt: any, promotedAt?: any | null, promotionJobId?: string | null, promotionJobStatus?: JobStatus | null, promotionJobUpdatedAt?: any | null, facility?: { __typename?: 'Facility', name: string, customerFacilityId?: string | null } | null, tenant?: { __typename?: 'Tenant', name: string } | null } };

export type UpdateWebAutomationJobsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  input: UpdateWebAutomationJobInput;
}>;


export type UpdateWebAutomationJobsMutation = { __typename?: 'Mutation', updateWebAutomationJobs?: { __typename?: 'WebAutomationJobResult', count: number } | null };

export type PromoteDraftReportMutationVariables = Exact<{
  webAutomationJobId: Scalars['ID'];
}>;


export type PromoteDraftReportMutation = { __typename?: 'Mutation', promoteDraftReport?: boolean | null };

export type JobLogsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type JobLogsQuery = { __typename?: 'Query', webAutomationJob: { __typename?: 'WebAutomationJobWithPromotionJob', id: string, status?: JobStatus | null, createdAt: any, updatedAt: any, logs: Array<{ __typename?: 'JobLog', id: string, jobId?: string | null, status: JobStatus, createdAt: any, updatedAt: any, errorMessage?: string | null }> } };

export type ImportT2sFileMutationVariables = Exact<{
  input: T2sImportInput;
}>;


export type ImportT2sFileMutation = { __typename?: 'Mutation', importT2sFile: Array<{ __typename?: 'Job', id: string }> };

export type T2sImportDialogFacilitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type T2sImportDialogFacilitiesQuery = { __typename?: 'Query', facilities: { __typename?: 'FacilitiesResult', count: number, items: Array<{ __typename?: 'Facility', id: string, name: string, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, state?: string | null, zip?: string | null }> } };

export type T2sReadT2sFileQueryVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type T2sReadT2sFileQuery = { __typename?: 'Query', readT2sFile: { __typename?: 'ReadT2sFileResponse', reportingYear: number, facilities: Array<{ __typename?: 'T2sReadFacility', name: string, city?: string | null, state?: string | null, chemicals: number, contacts: number }> } };

export type CopyChemicalInventoryForAllFacilitiesInTenantMutationVariables = Exact<{
  facilityIds: Array<Scalars['ID']> | Scalars['ID'];
  toYear: Scalars['Int'];
}>;


export type CopyChemicalInventoryForAllFacilitiesInTenantMutation = { __typename?: 'Mutation', copyFacilityInventoryForFacilities: { __typename?: 'BulkCopyInventoryResult', succeeded: Array<{ __typename?: 'CopyFacilityInventoryResult', facilityId: string }>, skipped: Array<{ __typename?: 'CopyFacilityInventoryResult', facilityId: string, reason?: string | null }>, failed: Array<{ __typename?: 'CopyFacilityInventoryResult', facilityId: string, reason?: string | null }> } };

export type ImplementationFacilitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type ImplementationFacilitiesQuery = { __typename?: 'Query', facilities: { __typename?: 'FacilitiesResult', count: number, items: Array<{ __typename?: 'Facility', id: string, customerFacilityId?: string | null, name: string, state?: string | null, collectionMode?: CollectionMode | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, zip?: string | null, country?: string | null, issueCount?: number | null, updatedAt?: any | null, createdAt?: any | null, portalCredential?: { __typename?: 'PortalCredential', credential?: { __typename?: 'Credential', username: string } | null } | null, tenant?: { __typename?: 'Tenant', id: string, name: string } | null, jobs?: Array<{ __typename?: 'Job', id: string, action?: WebAutomationAction | null, status: JobStatus, reportingYear?: number | null, requestId?: string | null, facilityId?: string | null, reportId?: string | null, createdAt: any, updatedAt: any }> | null, facilityAlternateIds?: Array<{ __typename?: 'AlternateId', id: string, type: string, value: string, hasNoId: boolean, expiresAt?: any | null }> | null, facilityCredentials?: Array<{ __typename?: 'FacilityCredential', credential: { __typename?: 'Credential', verificationStatus: CredentialVerificationStatus, lastVerificationCheckAt?: any | null, kind: CredentialKind } }> | null }> } };

export type DeleteFacilityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFacilityMutation = { __typename?: 'Mutation', deleteFacility: { __typename?: 'Facility', id: string } };

export type GenerateCandidatesMutationVariables = Exact<{
  input: GenerateInsightsCandidatesInput;
}>;


export type GenerateCandidatesMutation = { __typename?: 'Mutation', generateInsightsCandidates: boolean };

export type FacilitiesWithInsightsCandidatesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type FacilitiesWithInsightsCandidatesQuery = { __typename?: 'Query', facilitiesWithInsightsCandidates: { __typename?: 'FacilitiesResult', count: number, items: Array<{ __typename?: 'Facility', id: string, name: string, state?: string | null, latitude?: number | null, longitude?: number | null, streetAddress1?: string | null, city?: string | null, zip?: string | null, naicsCode?: number | null, tenant?: { __typename?: 'Tenant', id: string, name: string } | null, facilityAlternateIds?: Array<{ __typename?: 'AlternateId', type: string, value: string }> | null, echoFacilityMatchCandidates?: Array<{ __typename?: 'InsightsCandidate', matchScore?: number | null, id: string, echoExporter: { __typename?: 'SelectedEchoExporterFields', registryId: string, facName?: string | null, facCity?: string | null, facStreet?: string | null, facNaicsCodes: Array<string>, facActiveFlag?: boolean | null, facState?: string | null, facZip?: string | null, facLat?: number | null, facLong?: number | null, dfrUrl?: string | null, npdesIds: Array<string>, rcraIds: Array<string> } }> | null }> } };

export type LinkMatchesMutationVariables = Exact<{
  input: LinkFacilitiesInput;
}>;


export type LinkMatchesMutation = { __typename?: 'Mutation', linkFacilities: boolean };

export type GenerateCandidatesFromAlternateIdsMutationVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type GenerateCandidatesFromAlternateIdsMutation = { __typename?: 'Mutation', generateInsightsCandidatesFromAlternateIds: { __typename?: 'InsightsCandidatesResult', count: number, items: Array<{ __typename?: 'InsightsCandidate', id: string }> } };

export type DeleteCandidatesMutationVariables = Exact<{
  input: DeleteCandidatesInput;
}>;


export type DeleteCandidatesMutation = { __typename?: 'Mutation', deleteCandidates: boolean };

export type StaffReportJobFragmentFragment = { __typename?: 'Job', id: string, status: JobStatus, updatedAt: any, totalIssues?: number | null, staffReportKey?: string | null, parameters?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string } | null };

export type StaffReportJobsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type StaffReportJobsQuery = { __typename?: 'Query', jobs: { __typename?: 'JobsResult', count: number, items: Array<{ __typename?: 'Job', id: string, status: JobStatus, updatedAt: any, totalIssues?: number | null, staffReportKey?: string | null, parameters?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string } | null }> } };

export type GetStaffReportDownloadLinkQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetStaffReportDownloadLinkQuery = { __typename?: 'Query', job: { __typename?: 'Job', staffReportDownloadLink?: string | null } };

export type GenerateStaffReportMutationVariables = Exact<{
  reportType: StaffReportType;
  reportingYear: Scalars['Int'];
  tenantId?: InputMaybe<Scalars['String']>;
}>;


export type GenerateStaffReportMutation = { __typename?: 'Mutation', generateStaffReport: { __typename?: 'Job', id: string, status: JobStatus, updatedAt: any, totalIssues?: number | null, staffReportKey?: string | null, parameters?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string } | null } };

export type ImplementationsOrganizationDetailQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type ImplementationsOrganizationDetailQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', id: string, name: string, featureFlags: any, facilityCount?: number | null, contactCount?: number | null } };

export type UpsertTenantMutationVariables = Exact<{
  input: TenantInput;
}>;


export type UpsertTenantMutation = { __typename?: 'Mutation', upsertTenant: { __typename?: 'Tenant', id: string, name: string, isDisabled: boolean, isDemo: boolean, isPartner: boolean, partnerTenantId?: string | null } };

export type UpdateTenantMutationVariables = Exact<{
  input: TenantInput;
}>;


export type UpdateTenantMutation = { __typename?: 'Mutation', upsertTenant: { __typename?: 'Tenant', id: string, isDisabled: boolean } };

export type TenantsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type TenantsQuery = { __typename?: 'Query', tenants: { __typename?: 'TenantsResult', count: number, items: Array<{ __typename?: 'Tenant', id: string, name: string, isDisabled: boolean, isDemo: boolean, isPartner: boolean, accountType: AccountType, partnerTenant?: { __typename?: 'Tenant', id: string, name: string } | null }> } };

export type ValidateTenantInputQueryVariables = Exact<{
  input: TenantInput;
}>;


export type ValidateTenantInputQuery = { __typename?: 'Query', tenantInputValidator: Array<{ __typename?: 'Issue', level: IssueLevel, message: string, key?: string | null, modelId?: string | null, modelName: string, metadata?: any | null, jurisdictions?: Array<string> | null, schemaPath?: string | null }> };

export type JobFragmentFragment = { __typename?: 'Job', id: string, task?: JobTask | null, status: JobStatus, parameters?: any | null, createdAt: any, createdBy: string, updatedAt: any, updatedBy: string, tenant?: { __typename?: 'Tenant', id: string, name: string } | null, document?: { __typename?: 'Document', id: string, title: string } | null };

export type StaffJobDialogQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StaffJobDialogQuery = { __typename?: 'Query', job: { __typename?: 'Job', id: string, task?: JobTask | null, status: JobStatus, parameters?: any | null, createdAt: any, createdBy: string, updatedAt: any, updatedBy: string, tenant?: { __typename?: 'Tenant', id: string, name: string } | null, document?: { __typename?: 'Document', id: string, title: string } | null } };

export type StaffJobsTableQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type StaffJobsTableQuery = { __typename?: 'Query', jobs: { __typename?: 'JobsResult', count: number, items: Array<{ __typename?: 'Job', id: string, task?: JobTask | null, status: JobStatus, parameters?: any | null, createdAt: any, createdBy: string, updatedAt: any, updatedBy: string, tenant?: { __typename?: 'Tenant', id: string, name: string } | null, document?: { __typename?: 'Document', id: string, title: string } | null }> } };

export type StaffJobStepsDoneTableQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type StaffJobStepsDoneTableQuery = { __typename?: 'Query', jobStepsDone: { __typename?: 'JobStepsDoneResult', count: number, items: Array<{ __typename?: 'JobStepsDone', id: string, jobId: string, name?: string | null, updatedAt: any, createdAt: any }> } };

export type StaffJobLogsTableQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type StaffJobLogsTableQuery = { __typename?: 'Query', jobLogs: { __typename?: 'JobLogsResult', count: number, items: Array<{ __typename?: 'JobLog', id: string, status: JobStatus, createdAt: any, errorMessage?: string | null, updatedAt: any }> } };

export type TierIiReportActivitiesInErrorQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel> | SortModel>;
}>;


export type TierIiReportActivitiesInErrorQuery = { __typename?: 'Query', tierIIReportActivitiesInError: { __typename?: 'TierIIReportActivitiesResult', count: number, items: Array<{ __typename?: 'TierIIReportActivity', id: string, tierIIReportId?: string | null, reportingYear?: number | null, productCount?: number | null, organizationStatus?: string | null, encampStatus?: string | null, state?: string | null, facilityName: string, organizationName: string, workflowId?: string | null, activityId?: string | null, activityType?: string | null, activityDescription?: string | null, activityAssigneeEmail?: string | null, activityAssigneeFirst?: string | null, activityAssigneeLast?: string | null, activityExecutionPlan?: string | null, activityStatus?: string | null, activityErrorMessage?: string | null }> } };

export type SubmissionErrorStatsQueryVariables = Exact<{
  year: Scalars['Int'];
}>;


export type SubmissionErrorStatsQuery = { __typename?: 'Query', submissionErrorStats: { __typename?: 'SubmissionErrorStatsResult', reportsCurrentlyBlockedByErrors: number, errorsByAssignee: Array<{ __typename?: 'SubmissionErrorStatsResultItem', name?: string | null, val: number }>, errorsByCustomer: Array<{ __typename?: 'SubmissionErrorStatsResultItem', name?: string | null, val: number }>, errorsByState: Array<{ __typename?: 'SubmissionErrorStatsResultItem', name?: string | null, val: number }> } };

export type WorkflowManagerConfigQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkflowManagerConfigQueryQuery = { __typename?: 'Query', workflowManagerConfigs: { __typename?: 'WorkflowManagerConfigResult', items: Array<{ __typename?: 'WorkflowManagerConfig', id: string, type: WorkflowManagerConfigType, value: string, updatedAt: any, updatedBy: string }> } };

export type GeneratePresignedUrlMutationVariables = Exact<{
  fileName: Scalars['String'];
  tenantId: Scalars['ID'];
  facilityId?: InputMaybe<Scalars['ID']>;
}>;


export type GeneratePresignedUrlMutation = { __typename?: 'Mutation', generatePresignedUrl: { __typename?: 'GeneratePresignedUrlResult', key: string, presignedUrl: string } };

export type DocumentFragmentFragment = { __typename?: 'Document', id: string, title: string, description?: string | null, storageLink: string, documentType: DocumentType, updatedAt?: any | null, createdAt?: any | null, fileExtension?: string | null, facilities?: Array<{ __typename?: 'Facility', id: string, name: string }> | null };
